import * as is from "react";
import rn, { useEffect as ke, useState as Z, createContext as Vr, useContext as Kr, useCallback as Bt, useMemo as Dn, useRef as Zt, Fragment as Hu } from "react";
import Be from "@mui/material/Box";
import Zu from "@mui/material/Avatar";
import Wu from "@mui/material/Menu";
import Er from "@mui/material/MenuItem";
import Es from "@mui/material/ListItemIcon";
import Ju from "@mui/material/Divider";
import Gu from "@mui/material/IconButton";
import oa from "@mui/material/Tooltip";
import Vu from "@mui/icons-material/Person";
import Ku from "@mui/material/AppBar";
import Yu from "@mui/material/Toolbar";
import { Box as de, CircularProgress as Jn, Typography as Xe, Button as Ze, Breadcrumbs as Xu, CardActionArea as Qu, Card as Tr, CardContent as Cr, Stack as ln, Chip as aa, IconButton as jr, TextField as Fn, FormControlLabel as ua, Checkbox as ca, Link as Ci, Alert as $n, List as ec, ListItemButton as tc, ListItemText as nc, MenuItem as rc, Table as sc, TableHead as ic, TableRow as ji, TableCell as Lt, TableBody as oc, Divider as ac, Dialog as cr, DialogTitle as os, DialogContent as lr, DialogActions as Ts, Snackbar as uc } from "@mui/material";
import { AuthProvider as cc, useAuth as Vt } from "react-oidc-context";
import { Delete as lc, ArrowBack as dc, Add as fc, People as hc, Edit as pc } from "@mui/icons-material";
import kr from "@mui/material/Skeleton";
import Pr from "@mui/material/Stack";
import { ThemeProvider as mc, styled as Xs, useColorScheme as la } from "@mui/material/styles";
import gc from "@mui/material/CssBaseline";
import vc from "@mui/material/List";
import yc from "@mui/material/ListItem";
import bc from "@mui/material/ListItemText";
import da from "@mui/icons-material/Home";
import fa from "@mui/icons-material/Settings";
import { Navigate as ha, useLocation as wc } from "react-router-dom";
import Bn from "@mui/material/Typography";
import pa from "@mui/material/Select";
import xc from "@mui/icons-material/Event";
import ma from "@mui/material/Chip";
import Sc from "@mui/icons-material/Business";
import Rc from "@mui/icons-material/AdminPanelSettings";
import ga from "@mui/icons-material/Brightness4";
import va from "@mui/icons-material/Brightness7";
import ya from "@mui/icons-material/Logout";
import { colors as _c, Logo as Oc } from "brand";
import Ec from "@mui/icons-material/DeleteOutline";
import Tc from "@mui/icons-material/Lock";
import Cc from "axios";
var Cs = { exports: {} }, Sn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ki;
function jc() {
  if (ki) return Sn;
  ki = 1;
  var t = rn, e = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(a, u, c) {
    var l, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), u.key !== void 0 && (f = "" + u.key), u.ref !== void 0 && (h = u.ref);
    for (l in u) r.call(u, l) && !i.hasOwnProperty(l) && (d[l] = u[l]);
    if (a && a.defaultProps) for (l in u = a.defaultProps, u) d[l] === void 0 && (d[l] = u[l]);
    return { $$typeof: e, type: a, key: f, ref: h, props: d, _owner: s.current };
  }
  return Sn.Fragment = n, Sn.jsx = o, Sn.jsxs = o, Sn;
}
var Rn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Pi;
function kc() {
  return Pi || (Pi = 1, process.env.NODE_ENV !== "production" && function() {
    var t = rn, e = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), l = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), v = Symbol.iterator, p = "@@iterator";
    function _(g) {
      if (g === null || typeof g != "object")
        return null;
      var O = v && g[v] || g[p];
      return typeof O == "function" ? O : null;
    }
    var K = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function T(g) {
      {
        for (var O = arguments.length, j = new Array(O > 1 ? O - 1 : 0), W = 1; W < O; W++)
          j[W - 1] = arguments[W];
        V("error", g, j);
      }
    }
    function V(g, O, j) {
      {
        var W = K.ReactDebugCurrentFrame, le = W.getStackAddendum();
        le !== "" && (O += "%s", j = j.concat([le]));
        var me = j.map(function(oe) {
          return String(oe);
        });
        me.unshift("Warning: " + O), Function.prototype.apply.call(console[g], console, me);
      }
    }
    var M = !1, ie = !1, Q = !1, De = !1, Ee = !1, Ye;
    Ye = Symbol.for("react.module.reference");
    function at(g) {
      return !!(typeof g == "string" || typeof g == "function" || g === r || g === i || Ee || g === s || g === c || g === l || De || g === h || M || ie || Q || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === o || g.$$typeof === a || g.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      g.$$typeof === Ye || g.getModuleId !== void 0));
    }
    function he(g, O, j) {
      var W = g.displayName;
      if (W)
        return W;
      var le = O.displayName || O.name || "";
      return le !== "" ? j + "(" + le + ")" : j;
    }
    function Fe(g) {
      return g.displayName || "Context";
    }
    function fe(g) {
      if (g == null)
        return null;
      if (typeof g.tag == "number" && T("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof g == "function")
        return g.displayName || g.name || null;
      if (typeof g == "string")
        return g;
      switch (g) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case s:
          return "StrictMode";
        case c:
          return "Suspense";
        case l:
          return "SuspenseList";
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case a:
            var O = g;
            return Fe(O) + ".Consumer";
          case o:
            var j = g;
            return Fe(j._context) + ".Provider";
          case u:
            return he(g, g.render, "ForwardRef");
          case d:
            var W = g.displayName || null;
            return W !== null ? W : fe(g.type) || "Memo";
          case f: {
            var le = g, me = le._payload, oe = le._init;
            try {
              return fe(oe(me));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ae = Object.assign, ce = 0, Qe, je, vt, Tt, _e, Oe, $e;
    function Y() {
    }
    Y.__reactDisabledLog = !0;
    function pe() {
      {
        if (ce === 0) {
          Qe = console.log, je = console.info, vt = console.warn, Tt = console.error, _e = console.group, Oe = console.groupCollapsed, $e = console.groupEnd;
          var g = {
            configurable: !0,
            enumerable: !0,
            value: Y,
            writable: !0
          };
          Object.defineProperties(console, {
            info: g,
            log: g,
            warn: g,
            error: g,
            group: g,
            groupCollapsed: g,
            groupEnd: g
          });
        }
        ce++;
      }
    }
    function Me() {
      {
        if (ce--, ce === 0) {
          var g = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ae({}, g, {
              value: Qe
            }),
            info: ae({}, g, {
              value: je
            }),
            warn: ae({}, g, {
              value: vt
            }),
            error: ae({}, g, {
              value: Tt
            }),
            group: ae({}, g, {
              value: _e
            }),
            groupCollapsed: ae({}, g, {
              value: Oe
            }),
            groupEnd: ae({}, g, {
              value: $e
            })
          });
        }
        ce < 0 && T("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ut = K.ReactCurrentDispatcher, Ct;
    function Mt(g, O, j) {
      {
        if (Ct === void 0)
          try {
            throw Error();
          } catch (le) {
            var W = le.stack.trim().match(/\n( *(at )?)/);
            Ct = W && W[1] || "";
          }
        return `
` + Ct + g;
      }
    }
    var ct = !1, jt;
    {
      var Qr = typeof WeakMap == "function" ? WeakMap : Map;
      jt = new Qr();
    }
    function hi(g, O) {
      if (!g || ct)
        return "";
      {
        var j = jt.get(g);
        if (j !== void 0)
          return j;
      }
      var W;
      ct = !0;
      var le = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var me;
      me = ut.current, ut.current = null, pe();
      try {
        if (O) {
          var oe = function() {
            throw Error();
          };
          if (Object.defineProperty(oe.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(oe, []);
            } catch (Je) {
              W = Je;
            }
            Reflect.construct(g, [], oe);
          } else {
            try {
              oe.call();
            } catch (Je) {
              W = Je;
            }
            g.call(oe.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Je) {
            W = Je;
          }
          g();
        }
      } catch (Je) {
        if (Je && W && typeof Je.stack == "string") {
          for (var ne = Je.stack.split(`
`), He = W.stack.split(`
`), Pe = ne.length - 1, Ae = He.length - 1; Pe >= 1 && Ae >= 0 && ne[Pe] !== He[Ae]; )
            Ae--;
          for (; Pe >= 1 && Ae >= 0; Pe--, Ae--)
            if (ne[Pe] !== He[Ae]) {
              if (Pe !== 1 || Ae !== 1)
                do
                  if (Pe--, Ae--, Ae < 0 || ne[Pe] !== He[Ae]) {
                    var et = `
` + ne[Pe].replace(" at new ", " at ");
                    return g.displayName && et.includes("<anonymous>") && (et = et.replace("<anonymous>", g.displayName)), typeof g == "function" && jt.set(g, et), et;
                  }
                while (Pe >= 1 && Ae >= 0);
              break;
            }
        }
      } finally {
        ct = !1, ut.current = me, Me(), Error.prepareStackTrace = le;
      }
      var Yt = g ? g.displayName || g.name : "", zt = Yt ? Mt(Yt) : "";
      return typeof g == "function" && jt.set(g, zt), zt;
    }
    function wu(g, O, j) {
      return hi(g, !1);
    }
    function xu(g) {
      var O = g.prototype;
      return !!(O && O.isReactComponent);
    }
    function Kn(g, O, j) {
      if (g == null)
        return "";
      if (typeof g == "function")
        return hi(g, xu(g));
      if (typeof g == "string")
        return Mt(g);
      switch (g) {
        case c:
          return Mt("Suspense");
        case l:
          return Mt("SuspenseList");
      }
      if (typeof g == "object")
        switch (g.$$typeof) {
          case u:
            return wu(g.render);
          case d:
            return Kn(g.type, O, j);
          case f: {
            var W = g, le = W._payload, me = W._init;
            try {
              return Kn(me(le), O, j);
            } catch {
            }
          }
        }
      return "";
    }
    var xn = Object.prototype.hasOwnProperty, pi = {}, mi = K.ReactDebugCurrentFrame;
    function Yn(g) {
      if (g) {
        var O = g._owner, j = Kn(g.type, g._source, O ? O.type : null);
        mi.setExtraStackFrame(j);
      } else
        mi.setExtraStackFrame(null);
    }
    function Su(g, O, j, W, le) {
      {
        var me = Function.call.bind(xn);
        for (var oe in g)
          if (me(g, oe)) {
            var ne = void 0;
            try {
              if (typeof g[oe] != "function") {
                var He = Error((W || "React class") + ": " + j + " type `" + oe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[oe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw He.name = "Invariant Violation", He;
              }
              ne = g[oe](O, oe, W, j, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Pe) {
              ne = Pe;
            }
            ne && !(ne instanceof Error) && (Yn(le), T("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", W || "React class", j, oe, typeof ne), Yn(null)), ne instanceof Error && !(ne.message in pi) && (pi[ne.message] = !0, Yn(le), T("Failed %s type: %s", j, ne.message), Yn(null));
          }
      }
    }
    var Ru = Array.isArray;
    function es(g) {
      return Ru(g);
    }
    function _u(g) {
      {
        var O = typeof Symbol == "function" && Symbol.toStringTag, j = O && g[Symbol.toStringTag] || g.constructor.name || "Object";
        return j;
      }
    }
    function Ou(g) {
      try {
        return gi(g), !1;
      } catch {
        return !0;
      }
    }
    function gi(g) {
      return "" + g;
    }
    function vi(g) {
      if (Ou(g))
        return T("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", _u(g)), gi(g);
    }
    var yi = K.ReactCurrentOwner, Eu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, bi, wi;
    function Tu(g) {
      if (xn.call(g, "ref")) {
        var O = Object.getOwnPropertyDescriptor(g, "ref").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return g.ref !== void 0;
    }
    function Cu(g) {
      if (xn.call(g, "key")) {
        var O = Object.getOwnPropertyDescriptor(g, "key").get;
        if (O && O.isReactWarning)
          return !1;
      }
      return g.key !== void 0;
    }
    function ju(g, O) {
      typeof g.ref == "string" && yi.current;
    }
    function ku(g, O) {
      {
        var j = function() {
          bi || (bi = !0, T("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(g, "key", {
          get: j,
          configurable: !0
        });
      }
    }
    function Pu(g, O) {
      {
        var j = function() {
          wi || (wi = !0, T("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", O));
        };
        j.isReactWarning = !0, Object.defineProperty(g, "ref", {
          get: j,
          configurable: !0
        });
      }
    }
    var Iu = function(g, O, j, W, le, me, oe) {
      var ne = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: g,
        key: O,
        ref: j,
        props: oe,
        // Record the component responsible for creating this element.
        _owner: me
      };
      return ne._store = {}, Object.defineProperty(ne._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ne, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: W
      }), Object.defineProperty(ne, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: le
      }), Object.freeze && (Object.freeze(ne.props), Object.freeze(ne)), ne;
    };
    function Au(g, O, j, W, le) {
      {
        var me, oe = {}, ne = null, He = null;
        j !== void 0 && (vi(j), ne = "" + j), Cu(O) && (vi(O.key), ne = "" + O.key), Tu(O) && (He = O.ref, ju(O, le));
        for (me in O)
          xn.call(O, me) && !Eu.hasOwnProperty(me) && (oe[me] = O[me]);
        if (g && g.defaultProps) {
          var Pe = g.defaultProps;
          for (me in Pe)
            oe[me] === void 0 && (oe[me] = Pe[me]);
        }
        if (ne || He) {
          var Ae = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
          ne && ku(oe, Ae), He && Pu(oe, Ae);
        }
        return Iu(g, ne, He, le, W, yi.current, oe);
      }
    }
    var ts = K.ReactCurrentOwner, xi = K.ReactDebugCurrentFrame;
    function Kt(g) {
      if (g) {
        var O = g._owner, j = Kn(g.type, g._source, O ? O.type : null);
        xi.setExtraStackFrame(j);
      } else
        xi.setExtraStackFrame(null);
    }
    var ns;
    ns = !1;
    function rs(g) {
      return typeof g == "object" && g !== null && g.$$typeof === e;
    }
    function Si() {
      {
        if (ts.current) {
          var g = fe(ts.current.type);
          if (g)
            return `

Check the render method of \`` + g + "`.";
        }
        return "";
      }
    }
    function Uu(g) {
      return "";
    }
    var Ri = {};
    function Lu(g) {
      {
        var O = Si();
        if (!O) {
          var j = typeof g == "string" ? g : g.displayName || g.name;
          j && (O = `

Check the top-level render call using <` + j + ">.");
        }
        return O;
      }
    }
    function _i(g, O) {
      {
        if (!g._store || g._store.validated || g.key != null)
          return;
        g._store.validated = !0;
        var j = Lu(O);
        if (Ri[j])
          return;
        Ri[j] = !0;
        var W = "";
        g && g._owner && g._owner !== ts.current && (W = " It was passed a child from " + fe(g._owner.type) + "."), Kt(g), T('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', j, W), Kt(null);
      }
    }
    function Oi(g, O) {
      {
        if (typeof g != "object")
          return;
        if (es(g))
          for (var j = 0; j < g.length; j++) {
            var W = g[j];
            rs(W) && _i(W, O);
          }
        else if (rs(g))
          g._store && (g._store.validated = !0);
        else if (g) {
          var le = _(g);
          if (typeof le == "function" && le !== g.entries)
            for (var me = le.call(g), oe; !(oe = me.next()).done; )
              rs(oe.value) && _i(oe.value, O);
        }
      }
    }
    function Nu(g) {
      {
        var O = g.type;
        if (O == null || typeof O == "string")
          return;
        var j;
        if (typeof O == "function")
          j = O.propTypes;
        else if (typeof O == "object" && (O.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        O.$$typeof === d))
          j = O.propTypes;
        else
          return;
        if (j) {
          var W = fe(O);
          Su(j, g.props, "prop", W, g);
        } else if (O.PropTypes !== void 0 && !ns) {
          ns = !0;
          var le = fe(O);
          T("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", le || "Unknown");
        }
        typeof O.getDefaultProps == "function" && !O.getDefaultProps.isReactClassApproved && T("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Du(g) {
      {
        for (var O = Object.keys(g.props), j = 0; j < O.length; j++) {
          var W = O[j];
          if (W !== "children" && W !== "key") {
            Kt(g), T("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", W), Kt(null);
            break;
          }
        }
        g.ref !== null && (Kt(g), T("Invalid attribute `ref` supplied to `React.Fragment`."), Kt(null));
      }
    }
    var Ei = {};
    function Ti(g, O, j, W, le, me) {
      {
        var oe = at(g);
        if (!oe) {
          var ne = "";
          (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (ne += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var He = Uu();
          He ? ne += He : ne += Si();
          var Pe;
          g === null ? Pe = "null" : es(g) ? Pe = "array" : g !== void 0 && g.$$typeof === e ? (Pe = "<" + (fe(g.type) || "Unknown") + " />", ne = " Did you accidentally export a JSX literal instead of a component?") : Pe = typeof g, T("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Pe, ne);
        }
        var Ae = Au(g, O, j, le, me);
        if (Ae == null)
          return Ae;
        if (oe) {
          var et = O.children;
          if (et !== void 0)
            if (W)
              if (es(et)) {
                for (var Yt = 0; Yt < et.length; Yt++)
                  Oi(et[Yt], g);
                Object.freeze && Object.freeze(et);
              } else
                T("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Oi(et, g);
        }
        if (xn.call(O, "key")) {
          var zt = fe(g), Je = Object.keys(O).filter(function(qu) {
            return qu !== "key";
          }), ss = Je.length > 0 ? "{key: someKey, " + Je.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ei[zt + ss]) {
            var zu = Je.length > 0 ? "{" + Je.join(": ..., ") + ": ...}" : "{}";
            T(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ss, zt, zu, zt), Ei[zt + ss] = !0;
          }
        }
        return g === r ? Du(Ae) : Nu(Ae), Ae;
      }
    }
    function Fu(g, O, j) {
      return Ti(g, O, j, !0);
    }
    function $u(g, O, j) {
      return Ti(g, O, j, !1);
    }
    var Bu = $u, Mu = Fu;
    Rn.Fragment = r, Rn.jsx = Bu, Rn.jsxs = Mu;
  }()), Rn;
}
process.env.NODE_ENV === "production" ? Cs.exports = jc() : Cs.exports = kc();
var m = Cs.exports;
function Pc({ menuItems: t }) {
  const [e, n] = is.useState(null), r = !!e, s = (o) => {
    n(o.currentTarget);
  }, i = () => {
    n(null);
  };
  return /* @__PURE__ */ m.jsxs(is.Fragment, { children: [
    /* @__PURE__ */ m.jsx(Be, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ m.jsx(oa, { title: "Account settings", children: /* @__PURE__ */ m.jsx(
      Gu,
      {
        onClick: s,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": r ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": r ? "true" : void 0,
        children: /* @__PURE__ */ m.jsx(Zu, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ m.jsx(Vu, {}) })
      }
    ) }) }),
    /* @__PURE__ */ m.jsx(
      Wu,
      {
        anchorEl: e,
        id: "account-menu",
        open: r,
        onClose: i,
        onClick: i,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: t.map((o, a) => /* @__PURE__ */ m.jsxs(is.Fragment, { children: [
          o.divider && /* @__PURE__ */ m.jsx(Ju, {}),
          o.href ? /* @__PURE__ */ m.jsxs(Er, { component: "a", href: o.href, onClick: i, children: [
            o.icon && /* @__PURE__ */ m.jsx(Es, { children: o.icon }),
            o.text
          ] }) : /* @__PURE__ */ m.jsxs(
            Er,
            {
              onClick: () => {
                var u;
                (u = o.onClick) == null || u.call(o), i();
              },
              children: [
                o.icon && /* @__PURE__ */ m.jsx(Es, { children: o.icon }),
                o.text
              ]
            }
          )
        ] }, a))
      }
    )
  ] });
}
const Ic = 64, Ac = () => typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev", Uc = ({ rightContent: t = null, brandLogo: e = null, sx: n = {} }) => {
  const r = Ac();
  return /* @__PURE__ */ m.jsx(Ku, { sx: { ...n }, position: "fixed", elevation: 1, children: /* @__PURE__ */ m.jsxs(
    Yu,
    {
      sx: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        pl: 0,
        minHeight: `${Ic}px !important`
      },
      children: [
        e,
        /* @__PURE__ */ m.jsxs(Be, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: [
          t,
          r && /* @__PURE__ */ m.jsx(
            Be,
            {
              component: "span",
              "data-testid": "app-version",
              "aria-hidden": "true",
              sx: {
                color: "rgba(255, 255, 255, 0.4)",
                fontFamily: "monospace",
                fontSize: "11px",
                lineHeight: 1,
                whiteSpace: "nowrap",
                userSelect: "none",
                pr: 1
              },
              children: r
            }
          )
        ] })
      ]
    }
  ) });
}, Wh = ({ children: t, sx: e = {} }) => /* @__PURE__ */ m.jsx(
  Be,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (n) => n.zIndex.appBar,
      ...e
    },
    children: t
  }
), Lc = 64, Nc = ({ children: t }) => /* @__PURE__ */ m.jsx(
  Be,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${Lc}px - 56px)`,
      overflow: "auto"
    },
    children: t || /* @__PURE__ */ m.jsx("div", { children: "MainContent (stub)" })
  }
), as = 64, Ii = 72, Dc = { xs: 2, sm: 4, md: 8 }, Jh = ({
  appFooterEnabled: t = !0,
  children: e,
  appFooter: n = null,
  appBar: r = null,
  navRail: s = null
}) => /* @__PURE__ */ m.jsxs(Be, { sx: { minHeight: "100vh", width: "100%" }, children: [
  /* @__PURE__ */ m.jsx(
    Be,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        zIndex: 1300
      },
      children: r
    }
  ),
  /* @__PURE__ */ m.jsxs(
    Be,
    {
      sx: {
        display: "flex",
        flexDirection: "row",
        pt: `${as}px`
      },
      children: [
        s && /* @__PURE__ */ m.jsx(
          Be,
          {
            sx: {
              width: Ii,
              flexShrink: 0,
              position: "fixed",
              height: `calc(100vh - ${as}px)`,
              top: as,
              left: 0,
              zIndex: 1200
            },
            children: s
          }
        ),
        /* @__PURE__ */ m.jsx(
          Be,
          {
            sx: {
              flexGrow: 1,
              minWidth: 0,
              ml: s ? `${Ii}px` : 0,
              px: Dc
            },
            children: /* @__PURE__ */ m.jsx(Nc, { children: e })
          }
        )
      ]
    }
  ),
  t && n
] });
function dr({ message: t }) {
  return /* @__PURE__ */ m.jsxs(
    de,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ m.jsx(Jn, {}),
        t && /* @__PURE__ */ m.jsx(Xe, { variant: "h6", sx: { mt: 2 }, children: t })
      ]
    }
  );
}
const ba = ["/", "/callback", "/logout", "/logged-out"];
function Fc(t) {
  return typeof t == "string" && t.startsWith("/") && !ba.includes(t);
}
function Gh({ navigateFunction: t, location: e }) {
  return ke(() => {
    const n = setTimeout(() => {
      const r = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const s = Fc(r) ? r : "/";
      t(s, { replace: !0 });
    }, 500);
    return () => clearTimeout(n);
  }, [t, e]), /* @__PURE__ */ m.jsx(dr, { message: "Signing you in..." });
}
let wa = !1;
function Vh() {
  wa = !0;
}
function $c() {
  return wa;
}
function Bc({ children: t }) {
  const e = Vt();
  return ke(() => {
    const n = window.location.pathname;
    ba.includes(n) || localStorage.setItem("redirect_url", n);
  }, []), ke(() => {
    !e.isLoading && !e.isAuthenticated && !e.error && !$c() && e.signinRedirect();
  }, [e.isLoading, e.isAuthenticated, e.error, e]), e.isLoading ? /* @__PURE__ */ m.jsx(dr, { message: "Loading..." }) : e.error ? /* @__PURE__ */ m.jsx(
    dr,
    {
      message: `Encountering error... ${e.error.message}`
    }
  ) : e.isAuthenticated ? t : /* @__PURE__ */ m.jsx(dr, { message: "Redirecting to login..." });
}
function Kh({ cognitoAuthConfig: t, children: e }) {
  return /* @__PURE__ */ m.jsx(cc, { ...t, children: /* @__PURE__ */ m.jsx(Bc, { children: e }) });
}
const Yh = ({
  onConfirm: t,
  onCancel: e,
  confirmText: n = "Confirm",
  cancelText: r = "Cancel",
  buttonText: s = "Delete",
  buttonIcon: i = /* @__PURE__ */ m.jsx(lc, {}),
  variant: o = "outlined",
  color: a = "error",
  size: u = "small",
  disabled: c = !1,
  "data-testid": l,
  confirmButtonTestId: d,
  cancelButtonTestId: f
}) => {
  const [h, v] = Z(!1), p = () => {
    v(!0);
  }, _ = () => {
    v(!1), t();
  }, K = () => {
    v(!1), e && e();
  };
  return h ? /* @__PURE__ */ m.jsxs(de, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ m.jsx(
      Ze,
      {
        variant: "contained",
        color: a,
        size: u,
        onClick: _,
        "data-testid": d,
        children: n
      }
    ),
    /* @__PURE__ */ m.jsx(
      Ze,
      {
        variant: "outlined",
        size: u,
        onClick: K,
        "data-testid": f,
        children: r
      }
    )
  ] }) : /* @__PURE__ */ m.jsx(
    Ze,
    {
      variant: o,
      color: a,
      size: u,
      startIcon: i,
      onClick: p,
      disabled: c,
      "data-testid": l,
      children: s
    }
  );
};
function Xh({
  rows: t = 5,
  columns: e = 1,
  showHeader: n = !0,
  dense: r = !1,
  sx: s,
  ...i
}) {
  const o = r ? 28 : 40, a = r ? 0.75 : 1.25, u = Math.max(1, e), c = (l, d) => /* @__PURE__ */ m.jsx(Pr, { direction: "row", spacing: a, sx: { width: "100%" }, children: Array.from({ length: u }).map((f, h) => /* @__PURE__ */ m.jsx(
    kr,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    h
  )) }, l);
  return /* @__PURE__ */ m.jsx(
    Be,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...s },
      ...i,
      children: /* @__PURE__ */ m.jsxs(Pr, { spacing: a, children: [
        n && c("header", o * 0.7),
        Array.from({ length: Math.max(1, t) }).map(
          (l, d) => c(`row-${d}`, o)
        )
      ] })
    }
  );
}
function Qh() {
  return /* @__PURE__ */ m.jsxs("div", { children: [
    "You have been logged out. ",
    /* @__PURE__ */ m.jsx("a", { href: "/", children: "Go to home" })
  ] });
}
function ep({ navigateFunction: t }) {
  const e = Vt();
  return ke(() => {
    let n = !0;
    async function r() {
      await e.removeUser(), n && t("/logged-out", { replace: !0 });
    }
    return r(), () => {
      n = !1;
    };
  }, [e, t]), /* @__PURE__ */ m.jsx("div", { children: "You have been logged out." });
}
function tp({ theme: t, children: e }) {
  return !t || typeof t != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), e) : /* @__PURE__ */ m.jsxs(mc, { theme: t, children: [
    /* @__PURE__ */ m.jsx(gc, {}),
    e
  ] });
}
const Mc = Xs(Be)(({ theme: t, backgroundColor: e, color: n }) => ({
  width: 72,
  height: "100%",
  backgroundColor: e || t.palette.background.paper,
  color: n || t.palette.text.primary,
  borderRight: `1px solid ${t.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  paddingTop: t.spacing(2)
})), np = ({
  navItems: t,
  backgroundColor: e = "#1a1a1a",
  color: n = "inherit"
}) => {
  const r = [
    {
      icon: /* @__PURE__ */ m.jsx(da, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ m.jsx(fa, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], s = t && t.length > 0 ? t : r;
  return /* @__PURE__ */ m.jsx(Mc, { backgroundColor: e, color: n, children: /* @__PURE__ */ m.jsx(vc, { sx: { width: "100%", p: 0 }, children: s.map((i, o) => /* @__PURE__ */ m.jsxs(
    yc,
    {
      onClick: i.onClick,
      sx: {
        flexDirection: "column",
        py: 1,
        px: 0,
        color: "inherit",
        // #582 — nav items are clickable; show the pointer (hand) cursor
        // on hover (ListItem alone doesn't imply a button cursor).
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "transparent",
          opacity: 0.8
        }
      },
      children: [
        /* @__PURE__ */ m.jsx(
          Es,
          {
            sx: {
              minWidth: "auto",
              color: "inherit"
            },
            children: i.icon
          }
        ),
        /* @__PURE__ */ m.jsx(
          bc,
          {
            primary: i.text,
            primaryTypographyProps: {
              variant: "caption",
              align: "center",
              sx: {
                fontSize: "0.7rem",
                mt: 0.5,
                color: "inherit"
              }
            }
          }
        )
      ]
    },
    o
  )) }) });
};
function rp({ children: t }) {
  return Vt().isAuthenticated ? t : /* @__PURE__ */ m.jsx(ha, { to: "/callback", replace: !0 });
}
const sp = ({
  children: t,
  maxWidth: e = 600,
  minWidth: n = 320,
  backTo: r,
  backLabel: s,
  breadcrumbs: i,
  onBack: o
}) => {
  const a = () => {
    o && o();
  };
  return /* @__PURE__ */ m.jsxs(
    de,
    {
      maxWidth: e,
      minWidth: n,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ m.jsx(
          de,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ m.jsxs(de, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              r && /* @__PURE__ */ m.jsx(
                Ze,
                {
                  startIcon: /* @__PURE__ */ m.jsx(dc, {}),
                  onClick: a,
                  variant: "outlined",
                  size: "small",
                  children: s || "Back"
                }
              ),
              i && /* @__PURE__ */ m.jsx(Xu, { separator: "", children: rn.Children.map(i, (u, c) => {
                const l = rn.Children.count(i);
                let d = "middle";
                return l === 1 ? d = "single" : c === 0 ? d = "first" : c === l - 1 && (d = "last"), rn.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        t
      ]
    }
  );
}, lt = "12px", zc = Xs(Be, {
  shouldForwardProp: (t) => t !== "position"
})(({ theme: t, position: e }) => {
  const n = () => {
    switch (e) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${lt}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${lt} 0, 100% 0, calc(100% - ${lt}) 100%, 0 100%)`;
      case "last":
        return `polygon(${lt} 0, calc(100% - ${lt}) 0, 100% 50%, calc(100% - ${lt}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${lt}) 0, 100% 50%, calc(100% - ${lt}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200],
    color: t.palette.getContrastText(
      t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: n(),
    // Nudge the items together to overlap
    marginLeft: e === "middle" || e === "last" ? `-${lt}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: e === "middle" || e === "last" ? `calc(${lt} + ${t.spacing(1)})` : t.spacing(2),
    paddingRight: `calc(${lt} + ${t.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: t.palette.mode === "dark" ? t.palette.grey[700] : t.palette.grey[300]
    }
  };
}), qc = Xs(Bn)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), ip = ({ label: t, component: e = "a", ...n }) => /* @__PURE__ */ m.jsx(zc, { component: e, ...n, children: /* @__PURE__ */ m.jsx(qc, { children: t }) }), op = ({ onClick: t, label: e, "data-testid": n }) => /* @__PURE__ */ m.jsx(
  Qu,
  {
    onClick: t,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[800] : r.palette.grey[200],
      borderRadius: (r) => r.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (r) => r.palette.mode === "dark" ? r.palette.grey[700] : r.palette.grey[300]
      }
    },
    "data-testid": n || "new-item-card-button",
    children: /* @__PURE__ */ m.jsxs(
      de,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ m.jsx(
            de,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ m.jsx(fc, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ m.jsx(Xe, { variant: "button", component: "span", children: e })
        ]
      }
    )
  }
), ap = ({ title: t, icon: e, tags: n = [], onEdit: r, showEdit: s, onMembers: i, showMembers: o, "data-testid": a, editButtonTestId: u, membersButtonTestId: c }) => /* @__PURE__ */ m.jsxs(
  Tr,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (l) => l.palette.mode === "dark" ? l.palette.grey[900] : l.palette.background.paper
    },
    "data-testid": a,
    elevation: 1,
    children: [
      /* @__PURE__ */ m.jsx(Cr, { sx: { pb: 1 }, children: /* @__PURE__ */ m.jsxs(de, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        e && rn.cloneElement(e, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ m.jsx(Xe, { variant: "h6", component: "div", noWrap: !0, children: t })
      ] }) }),
      /* @__PURE__ */ m.jsx(Cr, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ m.jsx(ln, { direction: "row", spacing: 1, children: n.map((l, d) => /* @__PURE__ */ m.jsx(
        aa,
        {
          label: l.label,
          color: l.color || "default",
          size: l.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ m.jsxs(de, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        o && /* @__PURE__ */ m.jsx(
          jr,
          {
            "aria-label": `manage members for ${t}`,
            onClick: i,
            sx: {
              color: "text.secondary"
            },
            "data-testid": c,
            children: /* @__PURE__ */ m.jsx(hc, {})
          }
        ),
        s && /* @__PURE__ */ m.jsx(
          jr,
          {
            "aria-label": `edit ${t}`,
            onClick: r,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ m.jsx(pc, {})
          }
        )
      ] })
    ]
  }
);
class Pn extends Error {
}
Pn.prototype.name = "InvalidTokenError";
function Hc(t) {
  return decodeURIComponent(atob(t).replace(/(.)/g, (e, n) => {
    let r = n.charCodeAt(0).toString(16).toUpperCase();
    return r.length < 2 && (r = "0" + r), "%" + r;
  }));
}
function Zc(t) {
  let e = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (e.length % 4) {
    case 0:
      break;
    case 2:
      e += "==";
      break;
    case 3:
      e += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Hc(e);
  } catch {
    return atob(e);
  }
}
function xa(t, e) {
  if (typeof t != "string")
    throw new Pn("Invalid token specified: must be a string");
  e || (e = {});
  const n = e.header === !0 ? 0 : 1, r = t.split(".")[n];
  if (typeof r != "string")
    throw new Pn(`Invalid token specified: missing part #${n + 1}`);
  let s;
  try {
    s = Zc(r);
  } catch (i) {
    throw new Pn(`Invalid token specified: invalid base64 for part #${n + 1} (${i.message})`);
  }
  try {
    return JSON.parse(s);
  } catch (i) {
    throw new Pn(`Invalid token specified: invalid json for part #${n + 1} (${i.message})`);
  }
}
const js = "common-fe.activeOrgId", Wc = "426e8750-5b55-59f4-90c7-835b46d6a990", Jc = (t) => {
  const e = t.filter((n) => n.id !== Wc);
  return e.length ? e : t;
}, Gc = (t) => {
  if (!t) return !1;
  try {
    const e = xa(t), n = e["custom:super"] ?? e.super;
    return n === "true" || n === !0;
  } catch {
    return !1;
  }
}, Sa = Vr({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1
}), Vc = () => {
  try {
    return window.localStorage.getItem(js) || null;
  } catch {
    return null;
  }
}, Kc = (t) => {
  try {
    t ? window.localStorage.setItem(js, t) : window.localStorage.removeItem(js);
  } catch {
  }
}, up = ({ listOrgs: t, children: e }) => {
  var v;
  const r = (v = Vt().user) == null ? void 0 : v.access_token, s = Gc(r), [i, o] = Z([]), [a, u] = Z(!0), [c, l] = Z(null), [d, f] = Z(() => Vc()), h = Bt((p) => {
    f(p), Kc(p);
  }, []);
  return ke(() => {
    if (!t) {
      u(!1);
      return;
    }
    let p = !1;
    return (async () => {
      try {
        u(!0), l(null);
        const _ = await t(s);
        if (p) return;
        o(Jc(Array.isArray(_) ? _ : []));
      } catch (_) {
        if (p) return;
        console.error("Failed to load orgs for switcher:", _), l(_), o([]);
      } finally {
        p || u(!1);
      }
    })(), () => {
      p = !0;
    };
  }, [t, s]), ke(() => {
    if (!i.length) return;
    i.some((_) => _.id === d) || h(i[0].id);
  }, [i, d, h]), /* @__PURE__ */ m.jsx(
    Sa.Provider,
    {
      value: { orgs: i, activeOrgId: d, setActiveOrgId: h, loading: a, error: c, isSuper: s },
      children: e
    }
  );
}, Qs = () => Kr(Sa), ks = "common-fe.activeShowId", Ra = Vr({
  shows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  loading: !1,
  error: null
}), Yc = () => {
  try {
    return window.localStorage.getItem(ks) || null;
  } catch {
    return null;
  }
}, Xc = (t) => {
  try {
    t ? window.localStorage.setItem(ks, t) : window.localStorage.removeItem(ks);
  } catch {
  }
}, cp = ({ listShows: t, orgId: e, children: n }) => {
  const [r, s] = Z([]), [i, o] = Z(!0), [a, u] = Z(null), [c, l] = Z(() => Yc()), d = Bt((v) => {
    l(v), Xc(v);
  }, []);
  ke(() => {
    if (!t) {
      o(!1);
      return;
    }
    let v = !1;
    return (async () => {
      try {
        o(!0), u(null);
        const p = await t();
        if (v) return;
        s(Array.isArray(p) ? p : []);
      } catch (p) {
        if (v) return;
        console.error("Failed to load shows for switcher:", p), u(p), s([]);
      } finally {
        v || o(!1);
      }
    })(), () => {
      v = !0;
    };
  }, [t, e]), ke(() => {
    if (!r.length) return;
    r.some((p) => p.id === c) || d(r[0].id);
  }, [r, c, d]);
  const f = Dn(
    () => r.find((v) => v.id === c) || null,
    [r, c]
  ), h = Dn(
    () => ({ shows: r, activeShowId: c, activeShow: f, setActiveShowId: d, loading: i, error: a }),
    [r, c, f, d, i, a]
  );
  return /* @__PURE__ */ m.jsx(Ra.Provider, { value: h, children: n });
}, Qc = () => Kr(Ra), lp = ({ onShowChange: t }) => {
  const { shows: e, activeShowId: n, setActiveShowId: r, loading: s } = Qc();
  if (s && !e.length)
    return /* @__PURE__ */ m.jsx(
      kr,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!e || e.length === 0) return null;
  const i = (o) => {
    const a = o.target.value;
    r(a), t && t(a);
  };
  return /* @__PURE__ */ m.jsxs(
    Be,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ m.jsx(xc, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsx(
          pa,
          {
            value: n || "",
            onChange: i,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: (o) => {
              const a = e.find((u) => u.id === o);
              return a ? a.name || a.id : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 240,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: e.map((o) => /* @__PURE__ */ m.jsx(Er, { value: o.id, children: o.name || o.id }, o.id))
          }
        )
      ]
    }
  );
}, _a = Vr({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), el = (t, e) => typeof e == "string" && e.includes(":") ? e : `${t}:${e}`, tl = (t) => {
  if (!t) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const e = xa(t), n = e["custom:super"] ?? e.super, r = n === "true" || n === !0, s = new Set(
      Array.isArray(e.permissions) ? e.permissions : []
    );
    return { isSuper: r, permissions: s };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, dp = ({ appNamespace: t, children: e }) => {
  var i;
  const r = (i = Vt().user) == null ? void 0 : i.access_token, s = Dn(() => {
    const { isSuper: o, permissions: a } = tl(r);
    return { appNamespace: t, isSuper: o, permissions: a };
  }, [t, r]);
  return /* @__PURE__ */ m.jsx(_a.Provider, { value: s, children: e });
}, fp = (t) => {
  const { appNamespace: e, isSuper: n, permissions: r } = Kr(_a);
  return n ? !0 : r.has(el(e, t));
}, nl = (t, e) => t.length > e ? `${t.slice(0, Math.max(0, e - 1))}…` : t;
function rl({ maxEmailChars: t = 28 }) {
  var u;
  const n = ((u = Vt().user) == null ? void 0 : u.profile) || {}, r = (n.given_name || "").trim(), s = (n.family_name || "").trim(), i = [r, s].filter(Boolean).join(" "), o = (n.email || "").trim(), a = i || (o ? nl(o, t) : "");
  return a ? /* @__PURE__ */ m.jsx(oa, { title: i || o, children: /* @__PURE__ */ m.jsx(
    Bn,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: a
    }
  ) }) : null;
}
const sl = () => {
  const { orgs: t, activeOrgId: e, setActiveOrgId: n, isSuper: r } = Qs();
  return !t || t.length <= 1 ? null : /* @__PURE__ */ m.jsxs(
    Be,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        r && /* @__PURE__ */ m.jsx(
          ma,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ m.jsx(
              Rc,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ m.jsx(Sc, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsx(
          pa,
          {
            value: e || "",
            onChange: (s) => n(s.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (s) => {
              const i = t.find((o) => o.id === s);
              return i ? i.name : "";
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: t.map((s) => /* @__PURE__ */ m.jsx(Er, { value: s.id, children: s.name }, s.id))
          }
        )
      ]
    }
  );
};
function hp({ onLogout: t, brandLogo: e = null }) {
  var u;
  const { mode: n, setMode: r } = la(), { orgs: s, activeOrgId: i } = Qs(), o = ((u = s.find((c) => c.id === i)) == null ? void 0 : u.name) || null, a = [
    {
      icon: n === "dark" ? /* @__PURE__ */ m.jsx(va, {}) : /* @__PURE__ */ m.jsx(ga, {}),
      text: n === "dark" ? "Light mode" : "Dark mode",
      onClick: () => r(n === "dark" ? "light" : "dark")
    },
    {
      icon: /* @__PURE__ */ m.jsx(ya, {}),
      text: "Sign out",
      onClick: t
    }
  ];
  return /* @__PURE__ */ m.jsx(
    Uc,
    {
      sx: { backgroundColor: _c.darkGrey, color: "#fff" },
      brandLogo: e,
      rightContent: /* @__PURE__ */ m.jsxs(
        Be,
        {
          "data-testid": "gate-header",
          sx: { display: "flex", alignItems: "center", gap: 1.5 },
          children: [
            /* @__PURE__ */ m.jsx(sl, {}),
            o && /* @__PURE__ */ m.jsx(
              Bn,
              {
                "data-testid": "gate-active-org-name",
                variant: "body2",
                sx: { color: "inherit", opacity: 0.9, whiteSpace: "nowrap" },
                children: o
              }
            ),
            /* @__PURE__ */ m.jsx(rl, {}),
            /* @__PURE__ */ m.jsx(Pc, { menuItems: a })
          ]
        }
      )
    }
  );
}
const Oa = "common-fe.mockAuth", Ea = Vr(null), il = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function ol() {
  try {
    const t = localStorage.getItem(Oa);
    return t ? JSON.parse(t) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function al(t) {
  try {
    localStorage.setItem(Oa, JSON.stringify(t));
  } catch {
  }
}
function pp({ children: t, defaultUser: e = il }) {
  const [n, r] = Z(ol);
  ke(() => {
    al(n);
  }, [n]);
  const s = Bt(
    (a) => {
      r({ signedIn: !0, user: a ?? e });
    },
    [e]
  ), i = Bt(() => {
    r({ signedIn: !1, user: null });
  }, []), o = Dn(
    () => ({
      isAuthenticated: n.signedIn,
      user: n.user,
      signIn: s,
      signOut: i
    }),
    [n, s, i]
  );
  return /* @__PURE__ */ m.jsx(Ea.Provider, { value: o, children: t });
}
function Ta() {
  const t = Kr(Ea);
  if (!t)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return t;
}
function mp({ children: t, loginPath: e = "/login" }) {
  const { isAuthenticated: n } = Ta(), r = wc();
  return n ? t : /* @__PURE__ */ m.jsx(ha, { to: e, replace: !0, state: { from: r.pathname } });
}
const ul = "jaybill@foxvillage.com", cl = "demo-password", ll = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function gp({
  onSignIn: t,
  brandLogo: e,
  labels: n = {}
}) {
  const { signIn: r } = Ta(), [s, i] = Z(ul), [o, a] = Z(cl), [u, c] = Z(!1), l = { ...ll, ...n }, d = (h) => {
    h.preventDefault();
    const v = { email: s, displayName: s.split("@")[0] };
    t ? t(v) : r(v);
  }, f = e ?? Oc;
  return /* @__PURE__ */ m.jsx(
    de,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (h) => h.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ m.jsxs(
        Tr,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (h) => h.palette.mode === "dark" ? "#000" : "background.paper",
            color: (h) => h.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ m.jsx(
              de,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ m.jsx(f, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ m.jsx(Xe, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: l.heading }),
            /* @__PURE__ */ m.jsx(
              Xe,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: l.subheading
              }
            ),
            /* @__PURE__ */ m.jsx(de, { component: "form", onSubmit: d, children: /* @__PURE__ */ m.jsxs(ln, { spacing: 3, children: [
              /* @__PURE__ */ m.jsx(
                Fn,
                {
                  label: l.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: s,
                  onChange: (h) => i(h.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ m.jsxs(de, { children: [
                /* @__PURE__ */ m.jsx(
                  Fn,
                  {
                    label: l.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: o,
                    onChange: (h) => a(h.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ m.jsxs(
                  ln,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ m.jsx(
                        ua,
                        {
                          control: /* @__PURE__ */ m.jsx(
                            ca,
                            {
                              size: "small",
                              checked: u,
                              onChange: (h) => c(h.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: l.showPassword
                        }
                      ),
                      /* @__PURE__ */ m.jsx(
                        Ci,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: l.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ m.jsx(
                Ze,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: l.submit
                }
              ),
              /* @__PURE__ */ m.jsxs(
                Xe,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    l.newUserPrompt,
                    " ",
                    /* @__PURE__ */ m.jsx(
                      Ci,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: l.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var Ir = { d: (t, e) => {
  for (var n in e) Ir.o(e, n) && !Ir.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
}, o: (t, e) => Object.prototype.hasOwnProperty.call(t, e), r: (t) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
} }, Ps = {};
function Ca(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
Ir.r(Ps), Ir.d(Ps, { hasBrowserEnv: () => ti, hasStandardBrowserEnv: () => kl, hasStandardBrowserWebWorkerEnv: () => Pl, navigator: () => Is, origin: () => Il });
const { toString: dl } = Object.prototype, { getPrototypeOf: ei } = Object, { iterator: fr, toStringTag: ja } = Symbol, Ar = (us = /* @__PURE__ */ Object.create(null), (t) => {
  const e = dl.call(t);
  return us[e] || (us[e] = e.slice(8, -1).toLowerCase());
});
var us;
const mt = (t) => (t = t.toLowerCase(), (e) => Ar(e) === t), Yr = (t) => (e) => typeof e === t, { isArray: Qt } = Array, sn = Yr("undefined");
function Un(t) {
  return t !== null && !sn(t) && t.constructor !== null && !sn(t.constructor) && Ve(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Ai = mt("ArrayBuffer"), fl = Yr("string"), Ve = Yr("function"), Ui = Yr("number"), _n = (t) => t !== null && typeof t == "object", Xn = (t) => {
  if (Ar(t) !== "object") return !1;
  const e = ei(t);
  return !(e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || ja in t || fr in t);
}, hl = mt("Date"), pl = mt("File"), ml = mt("Blob"), gl = mt("FileList"), vl = mt("URLSearchParams"), [yl, bl, wl, xl] = ["ReadableStream", "Request", "Response", "Headers"].map(mt);
function In(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t == null) return;
  let r, s;
  if (typeof t != "object" && (t = [t]), Qt(t)) for (r = 0, s = t.length; r < s; r++) e.call(null, t[r], r, t);
  else {
    if (Un(t)) return;
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], e.call(null, t[a], a, t);
  }
}
function Li(t, e) {
  if (Un(t)) return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], e === r.toLowerCase()) return r;
  return null;
}
const qt = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ni = (t) => !sn(t) && t !== qt, Sl = (cs = typeof Uint8Array < "u" && ei(Uint8Array), (t) => cs && t instanceof cs);
var cs;
const Rl = mt("HTMLFormElement"), Di = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), _l = mt("RegExp"), Fi = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  In(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, Ol = mt("AsyncFunction"), ka = ($i = typeof setImmediate == "function", Bi = Ve(qt.postMessage), $i ? setImmediate : Bi ? (ls = `axios@${Math.random()}`, Qn = [], qt.addEventListener("message", ({ source: t, data: e }) => {
  t === qt && e === ls && Qn.length && Qn.shift()();
}, !1), (t) => {
  Qn.push(t), qt.postMessage(ls, "*");
}) : (t) => setTimeout(t));
var $i, Bi, ls, Qn;
const El = typeof queueMicrotask < "u" ? queueMicrotask.bind(qt) : typeof process < "u" && process.nextTick || ka, y = { isArray: Qt, isArrayBuffer: Ai, isBuffer: Un, isFormData: (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Ve(t.append) && ((e = Ar(t)) === "formdata" || e === "object" && Ve(t.toString) && t.toString() === "[object FormData]"));
}, isArrayBufferView: function(t) {
  let e;
  return e = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && Ai(t.buffer), e;
}, isString: fl, isNumber: Ui, isBoolean: (t) => t === !0 || t === !1, isObject: _n, isPlainObject: Xn, isEmptyObject: (t) => {
  if (!_n(t) || Un(t)) return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: yl, isRequest: bl, isResponse: wl, isHeaders: xl, isUndefined: sn, isDate: hl, isFile: pl, isBlob: ml, isRegExp: _l, isFunction: Ve, isStream: (t) => _n(t) && Ve(t.pipe), isURLSearchParams: vl, isTypedArray: Sl, isFileList: gl, forEach: In, merge: function t() {
  const { caseless: e, skipUndefined: n } = Ni(this) && this || {}, r = {}, s = (i, o) => {
    const a = e && Li(r, o) || o;
    Xn(r[a]) && Xn(i) ? r[a] = t(r[a], i) : Xn(i) ? r[a] = t({}, i) : Qt(i) ? r[a] = i.slice() : n && sn(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && In(arguments[i], s);
  return r;
}, extend: (t, e, n, { allOwnKeys: r } = {}) => (In(e, (s, i) => {
  n && Ve(s) ? t[i] = Ca(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), trim: (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), inherits: (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", { value: e.prototype }), n && Object.assign(t.prototype, n);
}, toFlatObject: (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; ) o = s[i], r && !r(o, t, e) || a[o] || (e[o] = t[o], a[o] = !0);
    t = n !== !1 && ei(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, kindOf: Ar, kindOfTest: mt, endsWith: (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, toArray: (t) => {
  if (!t) return null;
  if (Qt(t)) return t;
  let e = t.length;
  if (!Ui(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; ) n[e] = t[e];
  return n;
}, forEachEntry: (t, e) => {
  const n = (t && t[fr]).call(t);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    e.call(t, s[0], s[1]);
  }
}, matchAll: (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: Rl, hasOwnProperty: Di, hasOwnProp: Di, reduceDescriptors: Fi, freezeMethods: (t) => {
  Fi(t, (e, n) => {
    if (Ve(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = t[n];
    Ve(r) && (e.enumerable = !1, "writable" in e ? e.writable = !1 : e.set || (e.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return Qt(t) ? r(t) : r(String(t).split(e)), n;
}, toCamelCase: (t) => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (t, e) => t != null && Number.isFinite(t = +t) ? t : e, findKey: Li, global: qt, isContextDefined: Ni, isSpecCompliantForm: function(t) {
  return !!(t && Ve(t.append) && t[ja] === "FormData" && t[fr]);
}, toJSONObject: (t) => {
  const e = new Array(10), n = (r, s) => {
    if (_n(r)) {
      if (e.indexOf(r) >= 0) return;
      if (Un(r)) return r;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = Qt(r) ? [] : {};
        return In(r, (o, a) => {
          const u = n(o, s + 1);
          !sn(u) && (i[a] = u);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, isAsyncFn: Ol, isThenable: (t) => t && (_n(t) || Ve(t)) && Ve(t.then) && Ve(t.catch), setImmediate: ka, asap: El, isIterable: (t) => t != null && Ve(t[fr]) };
function on(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
y.inherits(on, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: y.toJSONObject(this.config), code: this.code, status: this.status };
} });
const Mi = on.prototype, zi = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t) => {
  zi[t] = { value: t };
}), Object.defineProperties(on, zi), Object.defineProperty(Mi, "isAxiosError", { value: !0 }), on.from = (t, e, n, r, s, i) => {
  const o = Object.create(Mi);
  y.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = t && t.message ? t.message : "Error", u = e == null && t ? t.code : e;
  return on.call(o, a, u, n, r, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const ee = on;
function ds(t) {
  return y.isPlainObject(t) || y.isArray(t);
}
function Pa(t) {
  return y.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function qi(t, e, n) {
  return t ? t.concat(e).map(function(r, s) {
    return r = Pa(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
const Tl = y.toFlatObject(y, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
}), Ur = function(t, e, n) {
  if (!y.isObject(t)) throw new TypeError("target must be an object");
  e = e || new FormData();
  const r = (n = y.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, h) {
    return !y.isUndefined(h[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && y.isSpecCompliantForm(e);
  if (!y.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (y.isDate(f)) return f.toISOString();
    if (y.isBoolean(f)) return f.toString();
    if (!a && y.isBlob(f)) throw new ee("Blob is not supported. Use a Buffer instead.");
    return y.isArrayBuffer(f) || y.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, h, v) {
    let p = f;
    if (f && !v && typeof f == "object") {
      if (y.endsWith(h, "{}")) h = r ? h : h.slice(0, -2), f = JSON.stringify(f);
      else if (y.isArray(f) && function(_) {
        return y.isArray(_) && !_.some(ds);
      }(f) || (y.isFileList(f) || y.endsWith(h, "[]")) && (p = y.toArray(f))) return h = Pa(h), p.forEach(function(_, K) {
        !y.isUndefined(_) && _ !== null && e.append(o === !0 ? qi([h], K, i) : o === null ? h : h + "[]", u(_));
      }), !1;
    }
    return !!ds(f) || (e.append(qi(v, h, i), u(f)), !1);
  }
  const l = [], d = Object.assign(Tl, { defaultVisitor: c, convertValue: u, isVisitable: ds });
  if (!y.isObject(t)) throw new TypeError("data must be an object");
  return function f(h, v) {
    if (!y.isUndefined(h)) {
      if (l.indexOf(h) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(h), y.forEach(h, function(p, _) {
        (!(y.isUndefined(p) || p === null) && s.call(e, p, y.isString(_) ? _.trim() : _, v, d)) === !0 && f(p, v ? v.concat(_) : [_]);
      }), l.pop();
    }
  }(t), e;
};
function Hi(t) {
  const e = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function Ia(t, e) {
  this._pairs = [], t && Ur(t, this, e);
}
const Zi = Ia.prototype;
Zi.append = function(t, e) {
  this._pairs.push([t, e]);
}, Zi.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, Hi);
  } : Hi;
  return this._pairs.map(function(n) {
    return e(n[0]) + "=" + e(n[1]);
  }, "").join("&");
};
const Aa = Ia;
function Cl(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Ua(t, e, n) {
  if (!e) return t;
  const r = n && n.encode || Cl;
  y.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(e, n) : y.isURLSearchParams(e) ? e.toString() : new Aa(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
const Wi = class {
  constructor() {
    this.handlers = [];
  }
  use(t, e, n) {
    return this.handlers.push({ fulfilled: t, rejected: e, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    y.forEach(this.handlers, function(e) {
      e !== null && t(e);
    });
  }
}, La = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, jl = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : Aa, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, ti = typeof window < "u" && typeof document < "u", Is = typeof navigator == "object" && navigator || void 0, kl = ti && (!Is || ["ReactNative", "NativeScript", "NS"].indexOf(Is.product) < 0), Pl = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Il = ti && window.location.href || "http://localhost", ze = { ...Ps, ...jl }, Na = function(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && y.isArray(s) ? s.length : o, u ? (y.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && y.isObject(s[o]) || (s[o] = []), e(n, r, s[o], i) && y.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const h = d.length;
      let v;
      for (f = 0; f < h; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (y.isFormData(t) && y.isFunction(t.entries)) {
    const n = {};
    return y.forEachEntry(t, (r, s) => {
      e(function(i) {
        return y.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, ni = { transitional: La, adapter: ["xhr", "http", "fetch"], transformRequest: [function(t, e) {
  const n = e.getContentType() || "", r = n.indexOf("application/json") > -1, s = y.isObject(t);
  if (s && y.isHTMLForm(t) && (t = new FormData(t)), y.isFormData(t)) return r ? JSON.stringify(Na(t)) : t;
  if (y.isArrayBuffer(t) || y.isBuffer(t) || y.isStream(t) || y.isFile(t) || y.isBlob(t) || y.isReadableStream(t)) return t;
  if (y.isArrayBufferView(t)) return t.buffer;
  if (y.isURLSearchParams(t)) return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return Ur(o, new ze.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return ze.isNode && y.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(t, this.formSerializer).toString();
    if ((i = y.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return Ur(i ? { "files[]": t } : t, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (e.setContentType("application/json", !1), function(o) {
    if (y.isString(o)) try {
      return (0, JSON.parse)(o), y.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(t)) : t;
}], transformResponse: [function(t) {
  const e = this.transitional || ni.transitional, n = e && e.forcedJSONParsing, r = this.responseType === "json";
  if (y.isResponse(t) || y.isReadableStream(t)) return t;
  if (t && y.isString(t) && (n && !this.responseType || r)) {
    const s = !(e && e.silentJSONParsing) && r;
    try {
      return JSON.parse(t, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? ee.from(i, ee.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return t;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: ze.classes.FormData, Blob: ze.classes.Blob }, validateStatus: function(t) {
  return t >= 200 && t < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
y.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  ni.headers[t] = {};
});
const ri = ni, Al = y.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Ji = Symbol("internals");
function On(t) {
  return t && String(t).trim().toLowerCase();
}
function hr(t) {
  return t === !1 || t == null ? t : y.isArray(t) ? t.map(hr) : String(t);
}
function fs(t, e, n, r, s) {
  return y.isFunction(r) ? r.call(this, e, n) : (s && (e = n), y.isString(e) ? y.isString(r) ? e.indexOf(r) !== -1 : y.isRegExp(r) ? r.test(e) : void 0 : void 0);
}
let pr = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = On(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = y.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = hr(a));
    }
    const o = (a, u) => y.forEach(a, (c, l) => i(c, l, u));
    if (y.isPlainObject(e) || e instanceof this.constructor) o(e, n);
    else if (y.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && Al[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(e), n);
    else if (y.isObject(e) && y.isIterable(e)) {
      let a, u, c = {};
      for (const l of e) {
        if (!y.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? y.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = On(e)) {
      const r = y.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (y.isFunction(n)) return n.call(this, s, r);
        if (y.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = On(e)) {
      const r = y.findKey(this, e);
      return !(!r || this[r] === void 0 || n && !fs(0, this[r], r, n));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = On(o)) {
        const a = y.findKey(r, o);
        !a || n && !fs(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return y.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      e && !fs(0, this[i], i, e, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return y.forEach(this, (s, i) => {
      const o = y.findKey(r, i);
      if (o) return n[o] = hr(s), void delete n[i];
      const a = e ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = hr(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return y.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && y.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const n = (this[Ji] = this[Ji] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = On(i);
      n[o] || (function(a, u) {
        const c = y.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, h) {
            return this[l].call(this, u, d, f, h);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return y.isArray(e) ? e.forEach(s) : s(e), this;
  }
};
pr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), y.reduceDescriptors(pr.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return { get: () => t, set(r) {
    this[n] = r;
  } };
}), y.freezeMethods(pr);
const ht = pr;
function hs(t, e) {
  const n = this || ri, r = e || n, s = ht.from(r.headers);
  let i = r.data;
  return y.forEach(t, function(o) {
    i = o.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function Da(t) {
  return !(!t || !t.__CANCEL__);
}
function Fa(t, e, n) {
  ee.call(this, t ?? "canceled", ee.ERR_CANCELED, e, n), this.name = "CanceledError";
}
y.inherits(Fa, ee, { __CANCEL__: !0 });
const Gn = Fa;
function $a(t, e, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? e(new ee("Request failed with status code " + n.status, [ee.ERR_BAD_REQUEST, ee.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
}
const Lr = (t, e, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const h = Date.now(), v = u[d];
      c || (c = h), a[l] = f, u[l] = h;
      let p = d, _ = 0;
      for (; p !== l; ) _ += a[p++], p %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), h - c < o) return;
      const K = v && h - v;
      return K ? Math.round(1e3 * _ / K) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, h = Date.now()) => {
      c = h, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const h = Date.now(), v = h - c;
      v >= l ? d(f, h) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, t({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [e ? "download" : "upload"]: !0 });
  }, n);
}, Gi = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({ lengthComputable: n, total: t, loaded: r }), e[1]];
}, Vi = (t) => (...e) => y.asap(() => t(...e)), Ul = ze.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, ze.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(new URL(ze.origin), ze.navigator && /(msie|trident)/i.test(ze.navigator.userAgent)) : () => !0, Ll = ze.hasStandardBrowserEnv ? { write(t, e, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${t}=${encodeURIComponent(e)}`];
  y.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), y.isString(r) && a.push(`path=${r}`), y.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), y.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(t) {
  if (typeof document > "u") return null;
  const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
  return e ? decodeURIComponent(e[1]) : null;
}, remove(t) {
  this.write(t, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function Ba(t, e, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  return t && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(t, e) : e;
}
const Ki = (t) => t instanceof ht ? { ...t } : t;
function Wt(t, e) {
  e = e || {};
  const n = {};
  function r(c, l, d, f) {
    return y.isPlainObject(c) && y.isPlainObject(l) ? y.merge.call({ caseless: f }, c, l) : y.isPlainObject(l) ? y.merge({}, l) : y.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!y.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return y.isUndefined(l) ? y.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in e ? r(c, l) : d in t ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(Ki(c), Ki(l), 0, !0) };
  return y.forEach(Object.keys({ ...t, ...e }), function(c) {
    const l = u[c] || s, d = l(t[c], e[c], c);
    y.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const Ma = (t) => {
  const e = Wt({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  if (e.headers = o = ht.from(o), e.url = Ua(Ba(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), y.isFormData(n)) {
    if (ze.hasStandardBrowserEnv || ze.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (y.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (ze.hasStandardBrowserEnv && (r && y.isFunction(r) && (r = r(e)), r || r !== !1 && Ul(e.url))) {
    const u = s && i && Ll.read(i);
    u && o.set(s, u);
  }
  return e;
}, Nl = typeof XMLHttpRequest < "u" && function(t) {
  return new Promise(function(e, n) {
    const r = Ma(t);
    let s = r.data;
    const i = ht.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: h } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let p = new XMLHttpRequest();
    function _() {
      if (!p) return;
      const T = ht.from("getAllResponseHeaders" in p && p.getAllResponseHeaders());
      $a(function(V) {
        e(V), v();
      }, function(V) {
        n(V), v();
      }, { data: d && d !== "text" && d !== "json" ? p.response : p.responseText, status: p.status, statusText: p.statusText, headers: T, config: t, request: p }), p = null;
    }
    p.open(r.method.toUpperCase(), r.url, !0), p.timeout = r.timeout, "onloadend" in p ? p.onloadend = _ : p.onreadystatechange = function() {
      p && p.readyState === 4 && (p.status !== 0 || p.responseURL && p.responseURL.indexOf("file:") === 0) && setTimeout(_);
    }, p.onabort = function() {
      p && (n(new ee("Request aborted", ee.ECONNABORTED, t, p)), p = null);
    }, p.onerror = function(T) {
      const V = T && T.message ? T.message : "Network Error", M = new ee(V, ee.ERR_NETWORK, t, p);
      M.event = T || null, n(M), p = null;
    }, p.ontimeout = function() {
      let T = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const V = r.transitional || La;
      r.timeoutErrorMessage && (T = r.timeoutErrorMessage), n(new ee(T, V.clarifyTimeoutError ? ee.ETIMEDOUT : ee.ECONNABORTED, t, p)), p = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in p && y.forEach(i.toJSON(), function(T, V) {
      p.setRequestHeader(V, T);
    }), y.isUndefined(r.withCredentials) || (p.withCredentials = !!r.withCredentials), d && d !== "json" && (p.responseType = r.responseType), h && ([u, l] = Lr(h, !0), p.addEventListener("progress", u)), f && p.upload && ([a, c] = Lr(f), p.upload.addEventListener("progress", a), p.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (T) => {
      p && (n(!T || T.type ? new Gn(null, t, p) : T), p.abort(), p = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const K = function(T) {
      const V = /^([-+\w]{1,25})(:?\/\/|:)/.exec(T);
      return V && V[1] || "";
    }(r.url);
    K && ze.protocols.indexOf(K) === -1 ? n(new ee("Unsupported protocol " + K + ":", ee.ERR_BAD_REQUEST, t)) : p.send(s || null);
  });
}, Dl = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof ee ? l : new Gn(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new ee(`timeout ${e} of ms exceeded`, ee.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => y.asap(a), u;
  }
}, Fl = function* (t, e) {
  let n = t.byteLength;
  if (n < e) return void (yield t);
  let r, s = 0;
  for (; s < n; ) r = s + e, yield t.slice(s, r), s = r;
}, Yi = (t, e, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: h, value: v } = await f.read();
          if (h) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* Fl(l, c);
  }(t, e);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: er } = y, $l = (({ Request: t, Response: e }) => ({ Request: t, Response: e }))(y.global), { ReadableStream: Xi, TextEncoder: Qi } = y.global, eo = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Bl = (t) => {
  t = y.merge.call({ skipUndefined: !0 }, $l, t);
  const { fetch: e, Request: n, Response: r } = t, s = e ? er(e) : typeof fetch == "function", i = er(n), o = er(r);
  if (!s) return !1;
  const a = s && er(Xi), u = s && (typeof Qi == "function" ? (c = new Qi(), (h) => c.encode(h)) : async (h) => new Uint8Array(await new n(h).arrayBuffer()));
  var c;
  const l = i && a && eo(() => {
    let h = !1;
    const v = new n(ze.origin, { body: new Xi(), method: "POST", get duplex() {
      return h = !0, "half";
    } }).headers.has("Content-Type");
    return h && !v;
  }), d = o && a && eo(() => y.isReadableStream(new r("").body)), f = { stream: d && ((h) => h.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (v, p) => {
      let _ = v && v[h];
      if (_) return _.call(v);
      throw new ee(`Response type '${h}' is not supported`, ee.ERR_NOT_SUPPORT, p);
    });
  }), async (h) => {
    let { url: v, method: p, data: _, signal: K, cancelToken: T, timeout: V, onDownloadProgress: M, onUploadProgress: ie, responseType: Q, headers: De, withCredentials: Ee = "same-origin", fetchOptions: Ye } = Ma(h), at = e || fetch;
    Q = Q ? (Q + "").toLowerCase() : "text";
    let he = Dl([K, T && T.toAbortSignal()], V), Fe = null;
    const fe = he && he.unsubscribe && (() => {
      he.unsubscribe();
    });
    let ae;
    try {
      if (ie && l && p !== "get" && p !== "head" && (ae = await (async (_e, Oe) => {
        const $e = y.toFiniteNumber(_e.getContentLength());
        return $e ?? (async (Y) => Y == null ? 0 : y.isBlob(Y) ? Y.size : y.isSpecCompliantForm(Y) ? (await new n(ze.origin, { method: "POST", body: Y }).arrayBuffer()).byteLength : y.isArrayBufferView(Y) || y.isArrayBuffer(Y) ? Y.byteLength : (y.isURLSearchParams(Y) && (Y += ""), y.isString(Y) ? (await u(Y)).byteLength : void 0))(Oe);
      })(De, _)) !== 0) {
        let _e, Oe = new n(v, { method: "POST", body: _, duplex: "half" });
        if (y.isFormData(_) && (_e = Oe.headers.get("content-type")) && De.setContentType(_e), Oe.body) {
          const [$e, Y] = Gi(ae, Lr(Vi(ie)));
          _ = Yi(Oe.body, 65536, $e, Y);
        }
      }
      y.isString(Ee) || (Ee = Ee ? "include" : "omit");
      const ce = i && "credentials" in n.prototype, Qe = { ...Ye, signal: he, method: p.toUpperCase(), headers: De.normalize().toJSON(), body: _, duplex: "half", credentials: ce ? Ee : void 0 };
      Fe = i && new n(v, Qe);
      let je = await (i ? at(Fe, Ye) : at(v, Qe));
      const vt = d && (Q === "stream" || Q === "response");
      if (d && (M || vt && fe)) {
        const _e = {};
        ["status", "statusText", "headers"].forEach((pe) => {
          _e[pe] = je[pe];
        });
        const Oe = y.toFiniteNumber(je.headers.get("content-length")), [$e, Y] = M && Gi(Oe, Lr(Vi(M), !0)) || [];
        je = new r(Yi(je.body, 65536, $e, () => {
          Y && Y(), fe && fe();
        }), _e);
      }
      Q = Q || "text";
      let Tt = await f[y.findKey(f, Q) || "text"](je, h);
      return !vt && fe && fe(), await new Promise((_e, Oe) => {
        $a(_e, Oe, { data: Tt, headers: ht.from(je.headers), status: je.status, statusText: je.statusText, config: h, request: Fe });
      });
    } catch (ce) {
      throw fe && fe(), ce && ce.name === "TypeError" && /Load failed|fetch/i.test(ce.message) ? Object.assign(new ee("Network Error", ee.ERR_NETWORK, h, Fe), { cause: ce.cause || ce }) : ee.from(ce, ce && ce.code, h, Fe);
    }
  };
}, Ml = /* @__PURE__ */ new Map(), to = (t) => {
  let e = t && t.env || {};
  const { fetch: n, Request: r, Response: s } = e, i = [r, s, n];
  let o, a, u = i.length, c = Ml;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : Bl(e)), c = a;
  return a;
}, za = (to(), { http: null, xhr: Nl, fetch: { get: to } });
y.forEach(za, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const no = (t) => `- ${t}`, zl = (t) => y.isFunction(t) || t === null || t === !1, qa = function(t, e) {
  t = y.isArray(t) ? t : [t];
  const { length: n } = t;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = t[o], s = r, !zl(r) && (s = za[(a = String(r)).toLowerCase()], s === void 0)) throw new ee(`Unknown adapter '${a}'`);
    if (s && (y.isFunction(s) || (s = s.get(e)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(no).join(`
`) : " " + no(o[0]) : "as no adapter specified";
    throw new ee("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function ps(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new Gn(null, t);
}
function ro(t) {
  return ps(t), t.headers = ht.from(t.headers), t.data = hs.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), qa(t.adapter || ri.adapter, t)(t).then(function(e) {
    return ps(t), e.data = hs.call(t, t.transformResponse, e), e.headers = ht.from(e.headers), e;
  }, function(e) {
    return Da(e) || (ps(t), e && e.response && (e.response.data = hs.call(t, t.transformResponse, e.response), e.response.headers = ht.from(e.response.headers))), Promise.reject(e);
  });
}
const Ha = "1.13.2", Nr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Nr[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const so = {};
Nr.transitional = function(t, e, n) {
  function r(s, i) {
    return "[Axios v" + Ha + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (t === !1) throw new ee(r(i, " has been removed" + (e ? " in " + e : "")), ee.ERR_DEPRECATED);
    return e && !so[i] && (so[i] = !0, console.warn(r(i, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(s, i, o);
  };
}, Nr.spelling = function(t) {
  return (e, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
const mr = { assertOptions: function(t, e, n) {
  if (typeof t != "object") throw new ee("options must be an object", ee.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], u = a === void 0 || o(a, i, t);
      if (u !== !0) throw new ee("option " + i + " must be " + u, ee.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new ee("Unknown option " + i, ee.ERR_BAD_OPTION);
  }
}, validators: Nr }, yt = mr.validators;
let gr = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = { request: new Wi(), response: new Wi() };
  }
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}).url = e : n = e || {}, n = Wt(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && mr.assertOptions(r, { silentJSONParsing: yt.transitional(yt.boolean), forcedJSONParsing: yt.transitional(yt.boolean), clarifyTimeoutError: yt.transitional(yt.boolean) }, !1), s != null && (y.isFunction(s) ? n.paramsSerializer = { serialize: s } : mr.assertOptions(s, { encode: yt.function, serialize: yt.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), mr.assertOptions(n, { baseUrl: yt.spelling("baseURL"), withXsrfToken: yt.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && y.merge(i.common, i[n.method]);
    i && y.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = ht.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [ro.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let h = n;
    for (; f < d; ) {
      const v = a[f++], p = a[f++];
      try {
        h = v(h);
      } catch (_) {
        p.call(this, _);
        break;
      }
    }
    try {
      l = ro.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(e) {
    return Ua(Ba((e = Wt(this.defaults, e)).baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
  }
};
y.forEach(["delete", "get", "head", "options"], function(t) {
  gr.prototype[t] = function(e, n) {
    return this.request(Wt(n || {}, { method: t, url: e, data: (n || {}).data }));
  };
}), y.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(r, s, i) {
      return this.request(Wt(i || {}, { method: t, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  gr.prototype[t] = e(), gr.prototype[t + "Form"] = e(!0);
});
const vr = gr;
let ql = class Za {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(s, i, o) {
      r.reason || (r.reason = new Gn(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  static source() {
    let e;
    return { token: new Za(function(n) {
      e = n;
    }), cancel: e };
  }
};
const Hl = ql, As = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(As).forEach(([t, e]) => {
  As[e] = t;
});
const Zl = As, Ue = function t(e) {
  const n = new vr(e), r = Ca(vr.prototype.request, n);
  return y.extend(r, vr.prototype, n, { allOwnKeys: !0 }), y.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return t(Wt(e, s));
  }, r;
}(ri);
Ue.Axios = vr, Ue.CanceledError = Gn, Ue.CancelToken = Hl, Ue.isCancel = Da, Ue.VERSION = Ha, Ue.toFormData = Ur, Ue.AxiosError = ee, Ue.Cancel = Ue.CanceledError, Ue.all = function(t) {
  return Promise.all(t);
}, Ue.spread = function(t) {
  return function(e) {
    return t.apply(null, e);
  };
}, Ue.isAxiosError = function(t) {
  return y.isObject(t) && t.isAxiosError === !0;
}, Ue.mergeConfig = Wt, Ue.AxiosHeaders = ht, Ue.formToJSON = (t) => Na(y.isHTMLForm(t) ? new FormData(t) : t), Ue.getAdapter = qa, Ue.HttpStatusCode = Zl, Ue.default = Ue;
const ve = Ue;
function Wa(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Us(t, e, n) {
  return Us = si() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && zn(a, i.prototype), a;
  }, Us.apply(null, arguments);
}
function yr(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Mn(t) {
  return Mn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Mn(t);
}
function zn(t, e) {
  return zn = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, zn(t, e);
}
function Ls(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Ls = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(n)) return e.get(n);
      e.set(n, s);
    }
    function s() {
      return Us(n, arguments, Mn(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), zn(s, n);
  }, Ls(t);
}
function si() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (si = function() {
    return !!t;
  })();
}
var ye = "http://localhost".replace(/\/+$/, ""), gn = function t(e) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ye, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ve;
  Wa(this, t), yr(this, "basePath", void 0), yr(this, "axios", void 0), yr(this, "configuration", void 0), this.basePath = r, this.axios = s, e && (this.configuration = e, this.basePath = (n = e.basePath) !== null && n !== void 0 ? n : r);
}, Wl = function() {
  function t(e, n) {
    var r;
    return Wa(this, t), yr(r = function(s, i, o) {
      return i = Mn(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, si() ? Reflect.construct(i, o || [], Mn(s).constructor) : i.apply(s, o));
    }(this, t, [n]), "field", void 0), r.field = e, r.name = "RequiredError", r;
  }
  return function(e, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && zn(e, n);
  }(t, Ls(Error)), t;
}(), be = {};
function io(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function Jl(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var we = "https://example.com", ge = function(t, e, n) {
  if (n == null) throw new Wl(e, "Required parameter ".concat(e, " was null or undefined when calling ").concat(t, "."));
}, Ie = function(t, e) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(h) {
        return function(v) {
          return function(p) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, p[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & p[0] ? u.return : p[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, p[1])).done) return c;
              switch (u = 0, c && (p = [2 & p[0], c.value]), p[0]) {
                case 0:
                case 1:
                  c = p;
                  break;
                case 4:
                  return l.label++, { value: p[1], done: !1 };
                case 5:
                  l.label++, u = p[1], p = [0];
                  continue;
                case 7:
                  p = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || p[0] !== 6 && p[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (p[0] === 3 && (!c || p[1] > c[0] && p[1] < c[3])) {
                    l.label = p[1];
                    break;
                  }
                  if (p[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = p;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(p);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              p = o.call(i, l);
            } catch (_) {
              p = [6, _], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & p[0]) throw p[1];
            return { value: p[0] ? p[1] : void 0, done: !0 };
          }([h, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return e && e.accessToken ? typeof e.accessToken != "function" ? [3, 2] : [4, e.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, e.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, t.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        io(a, i, o, u, c, "next", l);
      }
      function c(l) {
        io(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function Ns(t, e) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  e != null && ((e === void 0 ? "undefined" : (n = e) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(e) ? e.forEach(function(s) {
    return Ns(t, s, r);
  }) : Object.keys(e).forEach(function(s) {
    return Ns(t, e[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
var xe = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(t.search);
  Ns(s, n), t.search = s.toString();
}, It = function(t, e, n) {
  var r = typeof t != "string";
  return (r && n && n.isJsonMime ? n.isJsonMime(e.headers["Content-Type"]) : r) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, Se = function(t) {
  return t.pathname + t.search + t.hash;
}, Re = function(t, e, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, h = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (h = h.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), h.forEach(function(v) {
          Jl(l, v, f[v]);
        });
      }
      return l;
    }({}, t.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + t.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function oo(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function q(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, s) {
      var i = t.apply(e, n);
      function o(u) {
        oo(i, r, s, o, a, "next", u);
      }
      function a(u) {
        oo(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function vn(t, e, n) {
  return e = Dr(e), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(t, Ja() ? Reflect.construct(e, n || [], Dr(t).constructor) : e.apply(t, n));
}
function yn(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Gl(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function bn(t, e, n) {
  return e && Gl(t.prototype, e), t;
}
function Vl(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Dr(t) {
  return Dr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Dr(t);
}
function wn(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ds(t, e);
}
function z(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Vl(t, s, n[s]);
    });
  }
  return t;
}
function Ds(t, e) {
  return Ds = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Ds(t, e);
}
function Ja() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ja = function() {
    return !!t;
  })();
}
function H(t, e) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = e.call(t, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var Kl = function(t) {
  return { publicScoreSheetsConfigGet: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return q(function() {
      var n, r, s, i, o;
      return H(this, function(a) {
        return n = new URL("/public/score-sheets/config", we), t && (r = t.baseOptions), s = z({ method: "GET" }, r, e), i = {}, xe(n, {}), o = r && r.headers ? r.headers : {}, s.headers = z({}, i, o, e.headers), [2, { url: Se(n), options: s }];
      });
    })();
  }, publicScoreSheetsRequestPost: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        return ge("publicScoreSheetsRequestPost", "publicScoreSheetsRequestPostRequest", e), r = new URL("/public/score-sheets/request", we), t && (s = t.baseOptions), i = z({ method: "POST" }, s, n), a = {}, (o = {})["Content-Type"] = "application/json", xe(r, a), u = s && s.headers ? s.headers : {}, i.headers = z({}, o, u, n.headers), i.data = It(e, i, t), [2, { url: Se(r), options: i }];
      });
    })();
  }, publicScoreSheetsTokenGet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        return ge("publicScoreSheetsTokenGet", "token", e), r = "/public/score-sheets/{token}".replace("{token}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, n), a = {}, xe(s, {}), u = i && i.headers ? i.headers : {}, o.headers = z({}, a, u, n.headers), [2, { url: Se(s), options: o }];
      });
    })();
  } };
}, ms = function(t) {
  var e = Kl(t);
  return { publicScoreSheetsConfigGet: function(n) {
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.publicScoreSheetsConfigGet(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = be["DefaultApi.publicScoreSheetsConfigGet"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return Re(i, ve, ye, t)(l, u || d);
            }];
        }
      });
    })();
  }, publicScoreSheetsRequestPost: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.publicScoreSheetsRequestPost(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["DefaultApi.publicScoreSheetsRequestPost"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, publicScoreSheetsTokenGet: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.publicScoreSheetsTokenGet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["DefaultApi.publicScoreSheetsTokenGet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return yn(this, e), vn(this, e, arguments);
  }
  return wn(e, t), bn(e, [{ key: "publicScoreSheetsConfigGet", value: function(n) {
    var r = this;
    return ms(this.configuration).publicScoreSheetsConfigGet(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }, { key: "publicScoreSheetsRequestPost", value: function(n, r) {
    var s = this;
    return ms(this.configuration).publicScoreSheetsRequestPost(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "publicScoreSheetsTokenGet", value: function(n, r) {
    var s = this;
    return ms(this.configuration).publicScoreSheetsTokenGet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
})(gn);
var Yl = function(t) {
  return { correctUsefClass: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("correctUsefClass", "classId", e), ge("correctUsefClass", "uploadUsefClassRequest", n), s = "/federation/usef/classes/{classId}/correct".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, deleteUsefClass: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("deleteUsefClass", "classId", e), ge("deleteUsefClass", "deleteUsefClassRequest", n), s = "/federation/usef/classes/{classId}/delete".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, finalizeUsefClass: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("finalizeUsefClass", "classId", e), ge("finalizeUsefClass", "deleteUsefClassRequest", n), s = "/federation/usef/classes/{classId}/finalize".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, getFederationClassAudit: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("getFederationClassAudit", "classId", e), r = "/federation/classes/{classId}/audit".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, getFederationShowAudit: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("getFederationShowAudit", "showId", e), r = "/federation/shows/{showId}/audit".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, getFederationShowState: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("getFederationShowState", "showId", e), r = "/federation/shows/{showId}/state".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("getUsefDeadlineStatus", "competitionEndDate", e), s = new URL("/federation/usef/deadline", we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, r), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.competitionEndDate = e), n !== void 0 && (u.showId = n), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, r.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, listUsefDressageSections: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        switch (c.label) {
          case 0:
            return ge("listUsefDressageSections", "compYear", e), r = new URL("/federation/usef/sections", we), t && (s = t.baseOptions), i = z({ method: "GET" }, s, n), a = {}, [4, Ie(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.compYear = e), xe(r, a), u = s && s.headers ? s.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(r), options: i }];
        }
      });
    })();
  }, listUsefDressageTests: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        switch (c.label) {
          case 0:
            return ge("listUsefDressageTests", "testYear", e), r = new URL("/federation/usef/tests", we), t && (s = t.baseOptions), i = z({ method: "GET" }, s, n), a = {}, [4, Ie(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.testYear = e), xe(r, a), u = s && s.headers ? s.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(r), options: i }];
        }
      });
    })();
  }, previewClassResult: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("previewClassResult", "classId", e), r = "/federation/classes/{classId}/preview".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, previewShowResults: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("previewShowResults", "showId", e), r = "/federation/shows/{showId}/preview".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, publishUsdfShow: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("publishUsdfShow", "showId", e), ge("publishUsdfShow", "publishUsdfShowRequest", n), s = "/federation/usdf/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, publishUsefShow: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("publishUsefShow", "showId", e), ge("publishUsefShow", "publishUsefShowRequest", n), s = "/federation/usef/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, uploadUsefClass: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("uploadUsefClass", "classId", e), ge("uploadUsefClass", "uploadUsefClassRequest", n), s = "/federation/usef/classes/{classId}/upload".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  } };
}, Ge = function(t) {
  var e = Yl(t);
  return { correctUsefClass: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.correctUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.correctUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  }, deleteUsefClass: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.deleteUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.deleteUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  }, finalizeUsefClass: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.finalizeUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.finalizeUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  }, getFederationClassAudit: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getFederationClassAudit(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.getFederationClassAudit"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, getFederationShowAudit: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getFederationShowAudit(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.getFederationShowAudit"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, getFederationShowState: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getFederationShowState(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.getFederationShowState"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.getUsefDeadlineStatus(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.getUsefDeadlineStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  }, listUsefDressageSections: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listUsefDressageSections(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.listUsefDressageSections"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, listUsefDressageTests: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listUsefDressageTests(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.listUsefDressageTests"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, previewClassResult: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.previewClassResult(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.previewClassResult"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, previewShowResults: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.previewShowResults(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["FederationApi.previewShowResults"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, publishUsdfShow: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.publishUsdfShow(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.publishUsdfShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  }, publishUsefShow: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.publishUsefShow(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.publishUsefShow"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  }, uploadUsefClass: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.uploadUsefClass(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["FederationApi.uploadUsefClass"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return yn(this, e), vn(this, e, arguments);
  }
  return wn(e, t), bn(e, [{ key: "correctUsefClass", value: function(n, r, s) {
    var i = this;
    return Ge(this.configuration).correctUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteUsefClass", value: function(n, r, s) {
    var i = this;
    return Ge(this.configuration).deleteUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "finalizeUsefClass", value: function(n, r, s) {
    var i = this;
    return Ge(this.configuration).finalizeUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getFederationClassAudit", value: function(n, r) {
    var s = this;
    return Ge(this.configuration).getFederationClassAudit(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getFederationShowAudit", value: function(n, r) {
    var s = this;
    return Ge(this.configuration).getFederationShowAudit(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getFederationShowState", value: function(n, r) {
    var s = this;
    return Ge(this.configuration).getFederationShowState(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getUsefDeadlineStatus", value: function(n, r, s) {
    var i = this;
    return Ge(this.configuration).getUsefDeadlineStatus(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listUsefDressageSections", value: function(n, r) {
    var s = this;
    return Ge(this.configuration).listUsefDressageSections(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listUsefDressageTests", value: function(n, r) {
    var s = this;
    return Ge(this.configuration).listUsefDressageTests(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "previewClassResult", value: function(n, r) {
    var s = this;
    return Ge(this.configuration).previewClassResult(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "previewShowResults", value: function(n, r) {
    var s = this;
    return Ge(this.configuration).previewShowResults(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "publishUsdfShow", value: function(n, r, s) {
    var i = this;
    return Ge(this.configuration).publishUsdfShow(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "publishUsefShow", value: function(n, r, s) {
    var i = this;
    return Ge(this.configuration).publishUsefShow(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "uploadUsefClass", value: function(n, r, s) {
    var i = this;
    return Ge(this.configuration).uploadUsefClass(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(gn);
var Xl = function(t) {
  return { getHealth: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return q(function() {
      var n, r, s, i, o;
      return H(this, function(a) {
        return n = new URL("/health", we), t && (r = t.baseOptions), s = z({ method: "GET" }, r, e), i = {}, xe(n, {}), o = r && r.headers ? r.headers : {}, s.headers = z({}, i, o, e.headers), [2, { url: Se(n), options: s }];
      });
    })();
  } };
}, Ql = function(t) {
  var e = Xl(t);
  return { getHealth: function(n) {
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = be["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return Re(i, ve, ye, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return yn(this, e), vn(this, e, arguments);
  }
  return wn(e, t), bn(e, [{ key: "getHealth", value: function(n) {
    var r = this;
    return Ql(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(gn);
var ed = function(t) {
  return { createReportRun: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("createReportRun", "id", e), s = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  }, listReports: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/reports", we), t && (s = t.baseOptions), i = z({ method: "GET" }, s, n), a = {}, [4, Ie(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.domain = e), xe(r, a), u = s && s.headers ? s.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(r), options: i }];
        }
      });
    })();
  } };
}, ao = function(t) {
  var e = ed(t);
  return { createReportRun: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.createReportRun(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["ReportsApi.createReportRun"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  }, listReports: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listReports(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["ReportsApi.listReports"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  } };
}, td = function(t) {
  function e() {
    return yn(this, e), vn(this, e, arguments);
  }
  return wn(e, t), bn(e, [{ key: "createReportRun", value: function(n, r, s) {
    var i = this;
    return ao(this.configuration).createReportRun(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listReports", value: function(n, r) {
    var s = this;
    return ao(this.configuration).listReports(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
}(gn), nd = function(t) {
  return { resendScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return q(function() {
      var s, i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return ge("resendScoreSheet", "rideId", e), s = "/score-sheets/rides/{rideId}/resend".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, we), t && (o = t.baseOptions), a = z({ method: "POST" }, o, r), c = {}, [4, Ie(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", xe(i, c), l = o && o.headers ? o.headers : {}, a.headers = z({}, u, l, r.headers), a.data = It(n, a, t), [2, { url: Se(i), options: a }];
        }
      });
    })();
  } };
}, rd = function(t) {
  var e = nd(t);
  return { resendScoreSheet: function(n, r, s) {
    return q(function() {
      var i, o, a, u, c, l;
      return H(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.resendScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = be["RiderSheetsApi.resendScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return Re(a, ve, ye, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return yn(this, e), vn(this, e, arguments);
  }
  return wn(e, t), bn(e, [{ key: "resendScoreSheet", value: function(n, r, s) {
    var i = this;
    return rd(this.configuration).resendScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(gn);
var sd = function(t) {
  return { clearRuns: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", we), t && (s = t.baseOptions), i = z({ method: "DELETE" }, s, n), a = {}, [4, Ie(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.reportId = e), xe(r, a), u = s && s.headers ? s.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(r), options: i }];
        }
      });
    })();
  }, deleteRun: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("deleteRun", "id", e), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "DELETE" }, i, n), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, getRun: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return ge("getRun", "id", e), r = "/runs/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, we), t && (i = t.baseOptions), o = z({ method: "GET" }, i, n), u = {}, [4, Ie(a = {}, t)];
          case 1:
            return l.sent(), xe(s, u), c = i && i.headers ? i.headers : {}, o.headers = z({}, a, c, n.headers), [2, { url: Se(s), options: o }];
        }
      });
    })();
  }, listRuns: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return q(function() {
      var r, s, i, o, a, u;
      return H(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/runs", we), t && (s = t.baseOptions), i = z({ method: "GET" }, s, n), a = {}, [4, Ie(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.reportId = e), xe(r, a), u = s && s.headers ? s.headers : {}, i.headers = z({}, o, u, n.headers), [2, { url: Se(r), options: i }];
        }
      });
    })();
  } };
}, tr = function(t) {
  var e = sd(t);
  return { clearRuns: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.clearRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.clearRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, deleteRun: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.deleteRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRun: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRun(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.getRun"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRuns: function(n, r) {
    return q(function() {
      var s, i, o, a, u, c;
      return H(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listRuns(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = be["RunsApi.listRuns"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return Re(o, ve, ye, t)(d, c || f);
            }];
        }
      });
    })();
  } };
}, id = function(t) {
  function e() {
    return yn(this, e), vn(this, e, arguments);
  }
  return wn(e, t), bn(e, [{ key: "clearRuns", value: function(n, r) {
    var s = this;
    return tr(this.configuration).clearRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteRun", value: function(n, r) {
    var s = this;
    return tr(this.configuration).deleteRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRun", value: function(n, r) {
    var s = this;
    return tr(this.configuration).getRun(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRuns", value: function(n, r) {
    var s = this;
    return tr(this.configuration).listRuns(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
}(gn);
function od(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function kt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function uo(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      kt(t, s, n[s]);
    });
  }
  return t;
}
var ad = function() {
  function t() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), kt(this, "apiKey", void 0), kt(this, "username", void 0), kt(this, "password", void 0), kt(this, "accessToken", void 0), kt(this, "basePath", void 0), kt(this, "serverIndex", void 0), kt(this, "baseOptions", void 0), kt(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = uo({}, o.baseOptions), i = (i = { headers: uo({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var e, n;
  return e = t, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && od(e.prototype, n), t;
}();
function ud() {
  var r;
  const t = Vt(), { activeOrgId: e } = Qs(), n = (r = t.user) == null ? void 0 : r.access_token;
  return Bt(
    (s) => ({
      basePath: s,
      accessToken: n,
      baseOptions: e ? { headers: { "X-Org-Id": e } } : void 0
    }),
    [n, e]
  );
}
function cd(t) {
  const e = ud();
  return Dn(() => {
    const n = new ad(e(t));
    return {
      reports: new td(n),
      runs: new id(n)
    };
  }, [e, t]);
}
function an(t) {
  var n;
  const e = t == null ? void 0 : t.data;
  if (!e || e.status !== "success") {
    const r = ((n = e == null ? void 0 : e.data) == null ? void 0 : n.message) || (e == null ? void 0 : e.code) || "Request failed";
    throw new Error(r);
  }
  return e.data;
}
const ld = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, dd = (t) => (t == null ? void 0 : t.name) ?? "";
function fd({
  api: t,
  domain: e,
  onSelect: n,
  selectedId: r,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: s,
  labels: i = {},
  resolveReportName: o = dd
}) {
  const a = { ...ld, ...i }, [u, c] = Z([]), [l, d] = Z(!0), [f, h] = Z(null), v = Zt(!1);
  return ke(() => {
    if (v.current || !s || u.length === 0) return;
    const p = u.find((_) => _.id === s);
    p && (v.current = !0, n == null || n(p));
  }, [u, s, n]), ke(() => {
    let p = !1;
    return d(!0), h(null), t.reports.listReports(e).then((_) => {
      p || c(an(_) || []);
    }).catch((_) => {
      p || h(_.message || a.error);
    }).finally(() => {
      p || d(!1);
    }), () => {
      p = !0;
    };
  }, [t, e, a.error]), l ? /* @__PURE__ */ m.jsx(de, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Jn, { "data-testid": "report-list-loading" }) }) : f ? /* @__PURE__ */ m.jsx($n, { severity: "error", children: f }) : u.length === 0 ? /* @__PURE__ */ m.jsx(Xe, { color: "text.secondary", sx: { p: 2 }, children: a.empty }) : /* @__PURE__ */ m.jsx(ec, { "data-testid": "report-list", children: u.map((p) => /* @__PURE__ */ m.jsx(
    tc,
    {
      selected: p.id === r,
      onClick: () => n == null ? void 0 : n(p),
      children: /* @__PURE__ */ m.jsx(
        nc,
        {
          primary: o(p),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    p.id
  )) });
}
function hd(t) {
  return t.default !== void 0 ? t.default : t.type === "boolean" ? !1 : "";
}
const En = (t) => t !== "" && t !== void 0 && t !== null, pd = {
  submit: "Run report",
  required: "Required"
}, md = (t, e, n) => (n == null ? void 0 : n.title) || e;
function gd({
  def: t,
  onSubmit: e,
  submitting: n = !1,
  labels: r = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: s = {},
  fieldRenderers: i = {},
  resolveParamLabel: o = md
}) {
  var T, V;
  const a = { ...pd, ...r }, u = ((T = t == null ? void 0 : t.paramsSchema) == null ? void 0 : T.properties) || {}, c = ((V = t == null ? void 0 : t.paramsSchema) == null ? void 0 : V.required) || [], l = Object.entries(u).filter(([M]) => !En(s[M])), [d, f] = Z(() => {
    const M = {};
    for (const [ie, Q] of Object.entries(u))
      En(s[ie]) || (M[ie] = hd(Q));
    return M;
  }), [h, v] = Z(!1), p = (M, ie) => f((Q) => ({ ...Q, [M]: ie })), _ = c.filter((M) => En(s[M]) ? !1 : !En(d[M])), K = (M) => {
    if (M.preventDefault(), v(!0), _.length > 0) return;
    const ie = {};
    for (const [Q, De] of Object.entries(u)) {
      if (En(s[Q])) {
        ie[Q] = s[Q];
        continue;
      }
      const Ee = d[Q];
      Ee === "" && !c.includes(Q) || (ie[Q] = De.type === "number" || De.type === "integer" ? Number(Ee) : Ee);
    }
    e(ie);
  };
  return /* @__PURE__ */ m.jsx(de, { component: "form", onSubmit: K, noValidate: !0, children: /* @__PURE__ */ m.jsxs(ln, { spacing: 2, children: [
    l.map(([M, ie]) => {
      const Q = o(t, M, ie), De = c.includes(M), Ee = h && De && _.includes(M), Ye = i[M];
      if (Ye)
        return /* @__PURE__ */ m.jsx(Hu, { children: Ye({
          value: d[M],
          onChange: (he) => p(M, he),
          label: Q,
          required: De,
          error: Ee,
          disabled: n
        }) }, M);
      if (ie.type === "boolean")
        return /* @__PURE__ */ m.jsx(
          ua,
          {
            control: /* @__PURE__ */ m.jsx(
              ca,
              {
                color: "default",
                checked: !!d[M],
                onChange: (he) => p(M, he.target.checked)
              }
            ),
            label: Q
          },
          M
        );
      if (Array.isArray(ie.enum))
        return /* @__PURE__ */ m.jsx(
          Fn,
          {
            select: !0,
            label: Q,
            required: De,
            error: Ee,
            helperText: Ee ? a.required : ie.description,
            value: d[M] ?? "",
            onChange: (he) => p(M, he.target.value),
            fullWidth: !0,
            children: ie.enum.map((he) => /* @__PURE__ */ m.jsx(rc, { value: he, children: String(he) }, String(he)))
          },
          M
        );
      const at = ie.type === "number" || ie.type === "integer";
      return /* @__PURE__ */ m.jsx(
        Fn,
        {
          label: Q,
          type: at ? "number" : "text",
          required: De,
          error: Ee,
          helperText: Ee ? a.required : ie.description,
          value: d[M] ?? "",
          onChange: (he) => p(M, he.target.value),
          fullWidth: !0
        },
        M
      );
    }),
    /* @__PURE__ */ m.jsx(de, { children: /* @__PURE__ */ m.jsx(Ze, { type: "submit", variant: "contained", loading: n, children: a.submit }) })
  ] }) });
}
const vd = /* @__PURE__ */ new Set(["PENDING", "RUNNING"]), yd = {
  COMPLETE: "success",
  FAILED: "error",
  RUNNING: "info",
  PENDING: "warning"
};
function bd(t) {
  if (!t) return "";
  const e = new Date(t);
  return isNaN(e.getTime()) ? t : e.toLocaleString();
}
const wd = {
  empty: "No runs yet.",
  error: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  delete: "Delete"
}, xd = (t) => t;
function Sd({
  api: t,
  onView: e,
  onDelete: n,
  refreshKey: r = 0,
  labels: s = {},
  resolveReportName: i = xd
}) {
  const o = { ...wd, ...s }, [a, u] = Z([]), [c, l] = Z(!0), [d, f] = Z(null), h = Zt(null), v = Bt(async () => {
    try {
      const p = await t.runs.listRuns();
      u(an(p) || []), f(null);
    } catch (p) {
      f(p.message || o.error);
    } finally {
      l(!1);
    }
  }, [t, o.error]);
  return ke(() => {
    v();
  }, [v, r]), ke(() => {
    if (!a.some((_) => vd.has(_.status))) {
      h.current && clearInterval(h.current), h.current = null;
      return;
    }
    return h.current || (h.current = setInterval(v, 4e3)), () => {
      h.current && (clearInterval(h.current), h.current = null);
    };
  }, [a, v]), c ? /* @__PURE__ */ m.jsx(de, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Jn, { "data-testid": "run-history-loading" }) }) : d ? /* @__PURE__ */ m.jsx($n, { severity: "error", children: d }) : a.length === 0 ? /* @__PURE__ */ m.jsx(Xe, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ m.jsxs(sc, { size: "small", "data-testid": "run-history", children: [
    /* @__PURE__ */ m.jsx(ic, { children: /* @__PURE__ */ m.jsxs(ji, { children: [
      /* @__PURE__ */ m.jsx(Lt, { children: o.colReport }),
      /* @__PURE__ */ m.jsx(Lt, { children: o.colRequested }),
      /* @__PURE__ */ m.jsx(Lt, { children: o.colStatus }),
      /* @__PURE__ */ m.jsx(Lt, { align: "right", children: o.colActions })
    ] }) }),
    /* @__PURE__ */ m.jsx(oc, { children: a.map((p) => /* @__PURE__ */ m.jsxs(ji, { "data-testid": `run-row-${p.id}`, children: [
      /* @__PURE__ */ m.jsx(Lt, { sx: { color: "text.primary" }, children: i(p.reportId) }),
      /* @__PURE__ */ m.jsx(Lt, { sx: { color: "text.primary" }, children: bd(p.createdAt) }),
      /* @__PURE__ */ m.jsx(Lt, { children: /* @__PURE__ */ m.jsx(
        aa,
        {
          size: "small",
          label: p.status,
          color: yd[p.status] || "default"
        }
      ) }),
      /* @__PURE__ */ m.jsxs(Lt, { align: "right", children: [
        /* @__PURE__ */ m.jsx(
          Ze,
          {
            size: "small",
            variant: "outlined",
            color: "inherit",
            disabled: p.status !== "COMPLETE",
            onClick: () => e == null ? void 0 : e(p),
            children: o.view
          }
        ),
        n && /* @__PURE__ */ m.jsx(
          jr,
          {
            size: "small",
            color: "inherit",
            "aria-label": o.delete,
            title: o.delete,
            sx: { ml: 1 },
            onClick: () => n(p),
            children: /* @__PURE__ */ m.jsx(Ec, { fontSize: "small" })
          }
        )
      ] })
    ] }, p.id)) })
  ] });
}
const Rd = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function _d({ api: t, runId: e, height: n = 600, labels: r = {} }) {
  const s = { ...Rd, ...r }, [i, o] = Z(null), [a, u] = Z(!0), [c, l] = Z(null);
  return ke(() => {
    if (!e) return;
    let d = !1;
    return u(!0), l(null), t.runs.getRun(e).then((f) => {
      if (d) return;
      const h = an(f);
      if (h.status !== "COMPLETE" || !h.artifactUrls) {
        l(h.status === "FAILED" ? s.failed : s.notReady);
        return;
      }
      o(h.artifactUrls);
    }).catch((f) => {
      d || l(f.message || s.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [t, e, s.error, s.failed, s.notReady]), e ? a ? /* @__PURE__ */ m.jsx(de, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(Jn, { "data-testid": "report-viewer-loading" }) }) : c ? /* @__PURE__ */ m.jsx($n, { severity: "error", children: c }) : i ? /* @__PURE__ */ m.jsxs(ln, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ m.jsxs(ln, { direction: "row", spacing: 1, children: [
      i.pdf && /* @__PURE__ */ m.jsx(Ze, { variant: "outlined", href: i.pdf, target: "_blank", rel: "noopener", children: s.openPdf }),
      i.html && /* @__PURE__ */ m.jsx(Ze, { variant: "text", href: i.html, target: "_blank", rel: "noopener", children: s.openHtml })
    ] }),
    i.html && /* @__PURE__ */ m.jsx(
      de,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: s.preview,
        src: i.html,
        sx: { width: "100%", height: n, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
const Od = {
  title: "Reports",
  availableReports: "Available reports",
  runHistory: "Run history",
  reportDialogTitle: "Report",
  reportStarted: "Report started — open Run history to view it when ready.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready — or close this and find it in Run history.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded. It's also in Run history.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // #606 — clear old runs
  clearHistory: "Clear history",
  clearConfirm: "Delete all report runs for this organization? This removes the generated files too and can't be undone.",
  delete: "Delete",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // RunHistory
  noRuns: "No runs yet.",
  failedToLoadRuns: "Failed to load runs",
  colReport: "Report",
  colRequested: "Requested",
  colStatus: "Status",
  colActions: "Actions",
  view: "View",
  // ReportViewer
  runFailed: "This run failed to render.",
  runNotReady: "Report is not ready yet.",
  failedToLoadReport: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  reportPreview: "Report preview"
}, Ed = (t) => (t == null ? void 0 : t.name) ?? (t == null ? void 0 : t.id) ?? "", Td = (t, e, n) => (n == null ? void 0 : n.title) || e;
function co(t) {
  const e = document.createElement("a");
  e.href = t, e.target = "_blank", e.rel = "noopener", e.download = "", document.body.appendChild(e), e.click(), e.remove();
}
function bp({
  basePath: t,
  domain: e,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: n,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: r = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: s = {},
  paramsFieldRenderers: i = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: o,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: a = Ed,
  resolveParamLabel: u = Td
}) {
  var $e, Y;
  const c = { ...Od, ...r }, l = cd(t), [d, f] = Z(null), [h, v] = Z(!1), [p, _] = Z(null), [K, T] = Z(0), [V, M] = Z(""), [ie, Q] = Z(null), [De, Ee] = Z({});
  ke(() => {
    let pe = !1;
    return l.reports.listReports(e).then((Me) => {
      if (pe) return;
      const ut = {};
      for (const Ct of an(Me) || []) ut[Ct.id] = Ct;
      Ee(ut);
    }).catch(() => {
    }), () => {
      pe = !0;
    };
  }, [l, e]);
  const Ye = (pe) => {
    var Me;
    return a({ id: pe, name: (Me = De[pe]) == null ? void 0 : Me.name });
  }, [at, he] = Z(!1), [Fe, fe] = Z(null), [ae, ce] = Z(null), Qe = Zt(!1), je = async (pe) => {
    if (d) {
      v(!0), _(null);
      try {
        const Me = an(await l.reports.createReportRun(d.id, { params: pe }));
        T((ut) => ut + 1), f(null), Qe.current = !1, ce(Me), fe(Me.id);
      } catch (Me) {
        _(Me.message || c.failedToStart);
      } finally {
        v(!1);
      }
    }
  };
  ke(() => {
    if (!Fe) return;
    let pe = !1, Me;
    const ut = async () => {
      var Ct, Mt;
      try {
        const ct = an(await l.runs.getRun(Fe));
        if (pe) return;
        if (ce(ct), ct.status === "COMPLETE") {
          T((Qr) => Qr + 1);
          const jt = ((Ct = ct.artifactUrls) == null ? void 0 : Ct.pdf) || ((Mt = ct.artifactUrls) == null ? void 0 : Mt.html);
          jt && !Qe.current && (Qe.current = !0, co(jt));
          return;
        }
        if (ct.status === "FAILED") {
          T((jt) => jt + 1);
          return;
        }
        Me = setTimeout(ut, 3e3);
      } catch {
        pe || ce((ct) => ({ ...ct || {}, status: "FAILED" }));
      }
    };
    return Me = setTimeout(ut, 1200), () => {
      pe = !0, clearTimeout(Me);
    };
  }, [Fe, l]);
  const [vt, Tt] = Z(!1), _e = async () => {
    if (!(typeof window < "u" && !window.confirm(c.clearConfirm))) {
      Tt(!0);
      try {
        await l.runs.clearRuns(), T((pe) => pe + 1);
      } finally {
        Tt(!1);
      }
    }
  }, Oe = async (pe) => {
    await l.runs.deleteRun(pe.id), T((Me) => Me + 1);
  };
  return /* @__PURE__ */ m.jsxs(de, { children: [
    /* @__PURE__ */ m.jsx(Xe, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: n ?? c.title }),
    /* @__PURE__ */ m.jsxs(de, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ m.jsx(de, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ m.jsx(Tr, { variant: "outlined", children: /* @__PURE__ */ m.jsxs(Cr, { children: [
        /* @__PURE__ */ m.jsx(Xe, { variant: "subtitle1", sx: { color: "text.primary" }, children: c.availableReports }),
        /* @__PURE__ */ m.jsx(
          fd,
          {
            api: l,
            domain: e,
            selectedId: d == null ? void 0 : d.id,
            autoSelectId: o,
            onSelect: f,
            labels: { empty: c.noReports, error: c.failedToLoadReports },
            resolveReportName: a
          }
        ),
        /* @__PURE__ */ m.jsx(
          Ze,
          {
            fullWidth: !0,
            variant: "text",
            sx: { mt: 1, justifyContent: "flex-start" },
            onClick: () => he(!0),
            children: c.runHistory
          }
        )
      ] }) }) }),
      /* @__PURE__ */ m.jsx(de, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: d && /* @__PURE__ */ m.jsx(Tr, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ m.jsxs(Cr, { children: [
        /* @__PURE__ */ m.jsx(Xe, { variant: "subtitle1", sx: { color: "text.primary" }, children: a(d) }),
        /* @__PURE__ */ m.jsx(ac, { sx: { my: 1 } }),
        p && /* @__PURE__ */ m.jsx($n, { severity: "error", sx: { mb: 2 }, children: p }),
        /* @__PURE__ */ m.jsx(
          gd,
          {
            def: d,
            onSubmit: je,
            submitting: h,
            labels: { submit: c.runReport, required: c.required },
            context: s,
            fieldRenderers: typeof i == "function" ? i(d) : i,
            resolveParamLabel: u
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ m.jsxs(cr, { open: at, onClose: () => he(!1), maxWidth: "md", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(os, { children: c.runHistory }),
      /* @__PURE__ */ m.jsx(lr, { children: /* @__PURE__ */ m.jsx(
        Sd,
        {
          api: l,
          refreshKey: K,
          onView: (pe) => Q(pe.id),
          onDelete: Oe,
          labels: {
            empty: c.noRuns,
            error: c.failedToLoadRuns,
            colReport: c.colReport,
            colRequested: c.colRequested,
            colStatus: c.colStatus,
            colActions: c.colActions,
            view: c.view,
            delete: c.delete
          },
          resolveReportName: Ye
        }
      ) }),
      /* @__PURE__ */ m.jsxs(Ts, { children: [
        /* @__PURE__ */ m.jsx(Ze, { color: "error", onClick: _e, disabled: vt, children: c.clearHistory }),
        /* @__PURE__ */ m.jsx(Ze, { color: "inherit", onClick: () => he(!1), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ m.jsxs(cr, { open: !!ie, onClose: () => Q(null), maxWidth: "lg", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(os, { children: c.reportDialogTitle }),
      /* @__PURE__ */ m.jsx(lr, { children: /* @__PURE__ */ m.jsx(
        _d,
        {
          api: l,
          runId: ie,
          labels: {
            failed: c.runFailed,
            notReady: c.runNotReady,
            error: c.failedToLoadReport,
            openPdf: c.openPdf,
            openHtml: c.openHtml,
            preview: c.reportPreview
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ m.jsxs(cr, { open: !!Fe, onClose: () => fe(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(os, { children: (ae == null ? void 0 : ae.status) === "COMPLETE" ? c.runningDoneTitle : (ae == null ? void 0 : ae.status) === "FAILED" ? c.runningFailedTitle : c.runningTitle }),
      /* @__PURE__ */ m.jsx(lr, { children: (ae == null ? void 0 : ae.status) === "FAILED" ? /* @__PURE__ */ m.jsx($n, { severity: "error", children: c.runFailed }) : (ae == null ? void 0 : ae.status) === "COMPLETE" ? /* @__PURE__ */ m.jsx(Xe, { sx: { color: "text.primary" }, children: c.runningDoneMessage }) : /* @__PURE__ */ m.jsxs(de, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ m.jsx(Jn, { size: 26, color: "inherit" }),
        /* @__PURE__ */ m.jsx(Xe, { sx: { color: "text.primary" }, children: c.runningMessage })
      ] }) }),
      /* @__PURE__ */ m.jsxs(Ts, { children: [
        (ae == null ? void 0 : ae.status) === "COMPLETE" && ((($e = ae.artifactUrls) == null ? void 0 : $e.pdf) || ((Y = ae.artifactUrls) == null ? void 0 : Y.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ m.jsx(
          Ze,
          {
            variant: "contained",
            onClick: () => co(ae.artifactUrls.pdf || ae.artifactUrls.html),
            children: c.download
          }
        ),
        /* @__PURE__ */ m.jsx(Ze, { color: "inherit", onClick: () => fe(null), children: c.close })
      ] })
    ] }),
    /* @__PURE__ */ m.jsx(
      uc,
      {
        open: !!V,
        autoHideDuration: 5e3,
        onClose: () => M(""),
        message: V
      }
    )
  ] });
}
var Fr = { d: (t, e) => {
  for (var n in e) Fr.o(e, n) && !Fr.o(t, n) && Object.defineProperty(t, n, { enumerable: !0, get: e[n] });
}, o: (t, e) => Object.prototype.hasOwnProperty.call(t, e), r: (t) => {
  typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
} }, Fs = {};
Fr.r(Fs), Fr.d(Fs, { hasBrowserEnv: () => ui, hasStandardBrowserEnv: () => Rf, hasStandardBrowserWebWorkerEnv: () => _f, navigator: () => Ws, origin: () => Of });
var Ga = ["C", "E", "M", "B", "H"], nr = { PENDING: "PENDING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, Va = { BLOOD: "BLOOD", LAMENESS: "LAMENESS" }, Ln = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, Cd = 10;
function gs(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var rr;
gs(rr = {}, Ln.POINTS, [{ points: 2 }, { points: 4 }, { eliminate: !0 }]), gs(rr, Ln.PERCENT_SENIOR, [{ percent: 2 }, { eliminate: !0 }]), gs(rr, Ln.PERCENT_YOUTH, [{ percent: 0.5 }, { percent: 1 }, { eliminate: !0 }]);
function bt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var dt, wt = { PERCENTAGE: "PERCENTAGE", COLLECTIVE_MARKS: "COLLECTIVE_MARKS", YOUNG_HORSE_AVERAGE: "YOUNG_HORSE_AVERAGE", YOUNG_HORSE_SUBMISSION: "YOUNG_HORSE_SUBMISSION", FEI_CHILDREN_TECHNICAL: "FEI_CHILDREN_TECHNICAL", FEI_CHILDREN_MEDIAN: "FEI_CHILDREN_MEDIAN", FREESTYLE_ARTISTIC: "FREESTYLE_ARTISTIC", FREESTYLE_HARMONY: "FREESTYLE_HARMONY", FREESTYLE_CHOREOGRAPHY: "FREESTYLE_CHOREOGRAPHY", UNRESOLVED: "UNRESOLVED" };
bt(dt = {}, wt.PERCENTAGE, "DR123.3"), bt(dt, wt.COLLECTIVE_MARKS, "DR123.3"), bt(dt, wt.YOUNG_HORSE_AVERAGE, "DR123.3 (Young Horse exception)"), bt(dt, wt.YOUNG_HORSE_SUBMISSION, "DR123.3 (Young Horse exception)"), bt(dt, wt.FEI_CHILDREN_TECHNICAL, "DR123.3 (FEI Children exception)"), bt(dt, wt.FEI_CHILDREN_MEDIAN, "DR123.3 (FEI Children exception)"), bt(dt, wt.FREESTYLE_ARTISTIC, "DR129.5"), bt(dt, wt.FREESTYLE_HARMONY, "DR129.5"), bt(dt, wt.FREESTYLE_CHOREOGRAPHY, "DR129.5"), bt(dt, wt.UNRESOLVED, "DR123.3");
var Xt = { PENDING: nr.PENDING, IN_PROGRESS: nr.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: nr.COMPLETED, FINAL: "FINAL", SCRATCHED: nr.SCRATCHED }, ue, lo;
(function(t) {
  t.assertEqual = (e) => {
  }, t.assertIs = function(e) {
  }, t.assertNever = function(e) {
    throw new Error();
  }, t.arrayToEnum = (e) => {
    const n = {};
    for (const r of e) n[r] = r;
    return n;
  }, t.getValidEnumValues = (e) => {
    const n = t.objectKeys(e).filter((s) => typeof e[e[s]] != "number"), r = {};
    for (const s of n) r[s] = e[s];
    return t.objectValues(r);
  }, t.objectValues = (e) => t.objectKeys(e).map(function(n) {
    return e[n];
  }), t.objectKeys = typeof Object.keys == "function" ? (e) => Object.keys(e) : (e) => {
    const n = [];
    for (const r in e) Object.prototype.hasOwnProperty.call(e, r) && n.push(r);
    return n;
  }, t.find = (e, n) => {
    for (const r of e) if (n(r)) return r;
  }, t.isInteger = typeof Number.isInteger == "function" ? (e) => Number.isInteger(e) : (e) => typeof e == "number" && Number.isFinite(e) && Math.floor(e) === e, t.joinValues = function(e, n = " | ") {
    return e.map((r) => typeof r == "string" ? `'${r}'` : r).join(n);
  }, t.jsonStringifyReplacer = (e, n) => typeof n == "bigint" ? n.toString() : n;
})(ue || (ue = {})), function(t) {
  t.mergeShapes = (e, n) => ({ ...e, ...n });
}(lo || (lo = {}));
const k = ue.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), Dt = (t) => {
  switch (typeof t) {
    case "undefined":
      return k.undefined;
    case "string":
      return k.string;
    case "number":
      return Number.isNaN(t) ? k.nan : k.number;
    case "boolean":
      return k.boolean;
    case "function":
      return k.function;
    case "bigint":
      return k.bigint;
    case "symbol":
      return k.symbol;
    case "object":
      return Array.isArray(t) ? k.array : t === null ? k.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? k.promise : typeof Map < "u" && t instanceof Map ? k.map : typeof Set < "u" && t instanceof Set ? k.set : typeof Date < "u" && t instanceof Date ? k.date : k.object;
    default:
      return k.unknown;
  }
}, E = ue.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class Ut extends Error {
  get errors() {
    return this.issues;
  }
  constructor(e) {
    super(), this.issues = [], this.addIssue = (r) => {
      this.issues = [...this.issues, r];
    }, this.addIssues = (r = []) => {
      this.issues = [...this.issues, ...r];
    };
    const n = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, n) : this.__proto__ = n, this.name = "ZodError", this.issues = e;
  }
  format(e) {
    const n = e || function(i) {
      return i.message;
    }, r = { _errors: [] }, s = (i) => {
      for (const o of i.issues) if (o.code === "invalid_union") o.unionErrors.map(s);
      else if (o.code === "invalid_return_type") s(o.returnTypeError);
      else if (o.code === "invalid_arguments") s(o.argumentsError);
      else if (o.path.length === 0) r._errors.push(n(o));
      else {
        let a = r, u = 0;
        for (; u < o.path.length; ) {
          const c = o.path[u];
          u === o.path.length - 1 ? (a[c] = a[c] || { _errors: [] }, a[c]._errors.push(n(o))) : a[c] = a[c] || { _errors: [] }, a = a[c], u++;
        }
      }
    };
    return s(this), r;
  }
  static assert(e) {
    if (!(e instanceof Ut)) throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, ue.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (n) => n.message) {
    const n = {}, r = [];
    for (const s of this.issues) if (s.path.length > 0) {
      const i = s.path[0];
      n[i] = n[i] || [], n[i].push(e(s));
    } else r.push(e(s));
    return { formErrors: r, fieldErrors: n };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ut.create = (t) => new Ut(t);
const $s = (t, e) => {
  let n;
  switch (t.code) {
    case E.invalid_type:
      n = t.received === k.undefined ? "Required" : `Expected ${t.expected}, received ${t.received}`;
      break;
    case E.invalid_literal:
      n = `Invalid literal value, expected ${JSON.stringify(t.expected, ue.jsonStringifyReplacer)}`;
      break;
    case E.unrecognized_keys:
      n = `Unrecognized key(s) in object: ${ue.joinValues(t.keys, ", ")}`;
      break;
    case E.invalid_union:
      n = "Invalid input";
      break;
    case E.invalid_union_discriminator:
      n = `Invalid discriminator value. Expected ${ue.joinValues(t.options)}`;
      break;
    case E.invalid_enum_value:
      n = `Invalid enum value. Expected ${ue.joinValues(t.options)}, received '${t.received}'`;
      break;
    case E.invalid_arguments:
      n = "Invalid function arguments";
      break;
    case E.invalid_return_type:
      n = "Invalid function return type";
      break;
    case E.invalid_date:
      n = "Invalid date";
      break;
    case E.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (n = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? n = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? n = `Invalid input: must end with "${t.validation.endsWith}"` : ue.assertNever(t.validation) : n = t.validation !== "regex" ? `Invalid ${t.validation}` : "Invalid";
      break;
    case E.too_small:
      n = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" || t.type === "bigint" ? `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : "Invalid input";
      break;
    case E.too_big:
      n = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : "Invalid input";
      break;
    case E.custom:
      n = "Invalid input";
      break;
    case E.invalid_intersection_types:
      n = "Intersection results could not be merged";
      break;
    case E.not_multiple_of:
      n = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case E.not_finite:
      n = "Number must be finite";
      break;
    default:
      n = e.defaultError, ue.assertNever(t);
  }
  return { message: n };
};
let jd = $s;
var P;
(function(t) {
  t.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, t.toString = (e) => typeof e == "string" ? e : e == null ? void 0 : e.message;
})(P || (P = {}));
function C(t, e) {
  const n = jd, r = ((s) => {
    const { data: i, path: o, errorMaps: a, issueData: u } = s, c = [...o, ...u.path || []], l = { ...u, path: c };
    if (u.message !== void 0) return { ...u, path: c, message: u.message };
    let d = "";
    const f = a.filter((h) => !!h).slice().reverse();
    for (const h of f) d = h(l, { data: i, defaultError: d }).message;
    return { ...u, path: c, message: d };
  })({ issueData: e, data: t.data, path: t.path, errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, n, n === $s ? void 0 : $s].filter((s) => !!s) });
  t.common.issues.push(r);
}
class We {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(e, n) {
    const r = [];
    for (const s of n) {
      if (s.status === "aborted") return G;
      s.status === "dirty" && e.dirty(), r.push(s.value);
    }
    return { status: e.value, value: r };
  }
  static async mergeObjectAsync(e, n) {
    const r = [];
    for (const s of n) {
      const i = await s.key, o = await s.value;
      r.push({ key: i, value: o });
    }
    return We.mergeObjectSync(e, r);
  }
  static mergeObjectSync(e, n) {
    const r = {};
    for (const s of n) {
      const { key: i, value: o } = s;
      if (i.status === "aborted" || o.status === "aborted") return G;
      i.status === "dirty" && e.dirty(), o.status === "dirty" && e.dirty(), i.value === "__proto__" || o.value === void 0 && !s.alwaysSet || (r[i.value] = o.value);
    }
    return { status: e.value, value: r };
  }
}
const G = Object.freeze({ status: "aborted" }), Bs = (t) => ({ status: "dirty", value: t }), tt = (t) => ({ status: "valid", value: t }), fo = (t) => t.status === "aborted", ho = (t) => t.status === "dirty", dn = (t) => t.status === "valid", $r = (t) => typeof Promise < "u" && t instanceof Promise;
class Et {
  constructor(e, n, r, s) {
    this._cachedPath = [], this.parent = e, this.data = n, this._path = r, this._key = s;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const po = (t, e) => {
  if (dn(e)) return { success: !0, data: e.value };
  if (!t.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const n = new Ut(t.common.issues);
    return this._error = n, this._error;
  } };
};
function X(t) {
  if (!t) return {};
  const { errorMap: e, invalid_type_error: n, required_error: r, description: s } = t;
  if (e && (n || r)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return e ? { errorMap: e, description: s } : { errorMap: (i, o) => {
    const { message: a } = t;
    return i.code === "invalid_enum_value" ? { message: a ?? o.defaultError } : o.data === void 0 ? { message: a ?? r ?? o.defaultError } : i.code !== "invalid_type" ? { message: o.defaultError } : { message: a ?? n ?? o.defaultError };
  }, description: s };
}
class se {
  get description() {
    return this._def.description;
  }
  _getType(e) {
    return Dt(e.data);
  }
  _getOrReturnCtx(e, n) {
    return n || { common: e.parent.common, data: e.data, parsedType: Dt(e.data), schemaErrorMap: this._def.errorMap, path: e.path, parent: e.parent };
  }
  _processInputParams(e) {
    return { status: new We(), ctx: { common: e.parent.common, data: e.data, parsedType: Dt(e.data), schemaErrorMap: this._def.errorMap, path: e.path, parent: e.parent } };
  }
  _parseSync(e) {
    const n = this._parse(e);
    if ($r(n)) throw new Error("Synchronous parse encountered promise.");
    return n;
  }
  _parseAsync(e) {
    const n = this._parse(e);
    return Promise.resolve(n);
  }
  parse(e, n) {
    const r = this.safeParse(e, n);
    if (r.success) return r.data;
    throw r.error;
  }
  safeParse(e, n) {
    const r = { common: { issues: [], async: (n == null ? void 0 : n.async) ?? !1, contextualErrorMap: n == null ? void 0 : n.errorMap }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: Dt(e) }, s = this._parseSync({ data: e, path: r.path, parent: r });
    return po(r, s);
  }
  "~validate"(e) {
    var r, s;
    const n = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: Dt(e) };
    if (!this["~standard"].async) try {
      const i = this._parseSync({ data: e, path: [], parent: n });
      return dn(i) ? { value: i.value } : { issues: n.common.issues };
    } catch (i) {
      (s = (r = i == null ? void 0 : i.message) == null ? void 0 : r.toLowerCase()) != null && s.includes("encountered") && (this["~standard"].async = !0), n.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: e, path: [], parent: n }).then((i) => dn(i) ? { value: i.value } : { issues: n.common.issues });
  }
  async parseAsync(e, n) {
    const r = await this.safeParseAsync(e, n);
    if (r.success) return r.data;
    throw r.error;
  }
  async safeParseAsync(e, n) {
    const r = { common: { issues: [], contextualErrorMap: n == null ? void 0 : n.errorMap, async: !0 }, path: (n == null ? void 0 : n.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: e, parsedType: Dt(e) }, s = this._parse({ data: e, path: r.path, parent: r }), i = await ($r(s) ? s : Promise.resolve(s));
    return po(r, i);
  }
  refine(e, n) {
    const r = (s) => typeof n == "string" || n === void 0 ? { message: n } : typeof n == "function" ? n(s) : n;
    return this._refinement((s, i) => {
      const o = e(s), a = () => i.addIssue({ code: E.custom, ...r(s) });
      return typeof Promise < "u" && o instanceof Promise ? o.then((u) => !!u || (a(), !1)) : !!o || (a(), !1);
    });
  }
  refinement(e, n) {
    return this._refinement((r, s) => !!e(r) || (s.addIssue(typeof n == "function" ? n(r, s) : n), !1));
  }
  _refinement(e) {
    return new nn({ schema: this, typeName: J.ZodEffects, effect: { type: "refinement", refinement: e } });
  }
  superRefine(e) {
    return this._refinement(e);
  }
  constructor(e) {
    this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (n) => this["~validate"](n) };
  }
  optional() {
    return $t.create(this, this._def);
  }
  nullable() {
    return pn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return Rt.create(this);
  }
  promise() {
    return qr.create(this, this._def);
  }
  or(e) {
    return Mr.create([this, e], this._def);
  }
  and(e) {
    return zr.create(this, e, this._def);
  }
  transform(e) {
    return new nn({ ...X(this._def), schema: this, typeName: J.ZodEffects, effect: { type: "transform", transform: e } });
  }
  default(e) {
    const n = typeof e == "function" ? e : () => e;
    return new qs({ ...X(this._def), innerType: this, defaultValue: n, typeName: J.ZodDefault });
  }
  brand() {
    return new Vd({ typeName: J.ZodBranded, type: this, ...X(this._def) });
  }
  catch(e) {
    const n = typeof e == "function" ? e : () => e;
    return new Hs({ ...X(this._def), innerType: this, catchValue: n, typeName: J.ZodCatch });
  }
  describe(e) {
    return new this.constructor({ ...this._def, description: e });
  }
  pipe(e) {
    return oi.create(this, e);
  }
  readonly() {
    return Zs.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const kd = /^c[^\s-]{8,}$/i, Pd = /^[0-9a-z]+$/, Id = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Ad = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ud = /^[a-z0-9_-]{21}$/i, Ld = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Nd = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, Dd = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let vs;
const Fd = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, $d = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, Bd = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Md = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, zd = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, qd = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Ka = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Hd = new RegExp(`^${Ka}$`);
function Ya(t) {
  let e = "[0-5]\\d";
  return t.precision ? e = `${e}\\.\\d{${t.precision}}` : t.precision == null && (e = `${e}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${e})${t.precision ? "+" : "?"}`;
}
function Zd(t) {
  let e = `${Ka}T${Ya(t)}`;
  const n = [];
  return n.push(t.local ? "Z?" : "Z"), t.offset && n.push("([+-]\\d{2}:?\\d{2})"), e = `${e}(${n.join("|")})`, new RegExp(`^${e}$`);
}
function Wd(t, e) {
  if (!Ld.test(t)) return !1;
  try {
    const [n] = t.split(".");
    if (!n) return !1;
    const r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), s = JSON.parse(atob(r));
    return !(typeof s != "object" || s === null || "typ" in s && (s == null ? void 0 : s.typ) !== "JWT" || !s.alg || e && s.alg !== e);
  } catch {
    return !1;
  }
}
function Jd(t, e) {
  return !(e !== "v4" && e || !$d.test(t)) || !(e !== "v6" && e || !Md.test(t));
}
class At extends se {
  _parse(e) {
    if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== k.string) {
      const o = this._getOrReturnCtx(e);
      return C(o, { code: E.invalid_type, expected: k.string, received: o.parsedType }), G;
    }
    const n = new We();
    let r;
    for (const o of this._def.checks) if (o.kind === "min") e.data.length < o.value && (r = this._getOrReturnCtx(e, r), C(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "max") e.data.length > o.value && (r = this._getOrReturnCtx(e, r), C(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !1, message: o.message }), n.dirty());
    else if (o.kind === "length") {
      const a = e.data.length > o.value, u = e.data.length < o.value;
      (a || u) && (r = this._getOrReturnCtx(e, r), a ? C(r, { code: E.too_big, maximum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }) : u && C(r, { code: E.too_small, minimum: o.value, type: "string", inclusive: !0, exact: !0, message: o.message }), n.dirty());
    } else if (o.kind === "email") Dd.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "email", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "emoji") vs || (vs = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), vs.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "emoji", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "uuid") Ad.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "uuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "nanoid") Ud.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "nanoid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid") kd.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "cuid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "cuid2") Pd.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "cuid2", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "ulid") Id.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "ulid", code: E.invalid_string, message: o.message }), n.dirty());
    else if (o.kind === "url") try {
      new URL(e.data);
    } catch {
      r = this._getOrReturnCtx(e, r), C(r, { validation: "url", code: E.invalid_string, message: o.message }), n.dirty();
    }
    else o.kind === "regex" ? (o.regex.lastIndex = 0, o.regex.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "regex", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "trim" ? e.data = e.data.trim() : o.kind === "includes" ? e.data.includes(o.value, o.position) || (r = this._getOrReturnCtx(e, r), C(r, { code: E.invalid_string, validation: { includes: o.value, position: o.position }, message: o.message }), n.dirty()) : o.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : o.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : o.kind === "startsWith" ? e.data.startsWith(o.value) || (r = this._getOrReturnCtx(e, r), C(r, { code: E.invalid_string, validation: { startsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "endsWith" ? e.data.endsWith(o.value) || (r = this._getOrReturnCtx(e, r), C(r, { code: E.invalid_string, validation: { endsWith: o.value }, message: o.message }), n.dirty()) : o.kind === "datetime" ? Zd(o).test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { code: E.invalid_string, validation: "datetime", message: o.message }), n.dirty()) : o.kind === "date" ? Hd.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { code: E.invalid_string, validation: "date", message: o.message }), n.dirty()) : o.kind === "time" ? new RegExp(`^${Ya(o)}$`).test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { code: E.invalid_string, validation: "time", message: o.message }), n.dirty()) : o.kind === "duration" ? Nd.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "duration", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "ip" ? (s = e.data, ((i = o.version) !== "v4" && i || !Fd.test(s)) && (i !== "v6" && i || !Bd.test(s)) && (r = this._getOrReturnCtx(e, r), C(r, { validation: "ip", code: E.invalid_string, message: o.message }), n.dirty())) : o.kind === "jwt" ? Wd(e.data, o.alg) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "jwt", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "cidr" ? Jd(e.data, o.version) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "cidr", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64" ? zd.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "base64", code: E.invalid_string, message: o.message }), n.dirty()) : o.kind === "base64url" ? qd.test(e.data) || (r = this._getOrReturnCtx(e, r), C(r, { validation: "base64url", code: E.invalid_string, message: o.message }), n.dirty()) : ue.assertNever(o);
    var s, i;
    return { status: n.value, value: e.data };
  }
  _regex(e, n, r) {
    return this.refinement((s) => e.test(s), { validation: n, code: E.invalid_string, ...P.errToObj(r) });
  }
  _addCheck(e) {
    return new At({ ...this._def, checks: [...this._def.checks, e] });
  }
  email(e) {
    return this._addCheck({ kind: "email", ...P.errToObj(e) });
  }
  url(e) {
    return this._addCheck({ kind: "url", ...P.errToObj(e) });
  }
  emoji(e) {
    return this._addCheck({ kind: "emoji", ...P.errToObj(e) });
  }
  uuid(e) {
    return this._addCheck({ kind: "uuid", ...P.errToObj(e) });
  }
  nanoid(e) {
    return this._addCheck({ kind: "nanoid", ...P.errToObj(e) });
  }
  cuid(e) {
    return this._addCheck({ kind: "cuid", ...P.errToObj(e) });
  }
  cuid2(e) {
    return this._addCheck({ kind: "cuid2", ...P.errToObj(e) });
  }
  ulid(e) {
    return this._addCheck({ kind: "ulid", ...P.errToObj(e) });
  }
  base64(e) {
    return this._addCheck({ kind: "base64", ...P.errToObj(e) });
  }
  base64url(e) {
    return this._addCheck({ kind: "base64url", ...P.errToObj(e) });
  }
  jwt(e) {
    return this._addCheck({ kind: "jwt", ...P.errToObj(e) });
  }
  ip(e) {
    return this._addCheck({ kind: "ip", ...P.errToObj(e) });
  }
  cidr(e) {
    return this._addCheck({ kind: "cidr", ...P.errToObj(e) });
  }
  datetime(e) {
    return typeof e == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: e }) : this._addCheck({ kind: "datetime", precision: (e == null ? void 0 : e.precision) === void 0 ? null : e == null ? void 0 : e.precision, offset: (e == null ? void 0 : e.offset) ?? !1, local: (e == null ? void 0 : e.local) ?? !1, ...P.errToObj(e == null ? void 0 : e.message) });
  }
  date(e) {
    return this._addCheck({ kind: "date", message: e });
  }
  time(e) {
    return typeof e == "string" ? this._addCheck({ kind: "time", precision: null, message: e }) : this._addCheck({ kind: "time", precision: (e == null ? void 0 : e.precision) === void 0 ? null : e == null ? void 0 : e.precision, ...P.errToObj(e == null ? void 0 : e.message) });
  }
  duration(e) {
    return this._addCheck({ kind: "duration", ...P.errToObj(e) });
  }
  regex(e, n) {
    return this._addCheck({ kind: "regex", regex: e, ...P.errToObj(n) });
  }
  includes(e, n) {
    return this._addCheck({ kind: "includes", value: e, position: n == null ? void 0 : n.position, ...P.errToObj(n == null ? void 0 : n.message) });
  }
  startsWith(e, n) {
    return this._addCheck({ kind: "startsWith", value: e, ...P.errToObj(n) });
  }
  endsWith(e, n) {
    return this._addCheck({ kind: "endsWith", value: e, ...P.errToObj(n) });
  }
  min(e, n) {
    return this._addCheck({ kind: "min", value: e, ...P.errToObj(n) });
  }
  max(e, n) {
    return this._addCheck({ kind: "max", value: e, ...P.errToObj(n) });
  }
  length(e, n) {
    return this._addCheck({ kind: "length", value: e, ...P.errToObj(n) });
  }
  nonempty(e) {
    return this.min(1, P.errToObj(e));
  }
  trim() {
    return new At({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new At({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new At({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((e) => e.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((e) => e.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((e) => e.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((e) => e.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((e) => e.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((e) => e.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((e) => e.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((e) => e.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((e) => e.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((e) => e.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((e) => e.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((e) => e.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((e) => e.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((e) => e.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((e) => e.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((e) => e.kind === "base64url");
  }
  get minLength() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxLength() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
function Gd(t, e) {
  const n = (t.toString().split(".")[1] || "").length, r = (e.toString().split(".")[1] || "").length, s = n > r ? n : r;
  return Number.parseInt(t.toFixed(s).replace(".", "")) % Number.parseInt(e.toFixed(s).replace(".", "")) / 10 ** s;
}
At.create = (t) => new At({ checks: [], typeName: J.ZodString, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...X(t) });
class fn extends se {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(e) {
    if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== k.number) {
      const s = this._getOrReturnCtx(e);
      return C(s, { code: E.invalid_type, expected: k.number, received: s.parsedType }), G;
    }
    let n;
    const r = new We();
    for (const s of this._def.checks) s.kind === "int" ? ue.isInteger(e.data) || (n = this._getOrReturnCtx(e, n), C(n, { code: E.invalid_type, expected: "integer", received: "float", message: s.message }), r.dirty()) : s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), C(n, { code: E.too_small, minimum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), C(n, { code: E.too_big, maximum: s.value, type: "number", inclusive: s.inclusive, exact: !1, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? Gd(e.data, s.value) !== 0 && (n = this._getOrReturnCtx(e, n), C(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : s.kind === "finite" ? Number.isFinite(e.data) || (n = this._getOrReturnCtx(e, n), C(n, { code: E.not_finite, message: s.message }), r.dirty()) : ue.assertNever(s);
    return { status: r.value, value: e.data };
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, P.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, P.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, P.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, P.toString(n));
  }
  setLimit(e, n, r, s) {
    return new fn({ ...this._def, checks: [...this._def.checks, { kind: e, value: n, inclusive: r, message: P.toString(s) }] });
  }
  _addCheck(e) {
    return new fn({ ...this._def, checks: [...this._def.checks, e] });
  }
  int(e) {
    return this._addCheck({ kind: "int", message: P.toString(e) });
  }
  positive(e) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: P.toString(e) });
  }
  negative(e) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: P.toString(e) });
  }
  nonpositive(e) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: P.toString(e) });
  }
  nonnegative(e) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: P.toString(e) });
  }
  multipleOf(e, n) {
    return this._addCheck({ kind: "multipleOf", value: e, message: P.toString(n) });
  }
  finite(e) {
    return this._addCheck({ kind: "finite", message: P.toString(e) });
  }
  safe(e) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: P.toString(e) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: P.toString(e) });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
  get isInt() {
    return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && ue.isInteger(e.value));
  }
  get isFinite() {
    let e = null, n = null;
    for (const r of this._def.checks) {
      if (r.kind === "finite" || r.kind === "int" || r.kind === "multipleOf") return !0;
      r.kind === "min" ? (n === null || r.value > n) && (n = r.value) : r.kind === "max" && (e === null || r.value < e) && (e = r.value);
    }
    return Number.isFinite(n) && Number.isFinite(e);
  }
}
fn.create = (t) => new fn({ checks: [], typeName: J.ZodNumber, coerce: (t == null ? void 0 : t.coerce) || !1, ...X(t) });
class qn extends se {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(e) {
    if (this._def.coerce) try {
      e.data = BigInt(e.data);
    } catch {
      return this._getInvalidInput(e);
    }
    if (this._getType(e) !== k.bigint) return this._getInvalidInput(e);
    let n;
    const r = new We();
    for (const s of this._def.checks) s.kind === "min" ? (s.inclusive ? e.data < s.value : e.data <= s.value) && (n = this._getOrReturnCtx(e, n), C(n, { code: E.too_small, type: "bigint", minimum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "max" ? (s.inclusive ? e.data > s.value : e.data >= s.value) && (n = this._getOrReturnCtx(e, n), C(n, { code: E.too_big, type: "bigint", maximum: s.value, inclusive: s.inclusive, message: s.message }), r.dirty()) : s.kind === "multipleOf" ? e.data % s.value !== BigInt(0) && (n = this._getOrReturnCtx(e, n), C(n, { code: E.not_multiple_of, multipleOf: s.value, message: s.message }), r.dirty()) : ue.assertNever(s);
    return { status: r.value, value: e.data };
  }
  _getInvalidInput(e) {
    const n = this._getOrReturnCtx(e);
    return C(n, { code: E.invalid_type, expected: k.bigint, received: n.parsedType }), G;
  }
  gte(e, n) {
    return this.setLimit("min", e, !0, P.toString(n));
  }
  gt(e, n) {
    return this.setLimit("min", e, !1, P.toString(n));
  }
  lte(e, n) {
    return this.setLimit("max", e, !0, P.toString(n));
  }
  lt(e, n) {
    return this.setLimit("max", e, !1, P.toString(n));
  }
  setLimit(e, n, r, s) {
    return new qn({ ...this._def, checks: [...this._def.checks, { kind: e, value: n, inclusive: r, message: P.toString(s) }] });
  }
  _addCheck(e) {
    return new qn({ ...this._def, checks: [...this._def.checks, e] });
  }
  positive(e) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: P.toString(e) });
  }
  negative(e) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: P.toString(e) });
  }
  nonpositive(e) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: P.toString(e) });
  }
  nonnegative(e) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: P.toString(e) });
  }
  multipleOf(e, n) {
    return this._addCheck({ kind: "multipleOf", value: e, message: P.toString(n) });
  }
  get minValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e;
  }
  get maxValue() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e;
  }
}
qn.create = (t) => new qn({ checks: [], typeName: J.ZodBigInt, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...X(t) });
class Ms extends se {
  _parse(e) {
    if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== k.boolean) {
      const n = this._getOrReturnCtx(e);
      return C(n, { code: E.invalid_type, expected: k.boolean, received: n.parsedType }), G;
    }
    return tt(e.data);
  }
}
Ms.create = (t) => new Ms({ typeName: J.ZodBoolean, coerce: (t == null ? void 0 : t.coerce) || !1, ...X(t) });
class Br extends se {
  _parse(e) {
    if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== k.date) {
      const s = this._getOrReturnCtx(e);
      return C(s, { code: E.invalid_type, expected: k.date, received: s.parsedType }), G;
    }
    if (Number.isNaN(e.data.getTime())) return C(this._getOrReturnCtx(e), { code: E.invalid_date }), G;
    const n = new We();
    let r;
    for (const s of this._def.checks) s.kind === "min" ? e.data.getTime() < s.value && (r = this._getOrReturnCtx(e, r), C(r, { code: E.too_small, message: s.message, inclusive: !0, exact: !1, minimum: s.value, type: "date" }), n.dirty()) : s.kind === "max" ? e.data.getTime() > s.value && (r = this._getOrReturnCtx(e, r), C(r, { code: E.too_big, message: s.message, inclusive: !0, exact: !1, maximum: s.value, type: "date" }), n.dirty()) : ue.assertNever(s);
    return { status: n.value, value: new Date(e.data.getTime()) };
  }
  _addCheck(e) {
    return new Br({ ...this._def, checks: [...this._def.checks, e] });
  }
  min(e, n) {
    return this._addCheck({ kind: "min", value: e.getTime(), message: P.toString(n) });
  }
  max(e, n) {
    return this._addCheck({ kind: "max", value: e.getTime(), message: P.toString(n) });
  }
  get minDate() {
    let e = null;
    for (const n of this._def.checks) n.kind === "min" && (e === null || n.value > e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
  get maxDate() {
    let e = null;
    for (const n of this._def.checks) n.kind === "max" && (e === null || n.value < e) && (e = n.value);
    return e != null ? new Date(e) : null;
  }
}
Br.create = (t) => new Br({ checks: [], coerce: (t == null ? void 0 : t.coerce) || !1, typeName: J.ZodDate, ...X(t) });
class mo extends se {
  _parse(e) {
    if (this._getType(e) !== k.symbol) {
      const n = this._getOrReturnCtx(e);
      return C(n, { code: E.invalid_type, expected: k.symbol, received: n.parsedType }), G;
    }
    return tt(e.data);
  }
}
mo.create = (t) => new mo({ typeName: J.ZodSymbol, ...X(t) });
class go extends se {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return C(n, { code: E.invalid_type, expected: k.undefined, received: n.parsedType }), G;
    }
    return tt(e.data);
  }
}
go.create = (t) => new go({ typeName: J.ZodUndefined, ...X(t) });
class vo extends se {
  _parse(e) {
    if (this._getType(e) !== k.null) {
      const n = this._getOrReturnCtx(e);
      return C(n, { code: E.invalid_type, expected: k.null, received: n.parsedType }), G;
    }
    return tt(e.data);
  }
}
vo.create = (t) => new vo({ typeName: J.ZodNull, ...X(t) });
class yo extends se {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(e) {
    return tt(e.data);
  }
}
yo.create = (t) => new yo({ typeName: J.ZodAny, ...X(t) });
class bo extends se {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(e) {
    return tt(e.data);
  }
}
bo.create = (t) => new bo({ typeName: J.ZodUnknown, ...X(t) });
class Ft extends se {
  _parse(e) {
    const n = this._getOrReturnCtx(e);
    return C(n, { code: E.invalid_type, expected: k.never, received: n.parsedType }), G;
  }
}
Ft.create = (t) => new Ft({ typeName: J.ZodNever, ...X(t) });
class wo extends se {
  _parse(e) {
    if (this._getType(e) !== k.undefined) {
      const n = this._getOrReturnCtx(e);
      return C(n, { code: E.invalid_type, expected: k.void, received: n.parsedType }), G;
    }
    return tt(e.data);
  }
}
wo.create = (t) => new wo({ typeName: J.ZodVoid, ...X(t) });
class Rt extends se {
  _parse(e) {
    const { ctx: n, status: r } = this._processInputParams(e), s = this._def;
    if (n.parsedType !== k.array) return C(n, { code: E.invalid_type, expected: k.array, received: n.parsedType }), G;
    if (s.exactLength !== null) {
      const o = n.data.length > s.exactLength.value, a = n.data.length < s.exactLength.value;
      (o || a) && (C(n, { code: o ? E.too_big : E.too_small, minimum: a ? s.exactLength.value : void 0, maximum: o ? s.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: s.exactLength.message }), r.dirty());
    }
    if (s.minLength !== null && n.data.length < s.minLength.value && (C(n, { code: E.too_small, minimum: s.minLength.value, type: "array", inclusive: !0, exact: !1, message: s.minLength.message }), r.dirty()), s.maxLength !== null && n.data.length > s.maxLength.value && (C(n, { code: E.too_big, maximum: s.maxLength.value, type: "array", inclusive: !0, exact: !1, message: s.maxLength.message }), r.dirty()), n.common.async) return Promise.all([...n.data].map((o, a) => s.type._parseAsync(new Et(n, o, n.path, a)))).then((o) => We.mergeArray(r, o));
    const i = [...n.data].map((o, a) => s.type._parseSync(new Et(n, o, n.path, a)));
    return We.mergeArray(r, i);
  }
  get element() {
    return this._def.type;
  }
  min(e, n) {
    return new Rt({ ...this._def, minLength: { value: e, message: P.toString(n) } });
  }
  max(e, n) {
    return new Rt({ ...this._def, maxLength: { value: e, message: P.toString(n) } });
  }
  length(e, n) {
    return new Rt({ ...this._def, exactLength: { value: e, message: P.toString(n) } });
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
function en(t) {
  if (t instanceof Ne) {
    const e = {};
    for (const n in t.shape) {
      const r = t.shape[n];
      e[n] = $t.create(en(r));
    }
    return new Ne({ ...t._def, shape: () => e });
  }
  return t instanceof Rt ? new Rt({ ...t._def, type: en(t.element) }) : t instanceof $t ? $t.create(en(t.unwrap())) : t instanceof pn ? pn.create(en(t.unwrap())) : t instanceof Jt ? Jt.create(t.items.map((e) => en(e))) : t;
}
Rt.create = (t, e) => new Rt({ type: t, minLength: null, maxLength: null, exactLength: null, typeName: J.ZodArray, ...X(e) });
class Ne extends se {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const e = this._def.shape(), n = ue.objectKeys(e);
    return this._cached = { shape: e, keys: n }, this._cached;
  }
  _parse(e) {
    if (this._getType(e) !== k.object) {
      const u = this._getOrReturnCtx(e);
      return C(u, { code: E.invalid_type, expected: k.object, received: u.parsedType }), G;
    }
    const { status: n, ctx: r } = this._processInputParams(e), { shape: s, keys: i } = this._getCached(), o = [];
    if (!(this._def.catchall instanceof Ft && this._def.unknownKeys === "strip")) for (const u in r.data) i.includes(u) || o.push(u);
    const a = [];
    for (const u of i) {
      const c = s[u], l = r.data[u];
      a.push({ key: { status: "valid", value: u }, value: c._parse(new Et(r, l, r.path, u)), alwaysSet: u in r.data });
    }
    if (this._def.catchall instanceof Ft) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const c of o) a.push({ key: { status: "valid", value: c }, value: { status: "valid", value: r.data[c] } });
      else if (u === "strict") o.length > 0 && (C(r, { code: E.unrecognized_keys, keys: o }), n.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const c of o) {
        const l = r.data[c];
        a.push({ key: { status: "valid", value: c }, value: u._parse(new Et(r, l, r.path, c)), alwaysSet: c in r.data });
      }
    }
    return r.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const c of a) {
        const l = await c.key, d = await c.value;
        u.push({ key: l, value: d, alwaysSet: c.alwaysSet });
      }
      return u;
    }).then((u) => We.mergeObjectSync(n, u)) : We.mergeObjectSync(n, a);
  }
  get shape() {
    return this._def.shape();
  }
  strict(e) {
    return P.errToObj, new Ne({ ...this._def, unknownKeys: "strict", ...e !== void 0 ? { errorMap: (n, r) => {
      var i, o;
      const s = ((o = (i = this._def).errorMap) == null ? void 0 : o.call(i, n, r).message) ?? r.defaultError;
      return n.code === "unrecognized_keys" ? { message: P.errToObj(e).message ?? s } : { message: s };
    } } : {} });
  }
  strip() {
    return new Ne({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new Ne({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(e) {
    return new Ne({ ...this._def, shape: () => ({ ...this._def.shape(), ...e }) });
  }
  merge(e) {
    return new Ne({ unknownKeys: e._def.unknownKeys, catchall: e._def.catchall, shape: () => ({ ...this._def.shape(), ...e._def.shape() }), typeName: J.ZodObject });
  }
  setKey(e, n) {
    return this.augment({ [e]: n });
  }
  catchall(e) {
    return new Ne({ ...this._def, catchall: e });
  }
  pick(e) {
    const n = {};
    for (const r of ue.objectKeys(e)) e[r] && this.shape[r] && (n[r] = this.shape[r]);
    return new Ne({ ...this._def, shape: () => n });
  }
  omit(e) {
    const n = {};
    for (const r of ue.objectKeys(this.shape)) e[r] || (n[r] = this.shape[r]);
    return new Ne({ ...this._def, shape: () => n });
  }
  deepPartial() {
    return en(this);
  }
  partial(e) {
    const n = {};
    for (const r of ue.objectKeys(this.shape)) {
      const s = this.shape[r];
      e && !e[r] ? n[r] = s : n[r] = s.optional();
    }
    return new Ne({ ...this._def, shape: () => n });
  }
  required(e) {
    const n = {};
    for (const r of ue.objectKeys(this.shape)) if (e && !e[r]) n[r] = this.shape[r];
    else {
      let s = this.shape[r];
      for (; s instanceof $t; ) s = s._def.innerType;
      n[r] = s;
    }
    return new Ne({ ...this._def, shape: () => n });
  }
  keyof() {
    return Xa(ue.objectKeys(this.shape));
  }
}
Ne.create = (t, e) => new Ne({ shape: () => t, unknownKeys: "strip", catchall: Ft.create(), typeName: J.ZodObject, ...X(e) }), Ne.strictCreate = (t, e) => new Ne({ shape: () => t, unknownKeys: "strict", catchall: Ft.create(), typeName: J.ZodObject, ...X(e) }), Ne.lazycreate = (t, e) => new Ne({ shape: t, unknownKeys: "strip", catchall: Ft.create(), typeName: J.ZodObject, ...X(e) });
class Mr extends se {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = this._def.options;
    if (n.common.async) return Promise.all(r.map(async (s) => {
      const i = { ...n, common: { ...n.common, issues: [] }, parent: null };
      return { result: await s._parseAsync({ data: n.data, path: n.path, parent: i }), ctx: i };
    })).then(function(s) {
      for (const o of s) if (o.result.status === "valid") return o.result;
      for (const o of s) if (o.result.status === "dirty") return n.common.issues.push(...o.ctx.common.issues), o.result;
      const i = s.map((o) => new Ut(o.ctx.common.issues));
      return C(n, { code: E.invalid_union, unionErrors: i }), G;
    });
    {
      let s;
      const i = [];
      for (const a of r) {
        const u = { ...n, common: { ...n.common, issues: [] }, parent: null }, c = a._parseSync({ data: n.data, path: n.path, parent: u });
        if (c.status === "valid") return c;
        c.status !== "dirty" || s || (s = { result: c, ctx: u }), u.common.issues.length && i.push(u.common.issues);
      }
      if (s) return n.common.issues.push(...s.ctx.common.issues), s.result;
      const o = i.map((a) => new Ut(a));
      return C(n, { code: E.invalid_union, unionErrors: o }), G;
    }
  }
  get options() {
    return this._def.options;
  }
}
function zs(t, e) {
  const n = Dt(t), r = Dt(e);
  if (t === e) return { valid: !0, data: t };
  if (n === k.object && r === k.object) {
    const s = ue.objectKeys(e), i = ue.objectKeys(t).filter((a) => s.indexOf(a) !== -1), o = { ...t, ...e };
    for (const a of i) {
      const u = zs(t[a], e[a]);
      if (!u.valid) return { valid: !1 };
      o[a] = u.data;
    }
    return { valid: !0, data: o };
  }
  if (n === k.array && r === k.array) {
    if (t.length !== e.length) return { valid: !1 };
    const s = [];
    for (let i = 0; i < t.length; i++) {
      const o = zs(t[i], e[i]);
      if (!o.valid) return { valid: !1 };
      s.push(o.data);
    }
    return { valid: !0, data: s };
  }
  return n === k.date && r === k.date && +t == +e ? { valid: !0, data: t } : { valid: !1 };
}
Mr.create = (t, e) => new Mr({ options: t, typeName: J.ZodUnion, ...X(e) });
class zr extends se {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = (i, o) => {
      if (fo(i) || fo(o)) return G;
      const a = zs(i.value, o.value);
      return a.valid ? ((ho(i) || ho(o)) && n.dirty(), { status: n.value, value: a.data }) : (C(r, { code: E.invalid_intersection_types }), G);
    };
    return r.common.async ? Promise.all([this._def.left._parseAsync({ data: r.data, path: r.path, parent: r }), this._def.right._parseAsync({ data: r.data, path: r.path, parent: r })]).then(([i, o]) => s(i, o)) : s(this._def.left._parseSync({ data: r.data, path: r.path, parent: r }), this._def.right._parseSync({ data: r.data, path: r.path, parent: r }));
  }
}
zr.create = (t, e, n) => new zr({ left: t, right: e, typeName: J.ZodIntersection, ...X(n) });
class Jt extends se {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.array) return C(r, { code: E.invalid_type, expected: k.array, received: r.parsedType }), G;
    if (r.data.length < this._def.items.length) return C(r, { code: E.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), G;
    !this._def.rest && r.data.length > this._def.items.length && (C(r, { code: E.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), n.dirty());
    const s = [...r.data].map((i, o) => {
      const a = this._def.items[o] || this._def.rest;
      return a ? a._parse(new Et(r, i, r.path, o)) : null;
    }).filter((i) => !!i);
    return r.common.async ? Promise.all(s).then((i) => We.mergeArray(n, i)) : We.mergeArray(n, s);
  }
  get items() {
    return this._def.items;
  }
  rest(e) {
    return new Jt({ ...this._def, rest: e });
  }
}
Jt.create = (t, e) => {
  if (!Array.isArray(t)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new Jt({ items: t, typeName: J.ZodTuple, rest: null, ...X(e) });
};
class ii extends se {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.object) return C(r, { code: E.invalid_type, expected: k.object, received: r.parsedType }), G;
    const s = [], i = this._def.keyType, o = this._def.valueType;
    for (const a in r.data) s.push({ key: i._parse(new Et(r, a, r.path, a)), value: o._parse(new Et(r, r.data[a], r.path, a)), alwaysSet: a in r.data });
    return r.common.async ? We.mergeObjectAsync(n, s) : We.mergeObjectSync(n, s);
  }
  get element() {
    return this._def.valueType;
  }
  static create(e, n, r) {
    return new ii(n instanceof se ? { keyType: e, valueType: n, typeName: J.ZodRecord, ...X(r) } : { keyType: At.create(), valueType: e, typeName: J.ZodRecord, ...X(n) });
  }
}
class xo extends se {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.map) return C(r, { code: E.invalid_type, expected: k.map, received: r.parsedType }), G;
    const s = this._def.keyType, i = this._def.valueType, o = [...r.data.entries()].map(([a, u], c) => ({ key: s._parse(new Et(r, a, r.path, [c, "key"])), value: i._parse(new Et(r, u, r.path, [c, "value"])) }));
    if (r.common.async) {
      const a = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of o) {
          const c = await u.key, l = await u.value;
          if (c.status === "aborted" || l.status === "aborted") return G;
          c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
        }
        return { status: n.value, value: a };
      });
    }
    {
      const a = /* @__PURE__ */ new Map();
      for (const u of o) {
        const c = u.key, l = u.value;
        if (c.status === "aborted" || l.status === "aborted") return G;
        c.status !== "dirty" && l.status !== "dirty" || n.dirty(), a.set(c.value, l.value);
      }
      return { status: n.value, value: a };
    }
  }
}
xo.create = (t, e, n) => new xo({ valueType: e, keyType: t, typeName: J.ZodMap, ...X(n) });
class Hn extends se {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.parsedType !== k.set) return C(r, { code: E.invalid_type, expected: k.set, received: r.parsedType }), G;
    const s = this._def;
    s.minSize !== null && r.data.size < s.minSize.value && (C(r, { code: E.too_small, minimum: s.minSize.value, type: "set", inclusive: !0, exact: !1, message: s.minSize.message }), n.dirty()), s.maxSize !== null && r.data.size > s.maxSize.value && (C(r, { code: E.too_big, maximum: s.maxSize.value, type: "set", inclusive: !0, exact: !1, message: s.maxSize.message }), n.dirty());
    const i = this._def.valueType;
    function o(u) {
      const c = /* @__PURE__ */ new Set();
      for (const l of u) {
        if (l.status === "aborted") return G;
        l.status === "dirty" && n.dirty(), c.add(l.value);
      }
      return { status: n.value, value: c };
    }
    const a = [...r.data.values()].map((u, c) => i._parse(new Et(r, u, r.path, c)));
    return r.common.async ? Promise.all(a).then((u) => o(u)) : o(a);
  }
  min(e, n) {
    return new Hn({ ...this._def, minSize: { value: e, message: P.toString(n) } });
  }
  max(e, n) {
    return new Hn({ ...this._def, maxSize: { value: e, message: P.toString(n) } });
  }
  size(e, n) {
    return this.min(e, n).max(e, n);
  }
  nonempty(e) {
    return this.min(1, e);
  }
}
Hn.create = (t, e) => new Hn({ valueType: t, minSize: null, maxSize: null, typeName: J.ZodSet, ...X(e) });
class So extends se {
  get schema() {
    return this._def.getter();
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    return this._def.getter()._parse({ data: n.data, path: n.path, parent: n });
  }
}
So.create = (t, e) => new So({ getter: t, typeName: J.ZodLazy, ...X(e) });
class Ro extends se {
  _parse(e) {
    if (e.data !== this._def.value) {
      const n = this._getOrReturnCtx(e);
      return C(n, { received: n.data, code: E.invalid_literal, expected: this._def.value }), G;
    }
    return { status: "valid", value: e.data };
  }
  get value() {
    return this._def.value;
  }
}
function Xa(t, e) {
  return new hn({ values: t, typeName: J.ZodEnum, ...X(e) });
}
Ro.create = (t, e) => new Ro({ value: t, typeName: J.ZodLiteral, ...X(e) });
class hn extends se {
  _parse(e) {
    if (typeof e.data != "string") {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return C(n, { expected: ue.joinValues(r), received: n.parsedType, code: E.invalid_type }), G;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(e.data)) {
      const n = this._getOrReturnCtx(e), r = this._def.values;
      return C(n, { received: n.data, code: E.invalid_enum_value, options: r }), G;
    }
    return tt(e.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  get Values() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  get Enum() {
    const e = {};
    for (const n of this._def.values) e[n] = n;
    return e;
  }
  extract(e, n = this._def) {
    return hn.create(e, { ...this._def, ...n });
  }
  exclude(e, n = this._def) {
    return hn.create(this.options.filter((r) => !e.includes(r)), { ...this._def, ...n });
  }
}
hn.create = Xa;
class _o extends se {
  _parse(e) {
    const n = ue.getValidEnumValues(this._def.values), r = this._getOrReturnCtx(e);
    if (r.parsedType !== k.string && r.parsedType !== k.number) {
      const s = ue.objectValues(n);
      return C(r, { expected: ue.joinValues(s), received: r.parsedType, code: E.invalid_type }), G;
    }
    if (this._cache || (this._cache = new Set(ue.getValidEnumValues(this._def.values))), !this._cache.has(e.data)) {
      const s = ue.objectValues(n);
      return C(r, { received: r.data, code: E.invalid_enum_value, options: s }), G;
    }
    return tt(e.data);
  }
  get enum() {
    return this._def.values;
  }
}
_o.create = (t, e) => new _o({ values: t, typeName: J.ZodNativeEnum, ...X(e) });
class qr extends se {
  unwrap() {
    return this._def.type;
  }
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    if (n.parsedType !== k.promise && n.common.async === !1) return C(n, { code: E.invalid_type, expected: k.promise, received: n.parsedType }), G;
    const r = n.parsedType === k.promise ? n.data : Promise.resolve(n.data);
    return tt(r.then((s) => this._def.type.parseAsync(s, { path: n.path, errorMap: n.common.contextualErrorMap })));
  }
}
qr.create = (t, e) => new qr({ type: t, typeName: J.ZodPromise, ...X(e) });
class nn extends se {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === J.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e), s = this._def.effect || null, i = { addIssue: (o) => {
      C(r, o), o.fatal ? n.abort() : n.dirty();
    }, get path() {
      return r.path;
    } };
    if (i.addIssue = i.addIssue.bind(i), s.type === "preprocess") {
      const o = s.transform(r.data, i);
      if (r.common.async) return Promise.resolve(o).then(async (a) => {
        if (n.value === "aborted") return G;
        const u = await this._def.schema._parseAsync({ data: a, path: r.path, parent: r });
        return u.status === "aborted" ? G : u.status === "dirty" || n.value === "dirty" ? Bs(u.value) : u;
      });
      {
        if (n.value === "aborted") return G;
        const a = this._def.schema._parseSync({ data: o, path: r.path, parent: r });
        return a.status === "aborted" ? G : a.status === "dirty" || n.value === "dirty" ? Bs(a.value) : a;
      }
    }
    if (s.type === "refinement") {
      const o = (a) => {
        const u = s.refinement(a, i);
        if (r.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return a;
      };
      if (r.common.async === !1) {
        const a = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        return a.status === "aborted" ? G : (a.status === "dirty" && n.dirty(), o(a.value), { status: n.value, value: a.value });
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((a) => a.status === "aborted" ? G : (a.status === "dirty" && n.dirty(), o(a.value).then(() => ({ status: n.value, value: a.value }))));
    }
    if (s.type === "transform") {
      if (r.common.async === !1) {
        const o = this._def.schema._parseSync({ data: r.data, path: r.path, parent: r });
        if (!dn(o)) return G;
        const a = s.transform(o.value, i);
        if (a instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: n.value, value: a };
      }
      return this._def.schema._parseAsync({ data: r.data, path: r.path, parent: r }).then((o) => dn(o) ? Promise.resolve(s.transform(o.value, i)).then((a) => ({ status: n.value, value: a })) : G);
    }
    ue.assertNever(s);
  }
}
nn.create = (t, e, n) => new nn({ schema: t, typeName: J.ZodEffects, effect: e, ...X(n) }), nn.createWithPreprocess = (t, e, n) => new nn({ schema: e, effect: { type: "preprocess", transform: t }, typeName: J.ZodEffects, ...X(n) });
class $t extends se {
  _parse(e) {
    return this._getType(e) === k.undefined ? tt(void 0) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
$t.create = (t, e) => new $t({ innerType: t, typeName: J.ZodOptional, ...X(e) });
class pn extends se {
  _parse(e) {
    return this._getType(e) === k.null ? tt(null) : this._def.innerType._parse(e);
  }
  unwrap() {
    return this._def.innerType;
  }
}
pn.create = (t, e) => new pn({ innerType: t, typeName: J.ZodNullable, ...X(e) });
class qs extends se {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e);
    let r = n.data;
    return n.parsedType === k.undefined && (r = this._def.defaultValue()), this._def.innerType._parse({ data: r, path: n.path, parent: n });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
qs.create = (t, e) => new qs({ innerType: t, typeName: J.ZodDefault, defaultValue: typeof e.default == "function" ? e.default : () => e.default, ...X(e) });
class Hs extends se {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = { ...n, common: { ...n.common, issues: [] } }, s = this._def.innerType._parse({ data: r.data, path: r.path, parent: { ...r } });
    return $r(s) ? s.then((i) => ({ status: "valid", value: i.status === "valid" ? i.value : this._def.catchValue({ get error() {
      return new Ut(r.common.issues);
    }, input: r.data }) })) : { status: "valid", value: s.status === "valid" ? s.value : this._def.catchValue({ get error() {
      return new Ut(r.common.issues);
    }, input: r.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Hs.create = (t, e) => new Hs({ innerType: t, typeName: J.ZodCatch, catchValue: typeof e.catch == "function" ? e.catch : () => e.catch, ...X(e) });
class Oo extends se {
  _parse(e) {
    if (this._getType(e) !== k.nan) {
      const n = this._getOrReturnCtx(e);
      return C(n, { code: E.invalid_type, expected: k.nan, received: n.parsedType }), G;
    }
    return { status: "valid", value: e.data };
  }
}
Oo.create = (t) => new Oo({ typeName: J.ZodNaN, ...X(t) });
class Vd extends se {
  _parse(e) {
    const { ctx: n } = this._processInputParams(e), r = n.data;
    return this._def.type._parse({ data: r, path: n.path, parent: n });
  }
  unwrap() {
    return this._def.type;
  }
}
class oi extends se {
  _parse(e) {
    const { status: n, ctx: r } = this._processInputParams(e);
    if (r.common.async) return (async () => {
      const s = await this._def.in._parseAsync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? G : s.status === "dirty" ? (n.dirty(), Bs(s.value)) : this._def.out._parseAsync({ data: s.value, path: r.path, parent: r });
    })();
    {
      const s = this._def.in._parseSync({ data: r.data, path: r.path, parent: r });
      return s.status === "aborted" ? G : s.status === "dirty" ? (n.dirty(), { status: "dirty", value: s.value }) : this._def.out._parseSync({ data: s.value, path: r.path, parent: r });
    }
  }
  static create(e, n) {
    return new oi({ in: e, out: n, typeName: J.ZodPipeline });
  }
}
class Zs extends se {
  _parse(e) {
    const n = this._def.innerType._parse(e), r = (s) => (dn(s) && (s.value = Object.freeze(s.value)), s);
    return $r(n) ? n.then((s) => r(s)) : r(n);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var J;
Zs.create = (t, e) => new Zs({ innerType: t, typeName: J.ZodReadonly, ...X(e) }), function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
}(J || (J = {}));
const R = At.create, re = fn.create, mn = Ms.create, _t = (Ft.create, Rt.create), Ce = Ne.create, sr = Mr.create, Kd = (zr.create, Jt.create, ii.create), Ot = hn.create;
qr.create, $t.create, pn.create;
var Qa = re().min(0).max(Cd).refine(function(t) {
  return Math.abs(Math.round(10 * t) - 10 * t) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), eu = Ot(["N", "C"]), Yd = Ce({ id: R().optional(), type: eu.default("N"), movementNumber: re().int().positive(), description: R(), directive: R().optional(), location: R().optional(), coefficient: re().int().min(1).max(10), section: Ot(["technical", "artistic", "quality"]).optional() }), Xd = Ce({ id: R().optional(), type: eu.default("C"), movementNumber: re().int().positive(), name: R(), directive: R().optional(), coefficient: re().int().min(1).max(2) });
Ce({ id: R(), fvdId: sr([re(), R()]).nullable().optional(), source: Ot(["catalog", "custom"]).optional(), testCode: R(), organization: R().optional(), level: R().optional(), testNumber: re().int().optional(), movements: _t(Yd), collectives: _t(Xd), purpose: R().optional(), introduce: R().optional(), errorRule: Ce({ first: sr([re(), R()]).nullable().optional(), second: sr([re(), R()]).nullable().optional(), third: sr([re(), R()]).nullable().optional() }).nullable().optional(), collectivesLabel: R().default("Collective Marks") });
var Qd = Ce({ movementNumber: re().int().positive(), score: Qa.optional().nullable(), remarks: R().max(500).optional(), flagged: mn().default(!1), annotatedDirective: R().optional(), annotatedDescription: R().optional(), deductions: _t(Ce({ id: R(), reason: R(), points: re().positive() })).optional() }), ef = Ce({ score: Qa.optional(), remarks: R().max(500).optional(), flagged: mn().optional(), annotatedName: R().optional(), annotatedDirective: R().optional() }), tf = Kd(R().regex(/^\d+$/), ef);
Ce({ id: R().optional(), rideId: R(), judgeId: R(), testId: R(), movementScores: _t(Qd).default([]), collectives: tf.default({}), annotatedPurpose: R().optional(), annotatedIntroduce: R().optional(), generalRemarks: R().max(2e3).optional(), entryTimeSeconds: re().nonnegative().optional(), totalPoints: re().optional(), maxPoints: re().optional(), percentage: re().optional(), technicalPoints: re().optional(), technicalMaxPoints: re().optional(), artisticPoints: re().optional(), artisticMaxPoints: re().optional(), qualityPoints: re().optional(), qualityMaxPoints: re().optional(), judgeSignature: R().optional(), signature: Ce({ judgeId: R(), signatureHash: R(), signedAt: R() }).optional(), eliminations: _t(Ce({ id: R(), reason: R(), movementNumber: re().int().positive().nullable().optional(), fromError: mn().optional() })).optional(), errors: _t(Ce({ id: R(), label: R(), points: re().nonnegative().optional(), percent: re().nonnegative().optional(), movementNumber: re().int().positive().nullable().optional() })).optional(), marksConfirmedAt: R().optional(), marksConfirmedBy: R().optional(), timeFault: Ce({ exceeded: mn(), elapsedSeconds: re(), limitSeconds: re(), recordedAt: R() }).optional(), completedAt: R().optional() });
Ot(Ga);
var Eo = Ce(Object.fromEntries(Ga.map(function(t) {
  return [t, _t(R()).optional()];
})));
Ce({ id: R(), showId: R(), testId: R().optional(), className: R(), scheduledTime: R(), ring: R().optional(), judgeAssignments: Eo.optional(), judgeIds: _t(R()).optional(), scribeAssignments: Eo.optional(), qualityJudging: Ce({ topology: Ot(["two-judge", "technical-only"]), qualityPosition: Ot(["E", "B"]).nullable().optional(), qualityJudge: R().nullable().optional() }).optional(), faultTimeLimitSeconds: re().int().positive().default(45), errorDeductionScheme: Ot(Object.values(Ln)).default(Ln.POINTS), sectionJudgeAssignments: Ce({ technical: R().nullable().optional(), quality: R().nullable().optional() }).optional(), status: R().optional(), order: re().optional() });
var nf = Ce({ id: R(), type: Ot(Object.values(Va)), raisedByScribeId: R().nullable(), raisedAt: R(), acknowledged: Ce({ byScribeId: R().nullable(), at: R() }).nullable().optional() });
Ce({ type: Ot(Object.values(Va)) });
Ce({ id: R(), classId: R(), testId: R().optional(), horseId: R(), riderId: R(), rideNumber: re().int().positive(), scheduledTime: R().optional(), status: R().optional(), percentage: re().optional(), allSheetsCompletedAt: R().nullable().optional(), adminConfirmedAt: R().nullable().optional(), adminConfirmedBy: R().nullable().optional(), compositePercentage: re().nullable().optional(), placing: re().int().positive().nullable().optional(), isManual: mn().optional(), needsReview: mn().optional(), judgeIds: _t(R()).optional(), competitorNumber: R().optional(), horseName: R().optional(), riderName: R().optional(), trainerId: R().optional(), resolvedIntoRideId: R().nullable().optional(), utilityEvents: _t(nf).optional() });
Ce({ classId: R(), testId: R().optional(), competitorNumber: R().optional(), horseName: R().optional(), riderName: R().optional() });
Ce({ id: R(), personType: Ot(["RIDER", "JUDGE", "SCRIBE"]), firstName: R(), lastName: R(), usefId: R().optional(), usdfId: R().optional(), email: R().optional(), unlockCode: R().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: R().optional() });
Ce({ id: R(), name: R(), breed: R().optional(), foalYear: re().int().optional(), usefId: R().optional(), usdfId: R().optional() });
function tu(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: rf } = Object.prototype, { getPrototypeOf: ai } = Object, { iterator: br, toStringTag: nu } = Symbol, Hr = (ys = /* @__PURE__ */ Object.create(null), (t) => {
  const e = rf.call(t);
  return ys[e] || (ys[e] = e.slice(8, -1).toLowerCase());
});
var ys;
const gt = (t) => (t = t.toLowerCase(), (e) => Hr(e) === t), Xr = (t) => (e) => typeof e === t, { isArray: tn } = Array, un = Xr("undefined");
function Nn(t) {
  return t !== null && !un(t) && t.constructor !== null && !un(t.constructor) && Ke(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const To = gt("ArrayBuffer"), sf = Xr("string"), Ke = Xr("function"), Co = Xr("number"), Tn = (t) => t !== null && typeof t == "object", ir = (t) => {
  if (Hr(t) !== "object") return !1;
  const e = ai(t);
  return !(e !== null && e !== Object.prototype && Object.getPrototypeOf(e) !== null || nu in t || br in t);
}, of = gt("Date"), af = gt("File"), uf = gt("Blob"), cf = gt("FileList"), lf = gt("URLSearchParams"), [df, ff, hf, pf] = ["ReadableStream", "Request", "Response", "Headers"].map(gt);
function An(t, e, { allOwnKeys: n = !1 } = {}) {
  if (t == null) return;
  let r, s;
  if (typeof t != "object" && (t = [t]), tn(t)) for (r = 0, s = t.length; r < s; r++) e.call(null, t[r], r, t);
  else {
    if (Nn(t)) return;
    const i = n ? Object.getOwnPropertyNames(t) : Object.keys(t), o = i.length;
    let a;
    for (r = 0; r < o; r++) a = i[r], e.call(null, t[a], a, t);
  }
}
function jo(t, e) {
  if (Nn(t)) return null;
  e = e.toLowerCase();
  const n = Object.keys(t);
  let r, s = n.length;
  for (; s-- > 0; ) if (r = n[s], e === r.toLowerCase()) return r;
  return null;
}
const Ht = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, ko = (t) => !un(t) && t !== Ht, mf = (bs = typeof Uint8Array < "u" && ai(Uint8Array), (t) => bs && t instanceof bs);
var bs;
const gf = gt("HTMLFormElement"), Po = (({ hasOwnProperty: t }) => (e, n) => t.call(e, n))(Object.prototype), vf = gt("RegExp"), Io = (t, e) => {
  const n = Object.getOwnPropertyDescriptors(t), r = {};
  An(n, (s, i) => {
    let o;
    (o = e(s, i, t)) !== !1 && (r[i] = o || s);
  }), Object.defineProperties(t, r);
}, yf = gt("AsyncFunction"), ru = (Ao = typeof setImmediate == "function", Uo = Ke(Ht.postMessage), Ao ? setImmediate : Uo ? (ws = `axios@${Math.random()}`, or = [], Ht.addEventListener("message", ({ source: t, data: e }) => {
  t === Ht && e === ws && or.length && or.shift()();
}, !1), (t) => {
  or.push(t), Ht.postMessage(ws, "*");
}) : (t) => setTimeout(t));
var Ao, Uo, ws, or;
const bf = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ht) : typeof process < "u" && process.nextTick || ru, b = { isArray: tn, isArrayBuffer: To, isBuffer: Nn, isFormData: (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Ke(t.append) && ((e = Hr(t)) === "formdata" || e === "object" && Ke(t.toString) && t.toString() === "[object FormData]"));
}, isArrayBufferView: function(t) {
  let e;
  return e = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(t) : t && t.buffer && To(t.buffer), e;
}, isString: sf, isNumber: Co, isBoolean: (t) => t === !0 || t === !1, isObject: Tn, isPlainObject: ir, isEmptyObject: (t) => {
  if (!Tn(t) || Nn(t)) return !1;
  try {
    return Object.keys(t).length === 0 && Object.getPrototypeOf(t) === Object.prototype;
  } catch {
    return !1;
  }
}, isReadableStream: df, isRequest: ff, isResponse: hf, isHeaders: pf, isUndefined: un, isDate: of, isFile: af, isBlob: uf, isRegExp: vf, isFunction: Ke, isStream: (t) => Tn(t) && Ke(t.pipe), isURLSearchParams: lf, isTypedArray: mf, isFileList: cf, forEach: An, merge: function t() {
  const { caseless: e, skipUndefined: n } = ko(this) && this || {}, r = {}, s = (i, o) => {
    const a = e && jo(r, o) || o;
    ir(r[a]) && ir(i) ? r[a] = t(r[a], i) : ir(i) ? r[a] = t({}, i) : tn(i) ? r[a] = i.slice() : n && un(i) || (r[a] = i);
  };
  for (let i = 0, o = arguments.length; i < o; i++) arguments[i] && An(arguments[i], s);
  return r;
}, extend: (t, e, n, { allOwnKeys: r } = {}) => (An(e, (s, i) => {
  n && Ke(s) ? t[i] = tu(s, n) : t[i] = s;
}, { allOwnKeys: r }), t), trim: (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, ""), stripBOM: (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), inherits: (t, e, n, r) => {
  t.prototype = Object.create(e.prototype, r), t.prototype.constructor = t, Object.defineProperty(t, "super", { value: e.prototype }), n && Object.assign(t.prototype, n);
}, toFlatObject: (t, e, n, r) => {
  let s, i, o;
  const a = {};
  if (e = e || {}, t == null) return e;
  do {
    for (s = Object.getOwnPropertyNames(t), i = s.length; i-- > 0; ) o = s[i], r && !r(o, t, e) || a[o] || (e[o] = t[o], a[o] = !0);
    t = n !== !1 && ai(t);
  } while (t && (!n || n(t, e)) && t !== Object.prototype);
  return e;
}, kindOf: Hr, kindOfTest: gt, endsWith: (t, e, n) => {
  t = String(t), (n === void 0 || n > t.length) && (n = t.length), n -= e.length;
  const r = t.indexOf(e, n);
  return r !== -1 && r === n;
}, toArray: (t) => {
  if (!t) return null;
  if (tn(t)) return t;
  let e = t.length;
  if (!Co(e)) return null;
  const n = new Array(e);
  for (; e-- > 0; ) n[e] = t[e];
  return n;
}, forEachEntry: (t, e) => {
  const n = (t && t[br]).call(t);
  let r;
  for (; (r = n.next()) && !r.done; ) {
    const s = r.value;
    e.call(t, s[0], s[1]);
  }
}, matchAll: (t, e) => {
  let n;
  const r = [];
  for (; (n = t.exec(e)) !== null; ) r.push(n);
  return r;
}, isHTMLForm: gf, hasOwnProperty: Po, hasOwnProp: Po, reduceDescriptors: Io, freezeMethods: (t) => {
  Io(t, (e, n) => {
    if (Ke(t) && ["arguments", "caller", "callee"].indexOf(n) !== -1) return !1;
    const r = t[n];
    Ke(r) && (e.enumerable = !1, "writable" in e ? e.writable = !1 : e.set || (e.set = () => {
      throw Error("Can not rewrite read-only method '" + n + "'");
    }));
  });
}, toObjectSet: (t, e) => {
  const n = {}, r = (s) => {
    s.forEach((i) => {
      n[i] = !0;
    });
  };
  return tn(t) ? r(t) : r(String(t).split(e)), n;
}, toCamelCase: (t) => t.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, n, r) {
  return n.toUpperCase() + r;
}), noop: () => {
}, toFiniteNumber: (t, e) => t != null && Number.isFinite(t = +t) ? t : e, findKey: jo, global: Ht, isContextDefined: ko, isSpecCompliantForm: function(t) {
  return !!(t && Ke(t.append) && t[nu] === "FormData" && t[br]);
}, toJSONObject: (t) => {
  const e = new Array(10), n = (r, s) => {
    if (Tn(r)) {
      if (e.indexOf(r) >= 0) return;
      if (Nn(r)) return r;
      if (!("toJSON" in r)) {
        e[s] = r;
        const i = tn(r) ? [] : {};
        return An(r, (o, a) => {
          const u = n(o, s + 1);
          !un(u) && (i[a] = u);
        }), e[s] = void 0, i;
      }
    }
    return r;
  };
  return n(t, 0);
}, isAsyncFn: yf, isThenable: (t) => t && (Tn(t) || Ke(t)) && Ke(t.then) && Ke(t.catch), setImmediate: ru, asap: bf, isIterable: (t) => t != null && Ke(t[br]) };
function cn(t, e, n, r, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), n && (this.config = n), r && (this.request = r), s && (this.response = s, this.status = s.status ? s.status : null);
}
b.inherits(cn, Error, { toJSON: function() {
  return { message: this.message, name: this.name, description: this.description, number: this.number, fileName: this.fileName, lineNumber: this.lineNumber, columnNumber: this.columnNumber, stack: this.stack, config: b.toJSONObject(this.config), code: this.code, status: this.status };
} });
const Lo = cn.prototype, No = {};
["ERR_BAD_OPTION_VALUE", "ERR_BAD_OPTION", "ECONNABORTED", "ETIMEDOUT", "ERR_NETWORK", "ERR_FR_TOO_MANY_REDIRECTS", "ERR_DEPRECATED", "ERR_BAD_RESPONSE", "ERR_BAD_REQUEST", "ERR_CANCELED", "ERR_NOT_SUPPORT", "ERR_INVALID_URL"].forEach((t) => {
  No[t] = { value: t };
}), Object.defineProperties(cn, No), Object.defineProperty(Lo, "isAxiosError", { value: !0 }), cn.from = (t, e, n, r, s, i) => {
  const o = Object.create(Lo);
  b.toFlatObject(t, o, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const a = t && t.message ? t.message : "Error", u = e == null && t ? t.code : e;
  return cn.call(o, a, u, n, r, s), t && o.cause == null && Object.defineProperty(o, "cause", { value: t, configurable: !0 }), o.name = t && t.name || "Error", i && Object.assign(o, i), o;
};
const te = cn;
function xs(t) {
  return b.isPlainObject(t) || b.isArray(t);
}
function su(t) {
  return b.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Do(t, e, n) {
  return t ? t.concat(e).map(function(r, s) {
    return r = su(r), !n && s ? "[" + r + "]" : r;
  }).join(n ? "." : "") : e;
}
const wf = b.toFlatObject(b, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
}), Zr = function(t, e, n) {
  if (!b.isObject(t)) throw new TypeError("target must be an object");
  e = e || new FormData();
  const r = (n = b.toFlatObject(n, { metaTokens: !0, dots: !1, indexes: !1 }, !1, function(f, h) {
    return !b.isUndefined(h[f]);
  })).metaTokens, s = n.visitor || c, i = n.dots, o = n.indexes, a = (n.Blob || typeof Blob < "u" && Blob) && b.isSpecCompliantForm(e);
  if (!b.isFunction(s)) throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null) return "";
    if (b.isDate(f)) return f.toISOString();
    if (b.isBoolean(f)) return f.toString();
    if (!a && b.isBlob(f)) throw new te("Blob is not supported. Use a Buffer instead.");
    return b.isArrayBuffer(f) || b.isTypedArray(f) ? a && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, h, v) {
    let p = f;
    if (f && !v && typeof f == "object") {
      if (b.endsWith(h, "{}")) h = r ? h : h.slice(0, -2), f = JSON.stringify(f);
      else if (b.isArray(f) && function(_) {
        return b.isArray(_) && !_.some(xs);
      }(f) || (b.isFileList(f) || b.endsWith(h, "[]")) && (p = b.toArray(f))) return h = su(h), p.forEach(function(_, K) {
        !b.isUndefined(_) && _ !== null && e.append(o === !0 ? Do([h], K, i) : o === null ? h : h + "[]", u(_));
      }), !1;
    }
    return !!xs(f) || (e.append(Do(v, h, i), u(f)), !1);
  }
  const l = [], d = Object.assign(wf, { defaultVisitor: c, convertValue: u, isVisitable: xs });
  if (!b.isObject(t)) throw new TypeError("data must be an object");
  return function f(h, v) {
    if (!b.isUndefined(h)) {
      if (l.indexOf(h) !== -1) throw Error("Circular reference detected in " + v.join("."));
      l.push(h), b.forEach(h, function(p, _) {
        (!(b.isUndefined(p) || p === null) && s.call(e, p, b.isString(_) ? _.trim() : _, v, d)) === !0 && f(p, v ? v.concat(_) : [_]);
      }), l.pop();
    }
  }(t), e;
};
function Fo(t) {
  const e = { "!": "%21", "'": "%27", "(": "%28", ")": "%29", "~": "%7E", "%20": "+", "%00": "\0" };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(n) {
    return e[n];
  });
}
function iu(t, e) {
  this._pairs = [], t && Zr(t, this, e);
}
const $o = iu.prototype;
$o.append = function(t, e) {
  this._pairs.push([t, e]);
}, $o.toString = function(t) {
  const e = t ? function(n) {
    return t.call(this, n, Fo);
  } : Fo;
  return this._pairs.map(function(n) {
    return e(n[0]) + "=" + e(n[1]);
  }, "").join("&");
};
const ou = iu;
function xf(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function au(t, e, n) {
  if (!e) return t;
  const r = n && n.encode || xf;
  b.isFunction(n) && (n = { serialize: n });
  const s = n && n.serialize;
  let i;
  if (i = s ? s(e, n) : b.isURLSearchParams(e) ? e.toString() : new ou(e, n).toString(r), i) {
    const o = t.indexOf("#");
    o !== -1 && (t = t.slice(0, o)), t += (t.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return t;
}
const Bo = class {
  constructor() {
    this.handlers = [];
  }
  use(t, e, n) {
    return this.handlers.push({ fulfilled: t, rejected: e, synchronous: !!n && n.synchronous, runWhen: n ? n.runWhen : null }), this.handlers.length - 1;
  }
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(t) {
    b.forEach(this.handlers, function(e) {
      e !== null && t(e);
    });
  }
}, uu = { silentJSONParsing: !0, forcedJSONParsing: !0, clarifyTimeoutError: !1 }, Sf = { isBrowser: !0, classes: { URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : ou, FormData: typeof FormData < "u" ? FormData : null, Blob: typeof Blob < "u" ? Blob : null }, protocols: ["http", "https", "file", "blob", "url", "data"] }, ui = typeof window < "u" && typeof document < "u", Ws = typeof navigator == "object" && navigator || void 0, Rf = ui && (!Ws || ["ReactNative", "NativeScript", "NS"].indexOf(Ws.product) < 0), _f = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Of = ui && window.location.href || "http://localhost", qe = { ...Fs, ...Sf }, cu = function(t) {
  function e(n, r, s, i) {
    let o = n[i++];
    if (o === "__proto__") return !0;
    const a = Number.isFinite(+o), u = i >= n.length;
    return o = !o && b.isArray(s) ? s.length : o, u ? (b.hasOwnProp(s, o) ? s[o] = [s[o], r] : s[o] = r, !a) : (s[o] && b.isObject(s[o]) || (s[o] = []), e(n, r, s[o], i) && b.isArray(s[o]) && (s[o] = function(c) {
      const l = {}, d = Object.keys(c);
      let f;
      const h = d.length;
      let v;
      for (f = 0; f < h; f++) v = d[f], l[v] = c[v];
      return l;
    }(s[o])), !a);
  }
  if (b.isFormData(t) && b.isFunction(t.entries)) {
    const n = {};
    return b.forEachEntry(t, (r, s) => {
      e(function(i) {
        return b.matchAll(/\w+|\[(\w*)]/g, i).map((o) => o[0] === "[]" ? "" : o[1] || o[0]);
      }(r), s, n, 0);
    }), n;
  }
  return null;
}, ci = { transitional: uu, adapter: ["xhr", "http", "fetch"], transformRequest: [function(t, e) {
  const n = e.getContentType() || "", r = n.indexOf("application/json") > -1, s = b.isObject(t);
  if (s && b.isHTMLForm(t) && (t = new FormData(t)), b.isFormData(t)) return r ? JSON.stringify(cu(t)) : t;
  if (b.isArrayBuffer(t) || b.isBuffer(t) || b.isStream(t) || b.isFile(t) || b.isBlob(t) || b.isReadableStream(t)) return t;
  if (b.isArrayBufferView(t)) return t.buffer;
  if (b.isURLSearchParams(t)) return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
  let i;
  if (s) {
    if (n.indexOf("application/x-www-form-urlencoded") > -1) return function(o, a) {
      return Zr(o, new qe.classes.URLSearchParams(), { visitor: function(u, c, l, d) {
        return qe.isNode && b.isBuffer(u) ? (this.append(c, u.toString("base64")), !1) : d.defaultVisitor.apply(this, arguments);
      }, ...a });
    }(t, this.formSerializer).toString();
    if ((i = b.isFileList(t)) || n.indexOf("multipart/form-data") > -1) {
      const o = this.env && this.env.FormData;
      return Zr(i ? { "files[]": t } : t, o && new o(), this.formSerializer);
    }
  }
  return s || r ? (e.setContentType("application/json", !1), function(o) {
    if (b.isString(o)) try {
      return (0, JSON.parse)(o), b.trim(o);
    } catch (a) {
      if (a.name !== "SyntaxError") throw a;
    }
    return (0, JSON.stringify)(o);
  }(t)) : t;
}], transformResponse: [function(t) {
  const e = this.transitional || ci.transitional, n = e && e.forcedJSONParsing, r = this.responseType === "json";
  if (b.isResponse(t) || b.isReadableStream(t)) return t;
  if (t && b.isString(t) && (n && !this.responseType || r)) {
    const s = !(e && e.silentJSONParsing) && r;
    try {
      return JSON.parse(t, this.parseReviver);
    } catch (i) {
      if (s)
        throw i.name === "SyntaxError" ? te.from(i, te.ERR_BAD_RESPONSE, this, null, this.response) : i;
    }
  }
  return t;
}], timeout: 0, xsrfCookieName: "XSRF-TOKEN", xsrfHeaderName: "X-XSRF-TOKEN", maxContentLength: -1, maxBodyLength: -1, env: { FormData: qe.classes.FormData, Blob: qe.classes.Blob }, validateStatus: function(t) {
  return t >= 200 && t < 300;
}, headers: { common: { Accept: "application/json, text/plain, */*", "Content-Type": void 0 } } };
b.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  ci.headers[t] = {};
});
const li = ci, Ef = b.toObjectSet(["age", "authorization", "content-length", "content-type", "etag", "expires", "from", "host", "if-modified-since", "if-unmodified-since", "last-modified", "location", "max-forwards", "proxy-authorization", "referer", "retry-after", "user-agent"]), Mo = Symbol("internals");
function Cn(t) {
  return t && String(t).trim().toLowerCase();
}
function wr(t) {
  return t === !1 || t == null ? t : b.isArray(t) ? t.map(wr) : String(t);
}
function Ss(t, e, n, r, s) {
  return b.isFunction(r) ? r.call(this, e, n) : (s && (e = n), b.isString(e) ? b.isString(r) ? e.indexOf(r) !== -1 : b.isRegExp(r) ? r.test(e) : void 0 : void 0);
}
class xr {
  constructor(e) {
    e && this.set(e);
  }
  set(e, n, r) {
    const s = this;
    function i(a, u, c) {
      const l = Cn(u);
      if (!l) throw new Error("header name must be a non-empty string");
      const d = b.findKey(s, l);
      (!d || s[d] === void 0 || c === !0 || c === void 0 && s[d] !== !1) && (s[d || u] = wr(a));
    }
    const o = (a, u) => b.forEach(a, (c, l) => i(c, l, u));
    if (b.isPlainObject(e) || e instanceof this.constructor) o(e, n);
    else if (b.isString(e) && (e = e.trim()) && !/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim())) o(((a) => {
      const u = {};
      let c, l, d;
      return a && a.split(`
`).forEach(function(f) {
        d = f.indexOf(":"), c = f.substring(0, d).trim().toLowerCase(), l = f.substring(d + 1).trim(), !c || u[c] && Ef[c] || (c === "set-cookie" ? u[c] ? u[c].push(l) : u[c] = [l] : u[c] = u[c] ? u[c] + ", " + l : l);
      }), u;
    })(e), n);
    else if (b.isObject(e) && b.isIterable(e)) {
      let a, u, c = {};
      for (const l of e) {
        if (!b.isArray(l)) throw TypeError("Object iterator must return a key-value pair");
        c[u = l[0]] = (a = c[u]) ? b.isArray(a) ? [...a, l[1]] : [a, l[1]] : l[1];
      }
      o(c, n);
    } else e != null && i(n, e, r);
    return this;
  }
  get(e, n) {
    if (e = Cn(e)) {
      const r = b.findKey(this, e);
      if (r) {
        const s = this[r];
        if (!n) return s;
        if (n === !0) return function(i) {
          const o = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
          let u;
          for (; u = a.exec(i); ) o[u[1]] = u[2];
          return o;
        }(s);
        if (b.isFunction(n)) return n.call(this, s, r);
        if (b.isRegExp(n)) return n.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, n) {
    if (e = Cn(e)) {
      const r = b.findKey(this, e);
      return !(!r || this[r] === void 0 || n && !Ss(0, this[r], r, n));
    }
    return !1;
  }
  delete(e, n) {
    const r = this;
    let s = !1;
    function i(o) {
      if (o = Cn(o)) {
        const a = b.findKey(r, o);
        !a || n && !Ss(0, r[a], a, n) || (delete r[a], s = !0);
      }
    }
    return b.isArray(e) ? e.forEach(i) : i(e), s;
  }
  clear(e) {
    const n = Object.keys(this);
    let r = n.length, s = !1;
    for (; r--; ) {
      const i = n[r];
      e && !Ss(0, this[i], i, e, !0) || (delete this[i], s = !0);
    }
    return s;
  }
  normalize(e) {
    const n = this, r = {};
    return b.forEach(this, (s, i) => {
      const o = b.findKey(r, i);
      if (o) return n[o] = wr(s), void delete n[i];
      const a = e ? function(u) {
        return u.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (c, l, d) => l.toUpperCase() + d);
      }(i) : String(i).trim();
      a !== i && delete n[i], n[a] = wr(s), r[a] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const n = /* @__PURE__ */ Object.create(null);
    return b.forEach(this, (r, s) => {
      r != null && r !== !1 && (n[s] = e && b.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, n]) => e + ": " + n).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...n) {
    const r = new this(e);
    return n.forEach((s) => r.set(s)), r;
  }
  static accessor(e) {
    const n = (this[Mo] = this[Mo] = { accessors: {} }).accessors, r = this.prototype;
    function s(i) {
      const o = Cn(i);
      n[o] || (function(a, u) {
        const c = b.toCamelCase(" " + u);
        ["get", "set", "has"].forEach((l) => {
          Object.defineProperty(a, l + c, { value: function(d, f, h) {
            return this[l].call(this, u, d, f, h);
          }, configurable: !0 });
        });
      }(r, i), n[o] = !0);
    }
    return b.isArray(e) ? e.forEach(s) : s(e), this;
  }
}
xr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]), b.reduceDescriptors(xr.prototype, ({ value: t }, e) => {
  let n = e[0].toUpperCase() + e.slice(1);
  return { get: () => t, set(r) {
    this[n] = r;
  } };
}), b.freezeMethods(xr);
const pt = xr;
function Rs(t, e) {
  const n = this || li, r = e || n, s = pt.from(r.headers);
  let i = r.data;
  return b.forEach(t, function(o) {
    i = o.call(n, i, s.normalize(), e ? e.status : void 0);
  }), s.normalize(), i;
}
function lu(t) {
  return !(!t || !t.__CANCEL__);
}
function du(t, e, n) {
  te.call(this, t ?? "canceled", te.ERR_CANCELED, e, n), this.name = "CanceledError";
}
b.inherits(du, te, { __CANCEL__: !0 });
const Vn = du;
function fu(t, e, n) {
  const r = n.config.validateStatus;
  n.status && r && !r(n.status) ? e(new te("Request failed with status code " + n.status, [te.ERR_BAD_REQUEST, te.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4], n.config, n.request, n)) : t(n);
}
const Wr = (t, e, n = 3) => {
  let r = 0;
  const s = function(i, o) {
    i = i || 10;
    const a = new Array(i), u = new Array(i);
    let c, l = 0, d = 0;
    return o = o !== void 0 ? o : 1e3, function(f) {
      const h = Date.now(), v = u[d];
      c || (c = h), a[l] = f, u[l] = h;
      let p = d, _ = 0;
      for (; p !== l; ) _ += a[p++], p %= i;
      if (l = (l + 1) % i, l === d && (d = (d + 1) % i), h - c < o) return;
      const K = v && h - v;
      return K ? Math.round(1e3 * _ / K) : void 0;
    };
  }(50, 250);
  return function(i, o) {
    let a, u, c = 0, l = 1e3 / o;
    const d = (f, h = Date.now()) => {
      c = h, a = null, u && (clearTimeout(u), u = null), i(...f);
    };
    return [(...f) => {
      const h = Date.now(), v = h - c;
      v >= l ? d(f, h) : (a = f, u || (u = setTimeout(() => {
        u = null, d(a);
      }, l - v)));
    }, () => a && d(a)];
  }((i) => {
    const o = i.loaded, a = i.lengthComputable ? i.total : void 0, u = o - r, c = s(u);
    r = o, t({ loaded: o, total: a, progress: a ? o / a : void 0, bytes: u, rate: c || void 0, estimated: c && a && o <= a ? (a - o) / c : void 0, event: i, lengthComputable: a != null, [e ? "download" : "upload"]: !0 });
  }, n);
}, zo = (t, e) => {
  const n = t != null;
  return [(r) => e[0]({ lengthComputable: n, total: t, loaded: r }), e[1]];
}, qo = (t) => (...e) => b.asap(() => t(...e)), Tf = qe.hasStandardBrowserEnv ? /* @__PURE__ */ ((t, e) => (n) => (n = new URL(n, qe.origin), t.protocol === n.protocol && t.host === n.host && (e || t.port === n.port)))(new URL(qe.origin), qe.navigator && /(msie|trident)/i.test(qe.navigator.userAgent)) : () => !0, Cf = qe.hasStandardBrowserEnv ? { write(t, e, n, r, s, i, o) {
  if (typeof document > "u") return;
  const a = [`${t}=${encodeURIComponent(e)}`];
  b.isNumber(n) && a.push(`expires=${new Date(n).toUTCString()}`), b.isString(r) && a.push(`path=${r}`), b.isString(s) && a.push(`domain=${s}`), i === !0 && a.push("secure"), b.isString(o) && a.push(`SameSite=${o}`), document.cookie = a.join("; ");
}, read(t) {
  if (typeof document > "u") return null;
  const e = document.cookie.match(new RegExp("(?:^|; )" + t + "=([^;]*)"));
  return e ? decodeURIComponent(e[1]) : null;
}, remove(t) {
  this.write(t, "", Date.now() - 864e5, "/");
} } : { write() {
}, read: () => null, remove() {
} };
function hu(t, e, n) {
  let r = !/^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
  return t && (r || n == 0) ? function(s, i) {
    return i ? s.replace(/\/?\/$/, "") + "/" + i.replace(/^\/+/, "") : s;
  }(t, e) : e;
}
const Ho = (t) => t instanceof pt ? { ...t } : t;
function Gt(t, e) {
  e = e || {};
  const n = {};
  function r(c, l, d, f) {
    return b.isPlainObject(c) && b.isPlainObject(l) ? b.merge.call({ caseless: f }, c, l) : b.isPlainObject(l) ? b.merge({}, l) : b.isArray(l) ? l.slice() : l;
  }
  function s(c, l, d, f) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c, 0, f) : r(c, l, 0, f);
  }
  function i(c, l) {
    if (!b.isUndefined(l)) return r(void 0, l);
  }
  function o(c, l) {
    return b.isUndefined(l) ? b.isUndefined(c) ? void 0 : r(void 0, c) : r(void 0, l);
  }
  function a(c, l, d) {
    return d in e ? r(c, l) : d in t ? r(void 0, c) : void 0;
  }
  const u = { url: i, method: i, data: i, baseURL: o, transformRequest: o, transformResponse: o, paramsSerializer: o, timeout: o, timeoutMessage: o, withCredentials: o, withXSRFToken: o, adapter: o, responseType: o, xsrfCookieName: o, xsrfHeaderName: o, onUploadProgress: o, onDownloadProgress: o, decompress: o, maxContentLength: o, maxBodyLength: o, beforeRedirect: o, transport: o, httpAgent: o, httpsAgent: o, cancelToken: o, socketPath: o, responseEncoding: o, validateStatus: a, headers: (c, l, d) => s(Ho(c), Ho(l), 0, !0) };
  return b.forEach(Object.keys({ ...t, ...e }), function(c) {
    const l = u[c] || s, d = l(t[c], e[c], c);
    b.isUndefined(d) && l !== a || (n[c] = d);
  }), n;
}
const pu = (t) => {
  const e = Gt({}, t);
  let { data: n, withXSRFToken: r, xsrfHeaderName: s, xsrfCookieName: i, headers: o, auth: a } = e;
  if (e.headers = o = pt.from(o), e.url = au(hu(e.baseURL, e.url, e.allowAbsoluteUrls), t.params, t.paramsSerializer), a && o.set("Authorization", "Basic " + btoa((a.username || "") + ":" + (a.password ? unescape(encodeURIComponent(a.password)) : ""))), b.isFormData(n)) {
    if (qe.hasStandardBrowserEnv || qe.hasStandardBrowserWebWorkerEnv) o.setContentType(void 0);
    else if (b.isFunction(n.getHeaders)) {
      const u = n.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(u).forEach(([l, d]) => {
        c.includes(l.toLowerCase()) && o.set(l, d);
      });
    }
  }
  if (qe.hasStandardBrowserEnv && (r && b.isFunction(r) && (r = r(e)), r || r !== !1 && Tf(e.url))) {
    const u = s && i && Cf.read(i);
    u && o.set(s, u);
  }
  return e;
}, jf = typeof XMLHttpRequest < "u" && function(t) {
  return new Promise(function(e, n) {
    const r = pu(t);
    let s = r.data;
    const i = pt.from(r.headers).normalize();
    let o, a, u, c, l, { responseType: d, onUploadProgress: f, onDownloadProgress: h } = r;
    function v() {
      c && c(), l && l(), r.cancelToken && r.cancelToken.unsubscribe(o), r.signal && r.signal.removeEventListener("abort", o);
    }
    let p = new XMLHttpRequest();
    function _() {
      if (!p) return;
      const T = pt.from("getAllResponseHeaders" in p && p.getAllResponseHeaders());
      fu(function(V) {
        e(V), v();
      }, function(V) {
        n(V), v();
      }, { data: d && d !== "text" && d !== "json" ? p.response : p.responseText, status: p.status, statusText: p.statusText, headers: T, config: t, request: p }), p = null;
    }
    p.open(r.method.toUpperCase(), r.url, !0), p.timeout = r.timeout, "onloadend" in p ? p.onloadend = _ : p.onreadystatechange = function() {
      p && p.readyState === 4 && (p.status !== 0 || p.responseURL && p.responseURL.indexOf("file:") === 0) && setTimeout(_);
    }, p.onabort = function() {
      p && (n(new te("Request aborted", te.ECONNABORTED, t, p)), p = null);
    }, p.onerror = function(T) {
      const V = T && T.message ? T.message : "Network Error", M = new te(V, te.ERR_NETWORK, t, p);
      M.event = T || null, n(M), p = null;
    }, p.ontimeout = function() {
      let T = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded";
      const V = r.transitional || uu;
      r.timeoutErrorMessage && (T = r.timeoutErrorMessage), n(new te(T, V.clarifyTimeoutError ? te.ETIMEDOUT : te.ECONNABORTED, t, p)), p = null;
    }, s === void 0 && i.setContentType(null), "setRequestHeader" in p && b.forEach(i.toJSON(), function(T, V) {
      p.setRequestHeader(V, T);
    }), b.isUndefined(r.withCredentials) || (p.withCredentials = !!r.withCredentials), d && d !== "json" && (p.responseType = r.responseType), h && ([u, l] = Wr(h, !0), p.addEventListener("progress", u)), f && p.upload && ([a, c] = Wr(f), p.upload.addEventListener("progress", a), p.upload.addEventListener("loadend", c)), (r.cancelToken || r.signal) && (o = (T) => {
      p && (n(!T || T.type ? new Vn(null, t, p) : T), p.abort(), p = null);
    }, r.cancelToken && r.cancelToken.subscribe(o), r.signal && (r.signal.aborted ? o() : r.signal.addEventListener("abort", o)));
    const K = function(T) {
      const V = /^([-+\w]{1,25})(:?\/\/|:)/.exec(T);
      return V && V[1] || "";
    }(r.url);
    K && qe.protocols.indexOf(K) === -1 ? n(new te("Unsupported protocol " + K + ":", te.ERR_BAD_REQUEST, t)) : p.send(s || null);
  });
}, kf = (t, e) => {
  const { length: n } = t = t ? t.filter(Boolean) : [];
  if (e || n) {
    let r, s = new AbortController();
    const i = function(c) {
      if (!r) {
        r = !0, a();
        const l = c instanceof Error ? c : this.reason;
        s.abort(l instanceof te ? l : new Vn(l instanceof Error ? l.message : l));
      }
    };
    let o = e && setTimeout(() => {
      o = null, i(new te(`timeout ${e} of ms exceeded`, te.ETIMEDOUT));
    }, e);
    const a = () => {
      t && (o && clearTimeout(o), o = null, t.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(i) : c.removeEventListener("abort", i);
      }), t = null);
    };
    t.forEach((c) => c.addEventListener("abort", i));
    const { signal: u } = s;
    return u.unsubscribe = () => b.asap(a), u;
  }
}, Pf = function* (t, e) {
  let n = t.byteLength;
  if (n < e) return void (yield t);
  let r, s = 0;
  for (; s < n; ) r = s + e, yield t.slice(s, r), s = r;
}, Zo = (t, e, n, r) => {
  const s = async function* (u, c) {
    for await (const l of async function* (d) {
      if (d[Symbol.asyncIterator]) return void (yield* d);
      const f = d.getReader();
      try {
        for (; ; ) {
          const { done: h, value: v } = await f.read();
          if (h) break;
          yield v;
        }
      } finally {
        await f.cancel();
      }
    }(u)) yield* Pf(l, c);
  }(t, e);
  let i, o = 0, a = (u) => {
    i || (i = !0, r && r(u));
  };
  return new ReadableStream({ async pull(u) {
    try {
      const { done: c, value: l } = await s.next();
      if (c) return a(), void u.close();
      let d = l.byteLength;
      if (n) {
        let f = o += d;
        n(f);
      }
      u.enqueue(new Uint8Array(l));
    } catch (c) {
      throw a(c), c;
    }
  }, cancel: (u) => (a(u), s.return()) }, { highWaterMark: 2 });
}, { isFunction: ar } = b, If = (({ Request: t, Response: e }) => ({ Request: t, Response: e }))(b.global), { ReadableStream: Wo, TextEncoder: Jo } = b.global, Go = (t, ...e) => {
  try {
    return !!t(...e);
  } catch {
    return !1;
  }
}, Af = (t) => {
  t = b.merge.call({ skipUndefined: !0 }, If, t);
  const { fetch: e, Request: n, Response: r } = t, s = e ? ar(e) : typeof fetch == "function", i = ar(n), o = ar(r);
  if (!s) return !1;
  const a = s && ar(Wo), u = s && (typeof Jo == "function" ? (c = new Jo(), (h) => c.encode(h)) : async (h) => new Uint8Array(await new n(h).arrayBuffer()));
  var c;
  const l = i && a && Go(() => {
    let h = !1;
    const v = new n(qe.origin, { body: new Wo(), method: "POST", get duplex() {
      return h = !0, "half";
    } }).headers.has("Content-Type");
    return h && !v;
  }), d = o && a && Go(() => b.isReadableStream(new r("").body)), f = { stream: d && ((h) => h.body) };
  return s && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((h) => {
    !f[h] && (f[h] = (v, p) => {
      let _ = v && v[h];
      if (_) return _.call(v);
      throw new te(`Response type '${h}' is not supported`, te.ERR_NOT_SUPPORT, p);
    });
  }), async (h) => {
    let { url: v, method: p, data: _, signal: K, cancelToken: T, timeout: V, onDownloadProgress: M, onUploadProgress: ie, responseType: Q, headers: De, withCredentials: Ee = "same-origin", fetchOptions: Ye } = pu(h), at = e || fetch;
    Q = Q ? (Q + "").toLowerCase() : "text";
    let he = kf([K, T && T.toAbortSignal()], V), Fe = null;
    const fe = he && he.unsubscribe && (() => {
      he.unsubscribe();
    });
    let ae;
    try {
      if (ie && l && p !== "get" && p !== "head" && (ae = await (async (_e, Oe) => {
        const $e = b.toFiniteNumber(_e.getContentLength());
        return $e ?? (async (Y) => Y == null ? 0 : b.isBlob(Y) ? Y.size : b.isSpecCompliantForm(Y) ? (await new n(qe.origin, { method: "POST", body: Y }).arrayBuffer()).byteLength : b.isArrayBufferView(Y) || b.isArrayBuffer(Y) ? Y.byteLength : (b.isURLSearchParams(Y) && (Y += ""), b.isString(Y) ? (await u(Y)).byteLength : void 0))(Oe);
      })(De, _)) !== 0) {
        let _e, Oe = new n(v, { method: "POST", body: _, duplex: "half" });
        if (b.isFormData(_) && (_e = Oe.headers.get("content-type")) && De.setContentType(_e), Oe.body) {
          const [$e, Y] = zo(ae, Wr(qo(ie)));
          _ = Zo(Oe.body, 65536, $e, Y);
        }
      }
      b.isString(Ee) || (Ee = Ee ? "include" : "omit");
      const ce = i && "credentials" in n.prototype, Qe = { ...Ye, signal: he, method: p.toUpperCase(), headers: De.normalize().toJSON(), body: _, duplex: "half", credentials: ce ? Ee : void 0 };
      Fe = i && new n(v, Qe);
      let je = await (i ? at(Fe, Ye) : at(v, Qe));
      const vt = d && (Q === "stream" || Q === "response");
      if (d && (M || vt && fe)) {
        const _e = {};
        ["status", "statusText", "headers"].forEach((pe) => {
          _e[pe] = je[pe];
        });
        const Oe = b.toFiniteNumber(je.headers.get("content-length")), [$e, Y] = M && zo(Oe, Wr(qo(M), !0)) || [];
        je = new r(Zo(je.body, 65536, $e, () => {
          Y && Y(), fe && fe();
        }), _e);
      }
      Q = Q || "text";
      let Tt = await f[b.findKey(f, Q) || "text"](je, h);
      return !vt && fe && fe(), await new Promise((_e, Oe) => {
        fu(_e, Oe, { data: Tt, headers: pt.from(je.headers), status: je.status, statusText: je.statusText, config: h, request: Fe });
      });
    } catch (ce) {
      throw fe && fe(), ce && ce.name === "TypeError" && /Load failed|fetch/i.test(ce.message) ? Object.assign(new te("Network Error", te.ERR_NETWORK, h, Fe), { cause: ce.cause || ce }) : te.from(ce, ce && ce.code, h, Fe);
    }
  };
}, Uf = /* @__PURE__ */ new Map(), Vo = (t) => {
  let e = t && t.env || {};
  const { fetch: n, Request: r, Response: s } = e, i = [r, s, n];
  let o, a, u = i.length, c = Uf;
  for (; u--; ) o = i[u], a = c.get(o), a === void 0 && c.set(o, a = u ? /* @__PURE__ */ new Map() : Af(e)), c = a;
  return a;
}, mu = (Vo(), { http: null, xhr: jf, fetch: { get: Vo } });
b.forEach(mu, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const Ko = (t) => `- ${t}`, Lf = (t) => b.isFunction(t) || t === null || t === !1, gu = function(t, e) {
  t = b.isArray(t) ? t : [t];
  const { length: n } = t;
  let r, s;
  const i = {};
  for (let o = 0; o < n; o++) {
    let a;
    if (r = t[o], s = r, !Lf(r) && (s = mu[(a = String(r)).toLowerCase()], s === void 0)) throw new te(`Unknown adapter '${a}'`);
    if (s && (b.isFunction(s) || (s = s.get(e)))) break;
    i[a || "#" + o] = s;
  }
  if (!s) {
    const o = Object.entries(i).map(([u, c]) => `adapter ${u} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build"));
    let a = n ? o.length > 1 ? `since :
` + o.map(Ko).join(`
`) : " " + Ko(o[0]) : "as no adapter specified";
    throw new te("There is no suitable adapter to dispatch the request " + a, "ERR_NOT_SUPPORT");
  }
  return s;
};
function _s(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted) throw new Vn(null, t);
}
function Yo(t) {
  return _s(t), t.headers = pt.from(t.headers), t.data = Rs.call(t, t.transformRequest), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), gu(t.adapter || li.adapter, t)(t).then(function(e) {
    return _s(t), e.data = Rs.call(t, t.transformResponse, e), e.headers = pt.from(e.headers), e;
  }, function(e) {
    return lu(e) || (_s(t), e && e.response && (e.response.data = Rs.call(t, t.transformResponse, e.response), e.response.headers = pt.from(e.response.headers))), Promise.reject(e);
  });
}
const vu = "1.13.2", Jr = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  Jr[t] = function(n) {
    return typeof n === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const Xo = {};
Jr.transitional = function(t, e, n) {
  function r(s, i) {
    return "[Axios v" + vu + "] Transitional option '" + s + "'" + i + (n ? ". " + n : "");
  }
  return (s, i, o) => {
    if (t === !1) throw new te(r(i, " has been removed" + (e ? " in " + e : "")), te.ERR_DEPRECATED);
    return e && !Xo[i] && (Xo[i] = !0, console.warn(r(i, " has been deprecated since v" + e + " and will be removed in the near future"))), !t || t(s, i, o);
  };
}, Jr.spelling = function(t) {
  return (e, n) => (console.warn(`${n} is likely a misspelling of ${t}`), !0);
};
const Sr = { assertOptions: function(t, e, n) {
  if (typeof t != "object") throw new te("options must be an object", te.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(t);
  let s = r.length;
  for (; s-- > 0; ) {
    const i = r[s], o = e[i];
    if (o) {
      const a = t[i], u = a === void 0 || o(a, i, t);
      if (u !== !0) throw new te("option " + i + " must be " + u, te.ERR_BAD_OPTION_VALUE);
    } else if (n !== !0) throw new te("Unknown option " + i, te.ERR_BAD_OPTION);
  }
}, validators: Jr }, xt = Sr.validators;
class Rr {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = { request: new Bo(), response: new Bo() };
  }
  async request(e, n) {
    try {
      return await this._request(e, n);
    } catch (r) {
      if (r instanceof Error) {
        let s = {};
        Error.captureStackTrace ? Error.captureStackTrace(s) : s = new Error();
        const i = s.stack ? s.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? i && !String(r.stack).endsWith(i.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + i) : r.stack = i;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(e, n) {
    typeof e == "string" ? (n = n || {}).url = e : n = e || {}, n = Gt(this.defaults, n);
    const { transitional: r, paramsSerializer: s, headers: i } = n;
    r !== void 0 && Sr.assertOptions(r, { silentJSONParsing: xt.transitional(xt.boolean), forcedJSONParsing: xt.transitional(xt.boolean), clarifyTimeoutError: xt.transitional(xt.boolean) }, !1), s != null && (b.isFunction(s) ? n.paramsSerializer = { serialize: s } : Sr.assertOptions(s, { encode: xt.function, serialize: xt.function }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), Sr.assertOptions(n, { baseUrl: xt.spelling("baseURL"), withXsrfToken: xt.spelling("withXSRFToken") }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let o = i && b.merge(i.common, i[n.method]);
    i && b.forEach(["delete", "get", "head", "post", "put", "patch", "common"], (v) => {
      delete i[v];
    }), n.headers = pt.concat(o, i);
    const a = [];
    let u = !0;
    this.interceptors.request.forEach(function(v) {
      typeof v.runWhen == "function" && v.runWhen(n) === !1 || (u = u && v.synchronous, a.unshift(v.fulfilled, v.rejected));
    });
    const c = [];
    let l;
    this.interceptors.response.forEach(function(v) {
      c.push(v.fulfilled, v.rejected);
    });
    let d, f = 0;
    if (!u) {
      const v = [Yo.bind(this), void 0];
      for (v.unshift(...a), v.push(...c), d = v.length, l = Promise.resolve(n); f < d; ) l = l.then(v[f++], v[f++]);
      return l;
    }
    d = a.length;
    let h = n;
    for (; f < d; ) {
      const v = a[f++], p = a[f++];
      try {
        h = v(h);
      } catch (_) {
        p.call(this, _);
        break;
      }
    }
    try {
      l = Yo.call(this, h);
    } catch (v) {
      return Promise.reject(v);
    }
    for (f = 0, d = c.length; f < d; ) l = l.then(c[f++], c[f++]);
    return l;
  }
  getUri(e) {
    return au(hu((e = Gt(this.defaults, e)).baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
  }
}
b.forEach(["delete", "get", "head", "options"], function(t) {
  Rr.prototype[t] = function(e, n) {
    return this.request(Gt(n || {}, { method: t, url: e, data: (n || {}).data }));
  };
}), b.forEach(["post", "put", "patch"], function(t) {
  function e(n) {
    return function(r, s, i) {
      return this.request(Gt(i || {}, { method: t, headers: n ? { "Content-Type": "multipart/form-data" } : {}, url: r, data: s }));
    };
  }
  Rr.prototype[t] = e(), Rr.prototype[t + "Form"] = e(!0);
});
const _r = Rr;
class di {
  constructor(e) {
    if (typeof e != "function") throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(s) {
      n = s;
    });
    const r = this;
    this.promise.then((s) => {
      if (!r._listeners) return;
      let i = r._listeners.length;
      for (; i-- > 0; ) r._listeners[i](s);
      r._listeners = null;
    }), this.promise.then = (s) => {
      let i;
      const o = new Promise((a) => {
        r.subscribe(a), i = a;
      }).then(s);
      return o.cancel = function() {
        r.unsubscribe(i);
      }, o;
    }, e(function(s, i, o) {
      r.reason || (r.reason = new Vn(s, i, o), n(r.reason));
    });
  }
  throwIfRequested() {
    if (this.reason) throw this.reason;
  }
  subscribe(e) {
    this.reason ? e(this.reason) : this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  unsubscribe(e) {
    if (!this._listeners) return;
    const n = this._listeners.indexOf(e);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const e = new AbortController(), n = (r) => {
      e.abort(r);
    };
    return this.subscribe(n), e.signal.unsubscribe = () => this.unsubscribe(n), e.signal;
  }
  static source() {
    let e;
    return { token: new di(function(n) {
      e = n;
    }), cancel: e };
  }
}
const Nf = di, Js = { Continue: 100, SwitchingProtocols: 101, Processing: 102, EarlyHints: 103, Ok: 200, Created: 201, Accepted: 202, NonAuthoritativeInformation: 203, NoContent: 204, ResetContent: 205, PartialContent: 206, MultiStatus: 207, AlreadyReported: 208, ImUsed: 226, MultipleChoices: 300, MovedPermanently: 301, Found: 302, SeeOther: 303, NotModified: 304, UseProxy: 305, Unused: 306, TemporaryRedirect: 307, PermanentRedirect: 308, BadRequest: 400, Unauthorized: 401, PaymentRequired: 402, Forbidden: 403, NotFound: 404, MethodNotAllowed: 405, NotAcceptable: 406, ProxyAuthenticationRequired: 407, RequestTimeout: 408, Conflict: 409, Gone: 410, LengthRequired: 411, PreconditionFailed: 412, PayloadTooLarge: 413, UriTooLong: 414, UnsupportedMediaType: 415, RangeNotSatisfiable: 416, ExpectationFailed: 417, ImATeapot: 418, MisdirectedRequest: 421, UnprocessableEntity: 422, Locked: 423, FailedDependency: 424, TooEarly: 425, UpgradeRequired: 426, PreconditionRequired: 428, TooManyRequests: 429, RequestHeaderFieldsTooLarge: 431, UnavailableForLegalReasons: 451, InternalServerError: 500, NotImplemented: 501, BadGateway: 502, ServiceUnavailable: 503, GatewayTimeout: 504, HttpVersionNotSupported: 505, VariantAlsoNegotiates: 506, InsufficientStorage: 507, LoopDetected: 508, NotExtended: 510, NetworkAuthenticationRequired: 511, WebServerIsDown: 521, ConnectionTimedOut: 522, OriginIsUnreachable: 523, TimeoutOccurred: 524, SslHandshakeFailed: 525, InvalidSslCertificate: 526 };
Object.entries(Js).forEach(([t, e]) => {
  Js[e] = t;
});
const Df = Js, Le = function t(e) {
  const n = new _r(e), r = tu(_r.prototype.request, n);
  return b.extend(r, _r.prototype, n, { allOwnKeys: !0 }), b.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(s) {
    return t(Gt(e, s));
  }, r;
}(li);
Le.Axios = _r, Le.CanceledError = Vn, Le.CancelToken = Nf, Le.isCancel = lu, Le.VERSION = vu, Le.toFormData = Zr, Le.AxiosError = te, Le.Cancel = Le.CanceledError, Le.all = function(t) {
  return Promise.all(t);
}, Le.spread = function(t) {
  return function(e) {
    return t.apply(null, e);
  };
}, Le.isAxiosError = function(t) {
  return b.isObject(t) && t.isAxiosError === !0;
}, Le.mergeConfig = Gt, Le.AxiosHeaders = pt, Le.formToJSON = (t) => cu(b.isHTMLForm(t) ? new FormData(t) : t), Le.getAdapter = gu, Le.HttpStatusCode = Df, Le.default = Le;
const A = Le;
function yu(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Gs(t, e, n) {
  return Gs = fi() ? Reflect.construct : function(r, s, i) {
    var o = [null];
    o.push.apply(o, s);
    var a = new (Function.bind.apply(r, o))();
    return i && Wn(a, i.prototype), a;
  }, Gs.apply(null, arguments);
}
function Or(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Zn(t) {
  return Zn = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Zn(t);
}
function Wn(t, e) {
  return Wn = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Wn(t, e);
}
function Vs(t) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Vs = function(n) {
    if (n === null || (r = n, Function.toString.call(r).indexOf("[native code]") === -1)) return n;
    var r;
    if (typeof n != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(n)) return e.get(n);
      e.set(n, s);
    }
    function s() {
      return Gs(n, arguments, Zn(this).constructor);
    }
    return s.prototype = Object.create(n.prototype, { constructor: { value: s, enumerable: !1, writable: !0, configurable: !0 } }), Wn(s, n);
  }, Vs(t);
}
function fi() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fi = function() {
    return !!t;
  })();
}
var U = "http://localhost".replace(/\/+$/, ""), nt = function t(e) {
  var n, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : U, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : A;
  yu(this, t), Or(this, "basePath", void 0), Or(this, "axios", void 0), Or(this, "configuration", void 0), this.basePath = r, this.axios = s, e && (this.configuration = e, this.basePath = (n = e.basePath) !== null && n !== void 0 ? n : r);
}, Ff = function() {
  function t(e, n) {
    var r;
    return yu(this, t), Or(r = function(s, i, o) {
      return i = Zn(i), function(a, u) {
        return !u || ((c = u) && typeof Symbol < "u" && c.constructor === Symbol ? "symbol" : typeof c) != "object" && typeof u != "function" ? function(l) {
          if (l === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return l;
        }(a) : u;
        var c;
      }(s, fi() ? Reflect.construct(i, o || [], Zn(s).constructor) : i.apply(s, o));
    }(this, t, [n]), "field", void 0), r.field = e, r.name = "RequiredError", r;
  }
  return function(e, n) {
    if (typeof n != "function" && n !== null) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(n && n.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), n && Wn(e, n);
  }(t, Vs(Error)), t;
}(), L = {};
function Qo(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function $f(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
var N = "https://example.com", I = function(t, e, n) {
  if (n == null) throw new Ff(e, "Required parameter ".concat(e, " was null or undefined when calling ").concat(t, "."));
}, B = function(t, e) {
  return (n = function() {
    var r, s;
    return function(i, o) {
      var a, u, c, l = { label: 0, sent: function() {
        if (1 & c[0]) throw c[1];
        return c[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = f(0), d.throw = f(1), d.return = f(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function f(h) {
        return function(v) {
          return function(p) {
            if (a) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, p[0] && (l = 0)), l; ) try {
              if (a = 1, u && (c = 2 & p[0] ? u.return : p[0] ? u.throw || ((c = u.return) && c.call(u), 0) : u.next) && !(c = c.call(u, p[1])).done) return c;
              switch (u = 0, c && (p = [2 & p[0], c.value]), p[0]) {
                case 0:
                case 1:
                  c = p;
                  break;
                case 4:
                  return l.label++, { value: p[1], done: !1 };
                case 5:
                  l.label++, u = p[1], p = [0];
                  continue;
                case 7:
                  p = l.ops.pop(), l.trys.pop();
                  continue;
                default:
                  if (!((c = (c = l.trys).length > 0 && c[c.length - 1]) || p[0] !== 6 && p[0] !== 2)) {
                    l = 0;
                    continue;
                  }
                  if (p[0] === 3 && (!c || p[1] > c[0] && p[1] < c[3])) {
                    l.label = p[1];
                    break;
                  }
                  if (p[0] === 6 && l.label < c[1]) {
                    l.label = c[1], c = p;
                    break;
                  }
                  if (c && l.label < c[2]) {
                    l.label = c[2], l.ops.push(p);
                    break;
                  }
                  c[2] && l.ops.pop(), l.trys.pop();
                  continue;
              }
              p = o.call(i, l);
            } catch (_) {
              p = [6, _], u = 0;
            } finally {
              a = c = 0;
            }
            if (5 & p[0]) throw p[1];
            return { value: p[0] ? p[1] : void 0, done: !0 };
          }([h, v]);
        };
      }
    }(this, function(i) {
      switch (i.label) {
        case 0:
          return e && e.accessToken ? typeof e.accessToken != "function" ? [3, 2] : [4, e.accessToken()] : [3, 5];
        case 1:
          return s = i.sent(), [3, 4];
        case 2:
          return [4, e.accessToken];
        case 3:
          s = i.sent(), i.label = 4;
        case 4:
          r = s, t.Authorization = "Bearer " + r, i.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var r = this, s = arguments;
    return new Promise(function(i, o) {
      var a = n.apply(r, s);
      function u(l) {
        Qo(a, i, o, u, c, "next", l);
      }
      function c(l) {
        Qo(a, i, o, u, c, "throw", l);
      }
      u(void 0);
    });
  })();
  var n;
};
function Ks(t, e) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  e != null && ((e === void 0 ? "undefined" : (n = e) && typeof Symbol < "u" && n.constructor === Symbol ? "symbol" : typeof n) == "object" ? Array.isArray(e) ? e.forEach(function(s) {
    return Ks(t, s, r);
  }) : Object.keys(e).forEach(function(s) {
    return Ks(t, e[s], "".concat(r).concat(r !== "" ? "." : "").concat(s));
  }) : t.has(r) ? t.append(r, e) : t.set(r, e));
}
var D = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++) n[r - 1] = arguments[r];
  var s = new URLSearchParams(t.search);
  Ks(s, n), t.search = s.toString();
}, Te = function(t, e, n) {
  var r = typeof t != "string";
  return (r && n && n.isJsonMime ? n.isJsonMime(e.headers["Content-Type"]) : r) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, F = function(t) {
  return t.pathname + t.search + t.hash;
}, $ = function(t, e, n, r) {
  return function() {
    var s, i, o, a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : e, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n, c = (i = function(l) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {}, h = Object.keys(f);
        typeof Object.getOwnPropertySymbols == "function" && (h = h.concat(Object.getOwnPropertySymbols(f).filter(function(v) {
          return Object.getOwnPropertyDescriptor(f, v).enumerable;
        }))), h.forEach(function(v) {
          $f(l, v, f[v]);
        });
      }
      return l;
    }({}, t.options), o = (o = { url: (a.defaults.baseURL ? "" : (s = r == null ? void 0 : r.basePath) !== null && s !== void 0 ? s : u) + t.url }) != null ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(o)) : function(l) {
      var d = Object.keys(l);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(l);
        d.push.apply(d, f);
      }
      return d;
    }(Object(o)).forEach(function(l) {
      Object.defineProperty(i, l, Object.getOwnPropertyDescriptor(o, l));
    }), i);
    return a.request(c);
  };
};
function ea(t, e, n, r, s, i, o) {
  try {
    var a = t[i](o), u = a.value;
  } catch (c) {
    return void n(c);
  }
  a.done ? e(u) : Promise.resolve(u).then(r, s);
}
function x(t) {
  return function() {
    var e = this, n = arguments;
    return new Promise(function(r, s) {
      var i = t.apply(e, n);
      function o(u) {
        ea(i, r, s, o, a, "next", u);
      }
      function a(u) {
        ea(i, r, s, o, a, "throw", u);
      }
      o(void 0);
    });
  };
}
function rt(t, e, n) {
  return e = Gr(e), function(r, s) {
    return !s || ((i = s) && typeof Symbol < "u" && i.constructor === Symbol ? "symbol" : typeof i) != "object" && typeof s != "function" ? function(o) {
      if (o === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return o;
    }(r) : s;
    var i;
  }(t, bu() ? Reflect.construct(e, n || [], Gr(t).constructor) : e.apply(t, n));
}
function st(t, e) {
  if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function Bf(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function it(t, e, n) {
  return e && Bf(t.prototype, e), t;
}
function Mf(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function Gr(t) {
  return Gr = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, Gr(t);
}
function ot(t, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), e && Ys(t, e);
}
function w(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Mf(t, s, n[s]);
    });
  }
  return t;
}
function Ys(t, e) {
  return Ys = Object.setPrototypeOf || function(n, r) {
    return n.__proto__ = r, n;
  }, Ys(t, e);
}
function bu() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (bu = function() {
    return !!t;
  })();
}
function S(t, e) {
  var n, r, s, i = { label: 0, sent: function() {
    if (1 & s[0]) throw s[1];
    return s[1];
  }, trys: [], ops: [] }, o = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return o.next = a(0), o.throw = a(1), o.return = a(2), typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function a(u) {
    return function(c) {
      return function(l) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; o && (o = 0, l[0] && (i = 0)), i; ) try {
          if (n = 1, r && (s = 2 & l[0] ? r.return : l[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, l[1])).done) return s;
          switch (r = 0, s && (l = [2 & l[0], s.value]), l[0]) {
            case 0:
            case 1:
              s = l;
              break;
            case 4:
              return i.label++, { value: l[1], done: !1 };
            case 5:
              i.label++, r = l[1], l = [0];
              continue;
            case 7:
              l = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!((s = (s = i.trys).length > 0 && s[s.length - 1]) || l[0] !== 6 && l[0] !== 2)) {
                i = 0;
                continue;
              }
              if (l[0] === 3 && (!s || l[1] > s[0] && l[1] < s[3])) {
                i.label = l[1];
                break;
              }
              if (l[0] === 6 && i.label < s[1]) {
                i.label = s[1], s = l;
                break;
              }
              if (s && i.label < s[2]) {
                i.label = s[2], i.ops.push(l);
                break;
              }
              s[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          l = e.call(t, i);
        } catch (d) {
          l = [6, d], r = 0;
        } finally {
          n = s = 0;
        }
        if (5 & l[0]) throw l[1];
        return { value: l[0] ? l[1] : void 0, done: !0 };
      }([u, c]);
    };
  }
}
var zf = function(t) {
  return { listBreaks: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("listBreaks", "showId", e), s = new URL("/break", N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.showId = e), n !== void 0 && (u.ring = n), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  } };
}, qf = function(t) {
  var e = zf(t);
  return { listBreaks: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listBreaks(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["BreaksApi.listBreaks"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "listBreaks", value: function(n, r, s) {
    var i = this;
    return qf(this.configuration).listBreaks(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
var Hf = function(t) {
  return { getClass: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getClass", "classId", e), r = "/class/{classId}".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listClasses: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("listClasses", "showId", e), s = new URL("/class", N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.showId = e), n !== void 0 && (u.mine = n), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassErrorDeductionScheme", "classId", e), I("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", n), s = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassFaultTimeLimit", "classId", e), I("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", n), s = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassQualityJudging: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassQualityJudging", "classId", e), I("setClassQualityJudging", "setClassQualityJudgingRequest", n), s = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassScribeAssignment: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassScribeAssignment", "classId", e), I("setClassScribeAssignment", "setClassScribeAssignmentRequest", n), s = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassSectionJudgeAssignments", "classId", e), s = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setRingScribeAssignments: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setRingScribeAssignments", "ring", e), I("setRingScribeAssignments", "setRingScribeAssignmentsRequest", n), s = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, Nt = function(t) {
  var e = Hf(t);
  return { getClass: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getClass(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ClassesApi.getClass"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listClasses: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listClasses(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ClassesApi.listClasses"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassErrorDeductionScheme(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ClassesApi.setClassErrorDeductionScheme"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassFaultTimeLimit(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ClassesApi.setClassFaultTimeLimit"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassQualityJudging(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ClassesApi.setClassQualityJudging"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassScribeAssignment(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ClassesApi.setClassScribeAssignment"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassSectionJudgeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ClassesApi.setClassSectionJudgeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRingScribeAssignments(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ClassesApi.setRingScribeAssignments"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "getClass", value: function(n, r) {
    var s = this;
    return Nt(this.configuration).getClass(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listClasses", value: function(n, r, s) {
    var i = this;
    return Nt(this.configuration).listClasses(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(n, r, s) {
    var i = this;
    return Nt(this.configuration).setClassErrorDeductionScheme(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(n, r, s) {
    var i = this;
    return Nt(this.configuration).setClassFaultTimeLimit(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(n, r, s) {
    var i = this;
    return Nt(this.configuration).setClassQualityJudging(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(n, r, s) {
    var i = this;
    return Nt(this.configuration).setClassScribeAssignment(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(n, r, s) {
    var i = this;
    return Nt(this.configuration).setClassSectionJudgeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(n, r, s) {
    var i = this;
    return Nt(this.configuration).setRingScribeAssignments(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
var Zf = function(t) {
  return { getDaysheetReconcileStatus: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getDaysheetReconcileStatus", "showId", e), r = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, reconcileDaysheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("reconcileDaysheet", "showId", e), r = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  } };
}, ta = function(t) {
  var e = Zf(t);
  return { getDaysheetReconcileStatus: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getDaysheetReconcileStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["DaySheetApi.getDaysheetReconcileStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.reconcileDaysheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["DaySheetApi.reconcileDaysheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "getDaysheetReconcileStatus", value: function(n, r) {
    var s = this;
    return ta(this.configuration).getDaysheetReconcileStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(n, r) {
    var s = this;
    return ta(this.configuration).reconcileDaysheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }]), e;
})(nt);
var Wf = function(t) {
  return { getHealth: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o;
      return S(this, function(a) {
        return n = new URL("/health", N), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), i = {}, D(n, {}), o = r && r.headers ? r.headers : {}, s.headers = w({}, i, o, e.headers), [2, { url: F(n), options: s }];
      });
    })();
  } };
}, Jf = function(t) {
  var e = Wf(t);
  return { getHealth: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.getHealth(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = L["HealthApi.getHealth"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return $(i, A, U, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "getHealth", value: function(n) {
    var r = this;
    return Jf(this.configuration).getHealth(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(nt);
var Gf = function(t) {
  return { getHorse: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getHorse", "id", e), r = "/horse/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listHorses: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o, a;
      return S(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/horse", N), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), o = {}, [4, B(i = {}, t)];
          case 1:
            return u.sent(), D(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, e.headers), [2, { url: F(n), options: s }];
        }
      });
    })();
  } };
}, na = function(t) {
  var e = Gf(t);
  return { getHorse: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getHorse(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["HorsesApi.getHorse"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listHorses: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.listHorses(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = L["HorsesApi.listHorses"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return $(i, A, U, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "getHorse", value: function(n, r) {
    var s = this;
    return na(this.configuration).getHorse(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listHorses", value: function(n) {
    var r = this;
    return na(this.configuration).listHorses(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(nt);
var Vf = function(t) {
  return { deleteJudgeSignature: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("deleteJudgeSignature", "id", e), r = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listJudges: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return I("listJudges", "showId", e), r = new URL("/judge", N), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.showId = e), D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, putJudgeSignature: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("putJudgeSignature", "id", e), I("putJudgeSignature", "putJudgeSignatureRequest", n), s = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, Os = function(t) {
  var e = Vf(t);
  return { deleteJudgeSignature: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteJudgeSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["JudgesApi.deleteJudgeSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listJudges: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listJudges(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["JudgesApi.listJudges"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.putJudgeSignature(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["JudgesApi.putJudgeSignature"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "deleteJudgeSignature", value: function(n, r) {
    var s = this;
    return Os(this.configuration).deleteJudgeSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listJudges", value: function(n, r) {
    var s = this;
    return Os(this.configuration).listJudges(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(n, r, s) {
    var i = this;
    return Os(this.configuration).putJudgeSignature(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
var Kf = function(t) {
  return { createPerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Te(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, deletePerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("deletePerson", "id", e), r = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getPerson: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getPerson", "id", e), r = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listPeople: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/people", N), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.personType = e), D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, updatePerson: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("updatePerson", "id", e), s = "/people/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, jn = function(t) {
  var e = Kf(t);
  return { createPerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["PeopleApi.createPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, deletePerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deletePerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["PeopleApi.deletePerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, getPerson: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getPerson(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["PeopleApi.getPerson"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listPeople: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listPeople(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["PeopleApi.listPeople"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, updatePerson: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updatePerson(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["PeopleApi.updatePerson"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "createPerson", value: function(n, r) {
    var s = this;
    return jn(this.configuration).createPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deletePerson", value: function(n, r) {
    var s = this;
    return jn(this.configuration).deletePerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getPerson", value: function(n, r) {
    var s = this;
    return jn(this.configuration).getPerson(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listPeople", value: function(n, r) {
    var s = this;
    return jn(this.configuration).listPeople(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updatePerson", value: function(n, r, s) {
    var i = this;
    return jn(this.configuration).updatePerson(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
var Yf = function(t) {
  return { getClassResults: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getClassResults", "classId", e), r = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getRideResult: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getRideResult", "rideId", e), r = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, setClassPlacings: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setClassPlacings", "classId", e), I("setClassPlacings", "setClassPlacingsRequest", n), s = "/class/{classId}/placings".replace("{classId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setRidePlacing: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setRidePlacing", "rideId", e), s = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, ur = function(t) {
  var e = Yf(t);
  return { getClassResults: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getClassResults(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ResultsApi.getClassResults"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRideResult: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRideResult(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ResultsApi.getRideResult"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, setClassPlacings: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setClassPlacings(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ResultsApi.setClassPlacings"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setRidePlacing: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRidePlacing(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ResultsApi.setRidePlacing"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "getClassResults", value: function(n, r) {
    var s = this;
    return ur(this.configuration).getClassResults(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideResult", value: function(n, r) {
    var s = this;
    return ur(this.configuration).getRideResult(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "setClassPlacings", value: function(n, r, s) {
    var i = this;
    return ur(this.configuration).setClassPlacings(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRidePlacing", value: function(n, r, s) {
    var i = this;
    return ur(this.configuration).setRidePlacing(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
var Xf = function(t) {
  return { batchRideStatus: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return I("batchRideStatus", "batchRideStatusRequest", e), r = new URL("/rides/status", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Te(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, createRide: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/ride", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Te(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, createRideUtilityEvent: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("createRideUtilityEvent", "rideId", e), I("createRideUtilityEvent", "createRideUtilityEventRequest", n), s = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("deleteRideUtilityEvent", "rideId", e), I("deleteRideUtilityEvent", "eventId", n), s = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(e))).replace("{eventId}", encodeURIComponent(String(n))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "DELETE" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, finalizeRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("finalizeRide", "rideId", e), s = "/ride/{rideId}/finalize".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, getRide: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getRide", "rideId", e), r = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listRideUtilityEvents: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("listRideUtilityEvents", "rideId", e), r = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listRides: function(e, n, r, s, i, o, a) {
    var u = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
    return x(function() {
      var c, l, d, f, h, v;
      return S(this, function(p) {
        switch (p.label) {
          case 0:
            return c = new URL("/ride", N), t && (l = t.baseOptions), d = w({ method: "GET" }, l, u), h = {}, [4, B(f = {}, t)];
          case 1:
            return p.sent(), e !== void 0 && (h.classId = e), n !== void 0 && (h.showId = n), r !== void 0 && (h.day = r), s !== void 0 && (h.ring = s), i !== void 0 && (h.needsReview = i), o !== void 0 && (h.riderId = o), a !== void 0 && (h.horseId = a), D(c, h), v = l && l.headers ? l.headers : {}, d.headers = w({}, f, v, u.headers), [2, { url: F(c), options: d }];
        }
      });
    })();
  }, repointRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("repointRide", "rideId", e), I("repointRide", "repointRideRequest", n), s = "/ride/{rideId}/repoint".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, resolveManualRide: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("resolveManualRide", "rideId", e), I("resolveManualRide", "resolveManualRideRequest", n), s = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, setRideStatus: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("setRideStatus", "rideId", e), I("setRideStatus", "setRideStatusRequest", n), s = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, ft = function(t) {
  var e = Xf(t);
  return { batchRideStatus: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.batchRideStatus(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["RidesApi.batchRideStatus"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, createRide: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["RidesApi.createRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.createRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["RidesApi.createRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.deleteRideUtilityEvent(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["RidesApi.deleteRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, finalizeRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.finalizeRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["RidesApi.finalizeRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, getRide: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRide(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["RidesApi.getRide"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listRideUtilityEvents(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["RidesApi.listRideUtilityEvents"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listRides: function(n, r, s, i, o, a, u, c) {
    return x(function() {
      var l, d, f, h, v, p;
      return S(this, function(_) {
        switch (_.label) {
          case 0:
            return [4, e.listRides(n, r, s, i, o, a, u, c)];
          case 1:
            return f = _.sent(), v = (h = t == null ? void 0 : t.serverIndex) !== null && h !== void 0 ? h : 0, p = (d = L["RidesApi.listRides"]) === null || d === void 0 || (l = d[v]) === null || l === void 0 ? void 0 : l.url, [2, function(K, T) {
              return $(f, A, U, t)(K, p || T);
            }];
        }
      });
    })();
  }, repointRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.repointRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["RidesApi.repointRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, resolveManualRide: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.resolveManualRide(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["RidesApi.resolveManualRide"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, setRideStatus: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.setRideStatus(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["RidesApi.setRideStatus"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "batchRideStatus", value: function(n, r) {
    var s = this;
    return ft(this.configuration).batchRideStatus(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRide", value: function(n, r) {
    var s = this;
    return ft(this.configuration).createRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).createRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).deleteRideUtilityEvent(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "finalizeRide", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).finalizeRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getRide", value: function(n, r) {
    var s = this;
    return ft(this.configuration).getRide(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(n, r) {
    var s = this;
    return ft(this.configuration).listRideUtilityEvents(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listRides", value: function(n, r, s, i, o, a, u, c) {
    var l = this;
    return ft(this.configuration).listRides(n, r, s, i, o, a, u, c).then(function(d) {
      return d(l.axios, l.basePath);
    });
  } }, { key: "repointRide", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).repointRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "resolveManualRide", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).resolveManualRide(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setRideStatus", value: function(n, r, s) {
    var i = this;
    return ft(this.configuration).setRideStatus(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
var Qf = function(t) {
  return { completeScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("completeScoreSheet", "id", e), r = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("confirmScoreSheetMarks", "id", e), r = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "POST" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, createScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/scoresheet", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Te(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, getRideAuditTrail: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getRideAuditTrail", "rideId", e), r = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getScoreSheet: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getScoreSheet", "id", e), r = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getScoreSheetAuditTrail", "id", e), r = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getScoreSheetSignature: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getScoreSheetSignature", "id", e), r = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listScoreSheets: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoresheet", N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, r), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), e !== void 0 && (u.rideId = e), n !== void 0 && (u.judgeId = n), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, r.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, reopenScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("reopenScoreSheet", "id", e), I("reopenScoreSheet", "reopenScoreSheetRequest", n), s = "/scoresheet/{id}/reopen".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "POST" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  }, updateScoreSheet: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("updateScoreSheet", "id", e), s = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, St = function(t) {
  var e = Qf(t);
  return { completeScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.completeScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ScoreSheetsApi.completeScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.confirmScoreSheetMarks(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, createScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ScoreSheetsApi.createScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getRideAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ScoreSheetsApi.getRideAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheet: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheet(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ScoreSheetsApi.getScoreSheet"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheetAuditTrail(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getScoreSheetSignature(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ScoreSheetsApi.getScoreSheetSignature"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listScoreSheets: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.listScoreSheets(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ScoreSheetsApi.listScoreSheets"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, reopenScoreSheet: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.reopenScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ScoreSheetsApi.reopenScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updateScoreSheet(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["ScoreSheetsApi.updateScoreSheet"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "completeScoreSheet", value: function(n, r) {
    var s = this;
    return St(this.configuration).completeScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(n, r) {
    var s = this;
    return St(this.configuration).confirmScoreSheetMarks(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "createScoreSheet", value: function(n, r) {
    var s = this;
    return St(this.configuration).createScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(n, r) {
    var s = this;
    return St(this.configuration).getRideAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheet", value: function(n, r) {
    var s = this;
    return St(this.configuration).getScoreSheet(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(n, r) {
    var s = this;
    return St(this.configuration).getScoreSheetAuditTrail(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(n, r) {
    var s = this;
    return St(this.configuration).getScoreSheetSignature(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listScoreSheets", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).listScoreSheets(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "reopenScoreSheet", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).reopenScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(n, r, s) {
    var i = this;
    return St(this.configuration).updateScoreSheet(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
var eh = function(t) {
  return { getShow: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getShow", "id", e), r = "/show/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listShows: function() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return x(function() {
      var n, r, s, i, o, a;
      return S(this, function(u) {
        switch (u.label) {
          case 0:
            return n = new URL("/show", N), t && (r = t.baseOptions), s = w({ method: "GET" }, r, e), o = {}, [4, B(i = {}, t)];
          case 1:
            return u.sent(), D(n, o), a = r && r.headers ? r.headers : {}, s.headers = w({}, i, a, e.headers), [2, { url: F(n), options: s }];
        }
      });
    })();
  } };
}, ra = function(t) {
  var e = eh(t);
  return { getShow: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getShow(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["ShowsApi.getShow"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listShows: function(n) {
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, e.listShows(n)];
          case 1:
            return i = c.sent(), a = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, u = (s = L["ShowsApi.listShows"]) === null || s === void 0 || (r = s[a]) === null || r === void 0 ? void 0 : r.url, [2, function(l, d) {
              return $(i, A, U, t)(l, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "getShow", value: function(n, r) {
    var s = this;
    return ra(this.configuration).getShow(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listShows", value: function(n) {
    var r = this;
    return ra(this.configuration).listShows(n).then(function(s) {
      return s(r.axios, r.basePath);
    });
  } }]), e;
})(nt);
var th = function(t) {
  return { createTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", N), t && (s = t.baseOptions), i = w({ method: "POST" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), o["Content-Type"] = "application/json", D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), i.data = Te(e, i, t), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, deleteTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("deleteTest", "id", e), r = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "DELETE" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, getTest: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return I("getTest", "id", e), r = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), s = new URL(r, N), t && (i = t.baseOptions), o = w({ method: "GET" }, i, n), u = {}, [4, B(a = {}, t)];
          case 1:
            return l.sent(), D(s, u), c = i && i.headers ? i.headers : {}, o.headers = w({}, a, c, n.headers), [2, { url: F(s), options: o }];
        }
      });
    })();
  }, listTests: function(e) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return x(function() {
      var r, s, i, o, a, u;
      return S(this, function(c) {
        switch (c.label) {
          case 0:
            return r = new URL("/test", N), t && (s = t.baseOptions), i = w({ method: "GET" }, s, n), a = {}, [4, B(o = {}, t)];
          case 1:
            return c.sent(), e !== void 0 && (a.showId = e), D(r, a), u = s && s.headers ? s.headers : {}, i.headers = w({}, o, u, n.headers), [2, { url: F(r), options: i }];
        }
      });
    })();
  }, updateTest: function(e, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return x(function() {
      var s, i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return I("updateTest", "id", e), s = "/test/{id}".replace("{id}", encodeURIComponent(String(e))), i = new URL(s, N), t && (o = t.baseOptions), a = w({ method: "PUT" }, o, r), c = {}, [4, B(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", D(i, c), l = o && o.headers ? o.headers : {}, a.headers = w({}, u, l, r.headers), a.data = Te(n, a, t), [2, { url: F(i), options: a }];
        }
      });
    })();
  } };
}, kn = function(t) {
  var e = th(t);
  return { createTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.createTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["TestsApi.createTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, deleteTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.deleteTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["TestsApi.deleteTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, getTest: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.getTest(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["TestsApi.getTest"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, listTests: function(n, r) {
    return x(function() {
      var s, i, o, a, u, c;
      return S(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, e.listTests(n, r)];
          case 1:
            return o = l.sent(), u = (a = t == null ? void 0 : t.serverIndex) !== null && a !== void 0 ? a : 0, c = (i = L["TestsApi.listTests"]) === null || i === void 0 || (s = i[u]) === null || s === void 0 ? void 0 : s.url, [2, function(d, f) {
              return $(o, A, U, t)(d, c || f);
            }];
        }
      });
    })();
  }, updateTest: function(n, r, s) {
    return x(function() {
      var i, o, a, u, c, l;
      return S(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, e.updateTest(n, r, s)];
          case 1:
            return a = d.sent(), c = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, l = (o = L["TestsApi.updateTest"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(f, h) {
              return $(a, A, U, t)(f, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function e() {
    return st(this, e), rt(this, e, arguments);
  }
  return ot(e, t), it(e, [{ key: "createTest", value: function(n, r) {
    var s = this;
    return kn(this.configuration).createTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "deleteTest", value: function(n, r) {
    var s = this;
    return kn(this.configuration).deleteTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "getTest", value: function(n, r) {
    var s = this;
    return kn(this.configuration).getTest(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "listTests", value: function(n, r) {
    var s = this;
    return kn(this.configuration).listTests(n, r).then(function(i) {
      return i(s.axios, s.basePath);
    });
  } }, { key: "updateTest", value: function(n, r, s) {
    var i = this;
    return kn(this.configuration).updateTest(n, r, s).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), e;
})(nt);
function nh(t, e) {
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
  }
}
function Pt(t, e, n) {
  return e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function sa(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {}, r = Object.keys(n);
    typeof Object.getOwnPropertySymbols == "function" && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function(s) {
      return Object.getOwnPropertyDescriptor(n, s).enumerable;
    }))), r.forEach(function(s) {
      Pt(t, s, n[s]);
    });
  }
  return t;
}
(function() {
  function t() {
    var r, s, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(a, u) {
      if (!(a instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), Pt(this, "apiKey", void 0), Pt(this, "username", void 0), Pt(this, "password", void 0), Pt(this, "accessToken", void 0), Pt(this, "basePath", void 0), Pt(this, "serverIndex", void 0), Pt(this, "baseOptions", void 0), Pt(this, "formDataCtor", void 0), this.apiKey = o.apiKey, this.username = o.username, this.password = o.password, this.accessToken = o.accessToken, this.basePath = o.basePath, this.serverIndex = o.serverIndex, this.baseOptions = (s = sa({}, o.baseOptions), i = (i = { headers: sa({}, (r = o.baseOptions) === null || r === void 0 ? void 0 : r.headers) }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(i)) : function(a) {
      var u = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols(a);
        u.push.apply(u, c);
      }
      return u;
    }(Object(i)).forEach(function(a) {
      Object.defineProperty(s, a, Object.getOwnPropertyDescriptor(i, a));
    }), s), this.formDataCtor = o.formDataCtor;
  }
  var e, n;
  return e = t, (n = [{ key: "isJsonMime", value: function(r) {
    var s = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (s.test(r) || r.toLowerCase() === "application/json-patch+json");
  } }]) && nh(e.prototype, n), t;
})();
const rh = {
  [Xt.PENDING]: { color: "default", label: "Scheduled" },
  [Xt.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [Xt.CONFIRMED]: { color: "success", label: "Confirmed" },
  [Xt.COMPLETED]: { color: "warning", label: "Scored" },
  [Xt.FINAL]: { color: "success", label: "Final" },
  [Xt.SCRATCHED]: { color: "error", label: "Scratched" }
}, sh = { color: "default", label: "—" };
function wp({ status: t, labels: e, size: n = "small", ...r }) {
  const s = rh[t] ?? sh, i = (e == null ? void 0 : e[t]) ?? s.label;
  return /* @__PURE__ */ m.jsx(ma, { size: n, color: s.color, label: i, ...r });
}
function xp(t, e, { intervalMs: n, enabled: r = !0 } = {}) {
  const [s, i] = Z({}), [o, a] = Z(!1), [u, c] = Z(null), [l, d] = Z(null), f = Array.from(new Set((t ?? []).filter(Boolean))), h = f.join(","), v = Zt(e);
  v.current = e;
  const p = Zt(f);
  p.current = f;
  const _ = r && f.length > 0 && typeof e == "function", K = Bt(async () => {
    const T = p.current;
    if (!(!T.length || typeof v.current != "function")) {
      a(!0);
      try {
        const V = await v.current(T), M = {};
        for (const ie of V ?? []) M[ie.rideId] = ie.status;
        i(M), c(null), d(/* @__PURE__ */ new Date());
      } catch (V) {
        c(V);
      } finally {
        a(!1);
      }
    }
  }, []);
  return ke(() => {
    if (!f.length) {
      i({});
      return;
    }
    if (!_)
      return;
    if (!n) {
      K();
      return;
    }
    document.visibilityState !== "hidden" && K();
    let T = null;
    const V = () => {
      document.visibilityState !== "hidden" && T == null && (T = setInterval(K, n));
    }, M = () => {
      T != null && (clearInterval(T), T = null);
    }, ie = () => {
      document.visibilityState === "hidden" ? M() : (K(), V());
    };
    return V(), document.addEventListener("visibilitychange", ie), () => {
      M(), document.removeEventListener("visibilitychange", ie);
    };
  }, [h, _, n, K]), { statuses: s, loading: o, error: u, refresh: K, lastUpdated: l };
}
function Sp({
  judgeName: t,
  url: e,
  loading: n = !1,
  label: r = "Judge signature",
  ...s
}) {
  return n ? /* @__PURE__ */ m.jsxs(Pr, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...s, children: [
    /* @__PURE__ */ m.jsx(kr, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ m.jsx(kr, { variant: "text", width: 140 })
  ] }) : e ? /* @__PURE__ */ m.jsxs(
    Pr,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...s,
      children: [
        /* @__PURE__ */ m.jsx(Bn, { variant: "caption", color: "text.secondary", children: r }),
        /* @__PURE__ */ m.jsx(
          Be,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ m.jsx(
              Be,
              {
                component: "img",
                src: e,
                alt: t || r,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        t && /* @__PURE__ */ m.jsx(
          Bn,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: t
          }
        )
      ]
    }
  ) : null;
}
function Rp(t, e, { enabled: n = !0 } = {}) {
  const [r, s] = Z(null), [i, o] = Z(!1), [a, u] = Z(null), c = Zt(e);
  c.current = e;
  const l = n && !!t && typeof e == "function";
  return ke(() => {
    if (!l) {
      s(null);
      return;
    }
    let d = !1;
    return o(!0), u(null), (async () => {
      try {
        const f = await c.current(t);
        d || s(f ?? null);
      } catch (f) {
        d || u(f);
      } finally {
        d || o(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [l, t]), { signature: r, loading: i, error: a };
}
function _p({ buildId: t, testId: e = "build-badge" }) {
  const n = t ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
  return n ? /* @__PURE__ */ m.jsx(
    de,
    {
      "data-testid": e,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: n
    }
  ) : null;
}
function Op({ testId: t = "usa-badge" }) {
  return /* @__PURE__ */ m.jsxs(
    de,
    {
      "data-testid": t,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 2,
        width: 80,
        // Above AppBar/NavRail (both 1300/1200 in common-fe), same layer as
        // BuildBadge so the pair reads as one unit; below modals/dialogs.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ m.jsx(
          de,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ m.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ m.jsx(
          de,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
const ih = "5432";
function Ep({
  pin: t = ih,
  onUnlock: e,
  testId: n = "pin-lock",
  ariaLabel: r = "Unlock"
}) {
  const [s, i] = Z(!1), [o, a] = Z(""), [u, c] = Z(!1), l = Zt(null);
  return ke(() => {
    s || (a(""), c(!1));
  }, [s]), ke(() => {
    if (!s || o.length !== t.length) return;
    const d = setTimeout(() => {
      o === t ? (i(!1), e == null || e()) : (c(!0), setTimeout(() => {
        var f;
        a(""), c(!1), (f = l.current) == null || f.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(d);
  }, [o, s, t, e]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      jr,
      {
        onClick: () => i(!0),
        "aria-label": r,
        "data-testid": n,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: /* @__PURE__ */ m.jsx(Tc, { sx: { fontSize: 20 } })
      }
    ),
    /* @__PURE__ */ m.jsxs(
      cr,
      {
        open: s,
        onClose: () => i(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ m.jsx(lr, { children: /* @__PURE__ */ m.jsx(de, { sx: { pt: 1 }, children: /* @__PURE__ */ m.jsx(
            Fn,
            {
              inputRef: l,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: o,
              onChange: (d) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                a(
                  d.target.value.replace(/\D/g, "").slice(0, t.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: t.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: u,
              helperText: u ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ m.jsx(Ts, { children: /* @__PURE__ */ m.jsx(Ze, { color: "inherit", onClick: () => i(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
function Tp(t, e, n = [], r = !0) {
  const [s, i] = Z({ data: null, loading: !0, error: null }), [o, a] = Z(!1), [u, c] = Z(0);
  ke(() => {
    let d = !1;
    return (async () => {
      let f;
      try {
        f = await t();
      } catch {
        f = void 0;
      }
      const h = f != null;
      if (!d && h && i({ data: f, loading: !1, error: null }), r)
        try {
          const v = await e();
          d || i({ data: v, loading: !1, error: null });
        } catch (v) {
          !d && !h && i({ data: null, loading: !1, error: v });
        } finally {
          d || a(!1);
        }
      else
        !d && !h && i({ data: null, loading: !1, error: null }), d || a(!1);
    })(), () => {
      d = !0;
    };
  }, [...n, r, u]);
  const l = Bt(() => {
    a(!0), c((d) => d + 1);
  }, []);
  return { ...s, refetch: l, refreshing: o };
}
function Cp(t, e = []) {
  const [n, r] = Z({ data: null, loading: !0, error: null });
  return ke(() => {
    let s = !1;
    return r({ data: null, loading: !0, error: null }), t().then((i) => {
      s || r({ data: i, loading: !1, error: null });
    }).catch((i) => {
      s || r({ data: null, loading: !1, error: i });
    }), () => {
      s = !0;
    };
  }, e), n;
}
function oh({ clientId: t, cognitoDomain: e, logoutUri: n }) {
  if (t && e && n) {
    const r = `https://${e}/logout?client_id=${t}&logout_uri=${encodeURIComponent(n)}`;
    window.location.replace(r);
  }
}
function jp() {
  const { mode: t, setMode: e } = la();
  return { mode: t, toggleTheme: () => {
    e(t === "dark" ? "light" : "dark");
  } };
}
function kp({ t, mode: e, toggleTheme: n, navigate: r, cognitoConfig: s, settingsLink: i = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ m.jsx(da, {}),
      text: t("navigation.homeLink"),
      onClick: () => r("/")
    },
    {
      icon: /* @__PURE__ */ m.jsx(fa, {}),
      text: t("navigation.settingsLink"),
      onClick: () => window.location.href = i
    },
    {
      icon: e === "dark" ? /* @__PURE__ */ m.jsx(va, { fontSize: "small" }) : /* @__PURE__ */ m.jsx(ga, { fontSize: "small" }),
      text: t(e === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: n
    },
    {
      icon: /* @__PURE__ */ m.jsx(ya, {}),
      text: t("navigation.logoutLink"),
      onClick: () => oh(s)
    }
  ];
}
const ah = "Server Error";
let ia = !1;
function Pp(t = Cc) {
  ia || (ia = !0, t.interceptors.response.use(
    (e) => e,
    (e) => {
      var s, i, o;
      const n = (s = e == null ? void 0 : e.response) == null ? void 0 : s.data, r = ((i = n == null ? void 0 : n.data) == null ? void 0 : i.message) || (n == null ? void 0 : n.message) || (n == null ? void 0 : n.error) || (n == null ? void 0 : n.code) || (e == null ? void 0 : e.message);
      return console.error("[api error]", (o = e == null ? void 0 : e.response) == null ? void 0 : o.status, r, n), e && (e.serverErrorDetail = r, e.message = ah), Promise.reject(e);
    }
  ));
}
export {
  Pc as AccountMenu,
  up as ActiveOrgProvider,
  cp as ActiveShowProvider,
  Uc as AppBar,
  Wh as AppFooter,
  Jh as AppLayout,
  _p as BuildBadge,
  Gh as CallbackPage,
  Kh as CognitoAuthProvider,
  Yh as ConfirmButton,
  dr as FullScreenLoader,
  hp as GateHeader,
  ap as ItemCard,
  Qh as LoggedOutPage,
  ep as LogoutPage,
  Nc as MainContent,
  pp as MockAuthProvider,
  gp as MockLoginPage,
  mp as MockProtectedRoute,
  tp as MuiThemeProvider,
  np as NavRail,
  op as NewItemCard,
  sl as OrgSwitcher,
  sp as PageLayout,
  dp as PermissionProvider,
  Ep as PinLock,
  rp as ProtectedRoute,
  rh as RIDE_STATUS_DISPLAY,
  fd as ReportList,
  gd as ReportParamsForm,
  _d as ReportViewer,
  bp as Reports,
  wp as RideStatusBadge,
  Sd as RunHistory,
  ah as SERVER_ERROR_MESSAGE,
  lp as ShowSwitcher,
  Sp as SignatureBox,
  ip as StyledBreadcrumb,
  Xh as TableSkeleton,
  ih as UNLOCK_PIN,
  Op as UsaBadge,
  rl as UserDisplayName,
  Vh as beginSignOut,
  kp as getDefaultAccountMenuItems,
  Pp as installServerErrorInterceptor,
  $c as isSigningOut,
  oh as logoutCognito,
  an as unwrapReport,
  Qs as useActiveOrg,
  Qc as useActiveShow,
  ud as useApiConfig,
  Cp as useApiResource,
  Tp as useCachedResource,
  Ta as useMockAuth,
  fp as usePermission,
  cd as useReportApi,
  xp as useRideStatuses,
  Rp as useSheetSignature,
  jp as useThemeSwitcher
};
//# sourceMappingURL=common-fe.js.map
